const data = {
    list : [
        {
            "id": "1",
            "kanji": "発表",
            "n_read": "はっぴょう",
            "kango_easy": "知らせる",
            "e_read": "しらせる",
            "word_meaning": "นำเสนอ หรือประกาศ แจ้งให้รับรู้เป็นวงกว้าง เช่น ประกาศรายชื่อผู้ผ่านการทดสอบ นำเสนอหัวข้อรายงาน เป็นต้น",
            "word_usage": "คำนาม + を  + 発表 + する",
            "word_ex": "結果を発表する。"
        },
        {
            "id": "2",
            "kanji": "確認",
            "n_read": "かくにん",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "ตรวจสอบ ยืนยันให้แน่นอน ทำให้แน่ใจ เช่น ยืนยันความคิดเห็นของอีกฝ่าย, ตรวจสอบความปลอดภัย เป็นต้น ",
            "word_usage": "คำนาม + を  + 確認 + する",
            "word_ex": "相手の意思を確認する。"
        },
        {
            "id": "3",
            "kanji": "死亡",
            "n_read": "しぼう",
            "kango_easy": "死ぬ",
            "e_read": "しぬ",
            "word_meaning": "เสียชีวิต",
            "word_usage": "เวลา +  に + 死亡 + する\r\nสาเหตุ + で +  死亡 + する",
            "word_ex": " 彼は10月1日午前3時に死亡した。\r\n 毎年交通事故で多くの人が死亡する。"
        },
        {
            "id": "4",
            "kanji": "死亡",
            "n_read": "しぼう",
            "kango_easy": "亡くなる",
            "e_read": "なくなる",
            "word_meaning": "เสียชีวิต",
            "word_usage": "เวลา +  に + 死亡 + する\r\nสาเหตุ + で +  死亡 + する",
            "word_ex": " 彼は10月1日午前3時に死亡した。\r\n 毎年交通事故で多くの人が死亡する。"
        },
        {
            "id": "5",
            "kanji": "強調",
            "n_read": "きょうちょう",
            "kango_easy": "強くする",
            "e_read": "つよくする",
            "word_meaning": "เน้นย้ำในส่วนสำคัญ หรือจุดยืนความคิดเห็น เช่น อาจารย์เน้นย้ำเริ่องความซื่อสัตย์ เป็นต้น",
            "word_usage": "คำนาม + を + 強調 +する",
            "word_ex": "彼は時間厳守を強調した。"
        },
        {
            "id": "6",
            "kanji": "指摘",
            "n_read": "してき",
            "kango_easy": "示す",
            "e_read": "しめす",
            "word_meaning": "ชี้ให้เห็น เช่น ชี้ให้เห็นถึงข้อบกพร่อง ",
            "word_usage": "คำนาม + を + 指摘 + する",
            "word_ex": "欠点を指摘する。"
        },
        {
            "id": "7",
            "kanji": "指摘",
            "n_read": "してき",
            "kango_easy": "指す",
            "e_read": "さす",
            "word_meaning": "ชี้ให้เห็น เช่น ชี้ให้เห็นถึงข้อบกพร่อง ",
            "word_usage": "คำนาม + を + 指摘 + する",
            "word_ex": "欠点を指摘する。"
        },
        {
            "id": "8",
            "kanji": "参加",
            "n_read": "さんか",
            "kango_easy": "出席",
            "e_read": "しゅっせき",
            "word_meaning": "เข้าร่วม เป็นส่วนหนึ่งของกลุ่มหรือการรวมตัวกันโดยมีจุดประสงค์ร่วมกัน ทำสิ่งใดสิ่งหนึ่งร่วมกัน เช่น เข้าร่วมกิจกรรม เข้าร่วมกลุ่มอนุรักษ์สัตว์ เป็นต้น",
            "word_usage": "คำนาม + に + 参加 + する",
            "word_ex": "クラブ活動に積極的に参加する。"
        },
        {
            "id": "9",
            "kanji": "強化",
            "n_read": "きょうか",
            "kango_easy": "強くする",
            "e_read": "つよくする",
            "word_meaning": "ทำให้แข็งแกร่งขึ้น ทำให้เข้มแข็งขึ้น หรือทำสิ่งที่ทำอยู่แล้วให้มากขึ้นไปอีก เช่น เพิ่มความแข็งแกร่งให้กับกำลังรบ เพิ่มความเข้มงวดในการตรวจสอบ เป็นต้น",
            "word_usage": "คำนาม + を + 強化 + する",
            "word_ex": "戦力を強化する。"
        },
        {
            "id": "10",
            "kanji": "感染",
            "n_read": "かんせん",
            "kango_easy": "",
            "e_read": "うつる",
            "word_meaning": "ติดเชื้อ, ติดต่อ ใช้กับการติดโรค เช่น ติดหวัด เป็นต้น",
            "word_usage": "คำนาม(โรค) + に + 感染 + する",
            "word_ex": " この病気は感染します。"
        },
        {
            "id": "11",
            "kanji": "注目",
            "n_read": "ちゅうもく",
            "kango_easy": "向ける",
            "e_read": "むける",
            "word_meaning": "ให้ความสนใจ จดจ่อ มีสมาธิกับสิ่งที่อยู่ตรงหน้า เช่น จดจ่อกับกระดานดำ",
            "word_usage": "คำนาม + に + 注目 + する",
            "word_ex": "黒板に注目する。"
        },
        {
            "id": "12",
            "kanji": "注目",
            "n_read": "ちゅうもく",
            "kango_easy": "気になる",
            "e_read": "きになる",
            "word_meaning": "ให้ความสนใจ จดจ่อ มีสมาธิกับสิ่งที่อยู่ตรงหน้า เช่น จดจ่อกับกระดานดำ",
            "word_usage": "คำนาม + に + 注目 + する",
            "word_ex": "黒板に注目する。"
        },
        {
            "id": "13",
            "kanji": "拡大",
            "n_read": "かくだい",
            "kango_easy": "広げる",
            "e_read": "ひろげる",
            "word_meaning": "ขยายรูปร่าง ขนาด หรือสัดส่วนให้ใหญ่ขึ้น เช่น ขยายภาพ หรือหมายถึงขยายเป็นวงกว้าง เช่น สงคราม ความร่วมมือ เป็นต้น",
            "word_usage": "คำนาม + を + 拡大 + する",
            "word_ex": "写真を拡大する。"
        },
        {
            "id": "14",
            "kanji": "拡大",
            "n_read": "かくだい",
            "kango_easy": "広がる",
            "e_read": "ひろがる",
            "word_meaning": "ขยายรูปร่าง ขนาด หรือสัดส่วนให้ใหญ่ขึ้น เช่น ขยายภาพ หรือหมายถึงขยายเป็นวงกว้าง เช่น สงคราม ความร่วมมือ เป็นต้น",
            "word_usage": "คำนาม + を + 拡大 + する",
            "word_ex": "写真を拡大する。"
        },
        {
            "id": "15",
            "kanji": "主張",
            "n_read": "しゅちょう",
            "kango_easy": "言い張る",
            "e_read": "いいはる",
            "word_meaning": "ยืนยัน ยืนกรานกับความคิดของตัวเอง",
            "word_usage": "คำนาม + を + 主張 + する",
            "word_ex": "無罪を主張する。"
        },
        {
            "id": "16",
            "kanji": "会談",
            "n_read": "かいだん",
            "kango_easy": "話し合う",
            "e_read": "はなしあう",
            "word_meaning": "ประชุม หรือพบปะเจรจาพุดคุย ใช้กับการประชุม การเจรจาที่มีการประกาศให้สาธารณชนรับรู้ เช่น การประชุมระหว่างอเมริกา-ญี่ปุ่น ",
            "word_usage": "ฝ่ายตรงข้าม + と + 会談 + する\r\nคำนาม +が + 会談 + する",
            "word_ex": "両国の王が会談する。\r\nタイは日本と会談する。"
        },
        {
            "id": "17",
            "kanji": "批判",
            "n_read": "ひはん",
            "kango_easy": "評する",
            "e_read": "ひょうする",
            "word_meaning": "วิพากย์วิจารณ์ แฝงการประเมินว่าดีหรือไม่ดี ",
            "word_usage": "คำนาม + を + 批判 + する",
            "word_ex": "政府の対策について多く批判している。"
        },
        {
            "id": "18",
            "kanji": "懸念",
            "n_read": "けねん",
            "kango_easy": "心配する",
            "e_read": "しんぱいする",
            "word_meaning": "กังวล วิตก เช่น กังวลเก่ียวกับสถาณการณ์บ้านเมืองต่อจากนี้",
            "word_usage": "คำนาม + を + 懸念 + する",
            "word_ex": "姉の病気を懸念する。"
        },
        {
            "id": "19",
            "kanji": "表明",
            "n_read": "ひょうめい",
            "kango_easy": "表す",
            "e_read": "あらわす",
            "word_meaning": "แสดงออกทางความคิดเห็นและท่าทีอย่างชัดเจน เช่น แสดงท่าทีต่อต้าน เป็นต้น",
            "word_usage": "คำนาม + を + 表明 + する",
            "word_ex": "その提案に反対を表明する。"
        },
        {
            "id": "20",
            "kanji": "支援",
            "n_read": "しえん",
            "kango_easy": "支える",
            "e_read": "ささえる",
            "word_meaning": "ช่วยเหลือ สนับสนุนผู้อื่น (ในด้านการเงิน ความพยายาม)\r\n",
            "word_usage": "คำนาม + を + 支援 + する",
            "word_ex": "友人の事業を支援する。"
        },
        {
            "id": "21",
            "kanji": "支援",
            "n_read": "しえん",
            "kango_easy": "手伝う",
            "e_read": "てつだう",
            "word_meaning": "ช่วยเหลือ สนับสนุนผู้อื่น (ในด้านการเงิน ความพยายาม)\r\n",
            "word_usage": "คำนาม + を + 支援 + する",
            "word_ex": "友人の事業を支援する。"
        },
        {
            "id": "22",
            "kanji": "説明",
            "n_read": "せつめい",
            "kango_easy": "教える",
            "e_read": "おしえる",
            "word_meaning": "อธิบายเรื่องที่รู้และเช้าใจเป็นอย่างดี สอนเรื่องที่อีกฝ่ายยังไม่รู้ เช่น อธิบายวิธีใช้เตาอบ เป้นต้น",
            "word_usage": "คำนาม + を + 説明 + する",
            "word_ex": "スマホの使い方を説明する。"
        },
        {
            "id": "23",
            "kanji": "検討",
            "n_read": "けんとう",
            "kango_easy": "考える",
            "e_read": "かんがえる",
            "word_meaning": "คิดพิจารณาว่าดีหรือไม่ดี ตรวจสอบโดยละเอียด เช่นการพิจารณาร่างรัฐธรรมนูญ",
            "word_usage": "คำนาม + を + 検討 + する",
            "word_ex": "弁護士はその事件を検討した。"
        },
        {
            "id": "24",
            "kanji": "検討",
            "n_read": "けんとう",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "คิดพิจารณาว่าดีหรือไม่ดี ตรวจสอบโดยละเอียด เช่นการพิจารณาร่างรัฐธรรมนูญ",
            "word_usage": "คำนาม + を + 検討 + する",
            "word_ex": "弁護士はその事件を検討した。"
        },
        {
            "id": "25",
            "kanji": "非難",
            "n_read": "ひなん",
            "kango_easy": "責める",
            "e_read": "せめる",
            "word_meaning": "ยกข้อด้อย ข้อผิดพลาดของผู้อื่นมาตำหนิ เช่น นายกรัฐมนตรีถูกตำหนิเพราะมาตรการรับมือภัยแล้งไม่ได้เรื่อง",
            "word_usage": "คำนาม + を + 非難 + する",
            "word_ex": "彼は、失敗した部下を激しく非難した。"
        },
        {
            "id": "26",
            "kanji": "禁止",
            "n_read": "きんし",
            "kango_easy": "止める",
            "e_read": "やめる",
            "word_meaning": "ห้าม สั่งห้าม เช่น ห้ามเข้าสนามหญ้า ห้ามถ่ายรูป เป็นต้น",
            "word_usage": "คำนาม + を + 禁止 + する",
            "word_ex": "授業中に電話するのを禁止します。"
        },
        {
            "id": "27",
            "kanji": "派遣",
            "n_read": "はけん",
            "kango_easy": "送る",
            "e_read": "おくる",
            "word_meaning": "การถูกส่งไปประจำที่อื่น ด้วยงานที่รับผิดชอบ เช่น ส่งพนักงานไปประจำการที่ญี่ปุ่น",
            "word_usage": "คำนาม + を + 派遣 + する",
            "word_ex": "大使を海外に派遣する。"
        },
        {
            "id": "28",
            "kanji": "支持",
            "n_read": "しじ",
            "kango_easy": "支える",
            "e_read": "ささえる",
            "word_meaning": "การเห็นด้วยกับความคิด, ความคิดเห็น, การกระทำของผู้อื่น แล้วให้การสนับสนุน หรือการช่วยเหลือ เช่น การสนับสนุนทางการเมือง ขอความสนับสนุน ฐานอำนาจ (ทางการเมือง)",
            "word_usage": "คำนาม + を + 支持 + する",
            "word_ex": "彼の計画を支持する。"
        },
        {
            "id": "29",
            "kanji": "合意",
            "n_read": "ごうい",
            "kango_easy": "賛成する",
            "e_read": "さんせいする",
            "word_meaning": "ตกลง เห็นด้วย ความเห็นของคนตั้งแต่ 2 คนขึ้นไปตรงกัน เช่น เห็นด้วยกับความคิดเห็น ",
            "word_usage": "คำนาม + に + 合意 + する",
            "word_ex": "私はそれに合意します。"
        },
        {
            "id": "30",
            "kanji": "到着",
            "n_read": "とうちゃく",
            "kango_easy": "着く",
            "e_read": "つく",
            "word_meaning": "ถึง ไปยังจุดมุ่งหมาย เช่น ถึงญี่ปุ่นแล้ว เป็นต้น",
            "word_usage": "สถานที่ + に + 到着 + する",
            "word_ex": "列車は午後1時に駅に到着します。"
        },
        {
            "id": "31",
            "kanji": "帰国",
            "n_read": "きこく",
            "kango_easy": "帰る",
            "e_read": "かえる",
            "word_meaning": "กลับ ใช้ในกรณีที่ไปต่างประเทศและกลับมาประเทศตัวเอง เช่น ไปอยู่ญี่ปุ่นมา วันนี้ได้กลับไทยแล้ว เป็นต้น",
            "word_usage": "สถานที่ + に + 帰国 + する",
            "word_ex": "彼らは日本に帰国した。"
        },
        {
            "id": "32",
            "kanji": "投稿",
            "n_read": "とうこう",
            "kango_easy": "載せる",
            "e_read": "のせる",
            "word_meaning": "การส่งบทความลงหนังสือพิมพ์ หรือการโพสต์ข้อความ วิดีโอลงสื่อสาธารณะ เช่น เขาเขียนบทความลงหนังสือพิมพ์บ่อย เขาโพสต์รูปตัวเองลงทวิตเตอร์ เป็นต้น",
            "word_usage": "คำนาม + を + 投稿 + する",
            "word_ex": "彼はその新聞によく投稿する。"
        },
        {
            "id": "33",
            "kanji": "協力",
            "n_read": "きょうりょく",
            "kango_easy": "一緒にやる",
            "e_read": "いっしょにやる",
            "word_meaning": "ให้ความร่วมมือโดยมีจุดมุ่งหมายเดียวกัน",
            "word_usage": "คำนาม + に + 協力 + する",
            "word_ex": "事業に協力する。"
        },
        {
            "id": "34",
            "kanji": "一致",
            "n_read": "いっち",
            "kango_easy": "合う",
            "e_read": "あう",
            "word_meaning": "ตรงกัน เห็นพ้องต้องกัน",
            "word_usage": "คำนาม + が + 一致 + する",
            "word_ex": "彼とあらゆる点で意見が一致している。"
        },
        {
            "id": "35",
            "kanji": "公開",
            "n_read": "こうかい",
            "kango_easy": "開く",
            "e_read": "ひらく",
            "word_meaning": "เปิดเผยต่อสาธารณชน เปิดตัว (อณุญาตให้เข้าถึงรับรู้สิ่งที่ปิดเอาไว้)",
            "word_usage": "คำนาม + を + 公開 + する",
            "word_ex": "その情報を公開します。"
        },
        {
            "id": "36",
            "kanji": "拘束",
            "n_read": "こうそく",
            "kango_easy": "縛る",
            "e_read": "しばる",
            "word_meaning": "จำกัด(อิสระ) ควบคุมตัว ผูกมัด(ด้วยสัญญา)",
            "word_usage": "คำนาม + を + 拘束 + する",
            "word_ex": "自由を拘束する。\r\n身柄を拘束する。"
        },
        {
            "id": "37",
            "kanji": "反発",
            "n_read": "はんぱつ",
            "kango_easy": "背く",
            "e_read": "そむく",
            "word_meaning": "โต้ตอบ กลับตัว(กราฟ) ไม่ทำตามอีกฝ่าย",
            "word_usage": "คำนาม + に + 反発 + する",
            "word_ex": "彼はその意見に反発している。\r\n古い慣習に反発する。"
        },
        {
            "id": "38",
            "kanji": "訪問",
            "n_read": "ほうもん",
            "kango_easy": "訪ねる",
            "e_read": "たずねる",
            "word_meaning": "เยี่ยมเยียน ไปเยือน ไปบ้านคนอื่น",
            "word_usage": "สถานที่ + に + 訪問 + する",
            "word_ex": "京都は毎年多くの観光客が訪問する。\r\n生徒の家庭を次々に訪問する。"
        },
        {
            "id": "39",
            "kanji": "訪問",
            "n_read": "ほうもん",
            "kango_easy": "行く",
            "e_read": "いく",
            "word_meaning": "เยี่ยมเยียน ไปเยือน ไปบ้านคนอื่น",
            "word_usage": "สถานที่ + に + 訪問 + する",
            "word_ex": "京都は毎年多くの観光客が訪問する。\r\n生徒の家庭を次々に訪問する。"
        },
        {
            "id": "40",
            "kanji": "予想",
            "n_read": "よそう",
            "kango_easy": "考える",
            "e_read": "かんがえる",
            "word_meaning": "คาดการณ์ คาดคะเน คิดเรื่องที่จะเกิดขึ้นต่อจากนี้",
            "word_usage": "ประโยค + と + 予想 + する",
            "word_ex": "彼は来週来ると予想している。"
        },
        {
            "id": "41",
            "kanji": "予想",
            "n_read": "よそう",
            "kango_easy": "測る",
            "e_read": "はかる",
            "word_meaning": "คาดการณ์ คาดคะเน คิดเรื่องที่จะเกิดขึ้นต่อจากนี้",
            "word_usage": "ประโยค + と + 予想 + する",
            "word_ex": "彼は来週来ると予想している。"
        },
        {
            "id": "42",
            "kanji": "協議",
            "n_read": "きょうぎ",
            "kango_easy": "話し合う",
            "e_read": "はなしあう",
            "word_meaning": "ประชุม หารือเพื่อตัดสินใจเรื่องบางอย่าง",
            "word_usage": "ฝ่ายตรงข้าม + と + 協議 + する",
            "word_ex": "日本はその問題についてアメリカ政府と協議した。"
        },
        {
            "id": "43",
            "kanji": "再開",
            "n_read": "さいかい",
            "kango_easy": "始まる",
            "e_read": "はじまる",
            "word_meaning": "เริ่มใหม่ เปิดใหม่อีกครั้ง ใช้กับสิ่งที่เคยหยุด ปิดไปแล้วกลับมาใหม่อีกครั้ง",
            "word_usage": "คำนาม + を + 再開 + する",
            "word_ex": "その翌日から工場は生産を再開した。"
        },
        {
            "id": "44",
            "kanji": "再開",
            "n_read": "さいかい",
            "kango_easy": "始める",
            "e_read": "はじめる",
            "word_meaning": "เริ่มใหม่ เปิดใหม่อีกครั้ง ใช้กับสิ่งที่เคยหยุด ปิดไปแล้วกลับมาใหม่อีกครั้ง",
            "word_usage": "คำนาม + を + 再開 + する",
            "word_ex": "その翌日から工場は生産を再開した。"
        },
        {
            "id": "45",
            "kanji": "公表",
            "n_read": "こうひょう",
            "kango_easy": "知らせる",
            "e_read": "しらせる",
            "word_meaning": "ประกาศแจ้งให้ทราบเป็นวงกว้าง",
            "word_usage": "คำนาม + を + 公表 + する",
            "word_ex": "意見を公表する。"
        },
        {
            "id": "46",
            "kanji": "公表",
            "n_read": "こうひょう",
            "kango_easy": "表する",
            "e_read": "ひょうする",
            "word_meaning": "ประกาศแจ้งให้ทราบเป็นวงกว้าง",
            "word_usage": "คำนาม + を + 公表 + する",
            "word_ex": "意見を公表する。"
        },
        {
            "id": "47",
            "kanji": "会見",
            "n_read": "かいけん",
            "kango_easy": "会う",
            "e_read": "あう",
            "word_meaning": "การพบปะอย่างเป็นทางการ มีการกำหนดสถานที่",
            "word_usage": "ฝ่ายตรงข้าม + と + 会見 + する",
            "word_ex": "大統領と会見した。"
        },
        {
            "id": "48",
            "kanji": "殺害",
            "n_read": "さつがい",
            "kango_easy": "殺す",
            "e_read": "ころす",
            "word_meaning": "ฆ่า ฆาตรกรรม",
            "word_usage": "กรรม + を + 殺害 + する\r\nประธาน + が + 殺害 + する",
            "word_ex": "彼は(ナイフで)彼女を殺害した。"
        },
        {
            "id": "49",
            "kanji": "停止",
            "n_read": "ていし",
            "kango_easy": "止める",
            "e_read": "とめる",
            "word_meaning": "หยุดชะงัก ยับยั้งชั่วคราว (กระทำการบางอย่างมาเรื่อย ๆ แล้วเกิดเหตุที่ทำให้ต้องหยุดการกระทำนั้น)",
            "word_usage": "คำนาม + が + 停止 + する",
            "word_ex": "送電が停止する。"
        },
        {
            "id": "50",
            "kanji": "維持",
            "n_read": "いじ",
            "kango_easy": "保つ",
            "e_read": "たもつ",
            "word_meaning": "บำรุง รักษาให้อยู่ในสภาพเดิม เช่น รักษาสุขภาพ รักษาความสัมพันธ์ เป็นต้น",
            "word_usage": "คำนาม + を + 維持 + する",
            "word_ex": "健康を維持する。\r\n友好関係を維持する。"
        },
        {
            "id": "51",
            "kanji": "維持",
            "n_read": "いじ",
            "kango_easy": "守る",
            "e_read": "まもる",
            "word_meaning": "บำรุง รักษาให้อยู่ในสภาพเดิม เช่น รักษาสุขภาพ รักษาความสัมพันธ์ เป็นต้น",
            "word_usage": "คำนาม + を + 維持 + する",
            "word_ex": "健康を維持する。\r\n友好関係を維持する。"
        },
        {
            "id": "52",
            "kanji": "期待",
            "n_read": "きたい",
            "kango_easy": "待つ",
            "e_read": "まつ",
            "word_meaning": "คาดหวัง (เฝ้ารอผลดีของเหตุการณ์ต่อจากนี้)",
            "word_usage": "ประโยค + を + 期待 + する",
            "word_ex": "その歌手はアンコールを3回受けることを期待していた。"
        },
        {
            "id": "53",
            "kanji": "期待",
            "n_read": "きたい",
            "kango_easy": "望む",
            "e_read": "のぞむ",
            "word_meaning": "คาดหวัง (เฝ้ารอผลดีของเหตุการณ์ต่อจากนี้)",
            "word_usage": "ประโยค + を + 期待 + する",
            "word_ex": "その歌手はアンコールを3回受けることを期待していた。"
        },
        {
            "id": "54",
            "kanji": "期待",
            "n_read": "きたい",
            "kango_easy": "楽しみ",
            "e_read": "たのしみ",
            "word_meaning": "คาดหวัง (เฝ้ารอผลดีของเหตุการณ์ต่อจากนี้)",
            "word_usage": "ประโยค + を + 期待 + する",
            "word_ex": "その歌手はアンコールを3回受けることを期待していた。"
        },
        {
            "id": "55",
            "kanji": "実現",
            "n_read": "じつげん",
            "kango_easy": "叶う",
            "e_read": "かなう",
            "word_meaning": "ทำให้เป็นจริง กลายเป็นจริง เช่น ความหวังกลายเป็นจริง แผนที่วางไว้กลายเป็นจริง เป็นต้น",
            "word_usage": "คำนาม + を + 実現 + する",
            "word_ex": "彼の希望は実現した。"
        },
        {
            "id": "56",
            "kanji": "発射",
            "n_read": "はっしゃ",
            "kango_easy": "撃つ",
            "e_read": "うつ",
            "word_meaning": "ยิง (กระสุน จรวด เป็นต้น)",
            "word_usage": "คำนาม + を + 発射 + する",
            "word_ex": "ライフルを彼に向けて発射する。\r\n月ロケットを発射する。"
        },
        {
            "id": "57",
            "kanji": "担当",
            "n_read": "たんとう",
            "kango_easy": "受ける",
            "e_read": "うける",
            "word_meaning": "\bรับผิดชอบ รับงาน",
            "word_usage": "คำนาม + を + 担当 + する",
            "word_ex": "営業を担当する。"
        },
        {
            "id": "58",
            "kanji": "開催",
            "n_read": "かいさい",
            "kango_easy": "開く",
            "e_read": "ひらく",
            "word_meaning": "เปิดงานแสดงขนาดใหญ่ จัดงานใหญ่อย่างเป็นทางการ",
            "word_usage": "คำนาม + を + 開催 + する\r\nสถานที่ + で + 開催 + する",
            "word_ex": "今年は日本でオリンピックを開催する。"
        },
        {
            "id": "59",
            "kanji": "評価",
            "n_read": "ひょうか",
            "kango_easy": "評する",
            "e_read": "ひょうする",
            "word_meaning": "ตัดสินคุณค่า ประเมินว่าดีหรือไม่ดี สวยหรือไม่สวย ใช้ได้กับการประเมินราคาเช่นกัน",
            "word_usage": "คำนาม + を + 評価 + する",
            "word_ex": "学生の能力を評価する。\r\nその家を4,000万円と評価する。"
        },
        {
            "id": "60",
            "kanji": "連携",
            "n_read": "れんけい",
            "kango_easy": "一緒にやる",
            "e_read": "いっしょにやる",
            "word_meaning": "ติดต่อร่วมมือ ทำบางอย่างร่มกันเพื่อจุดมุ่งหมายบางอย่าง",
            "word_usage": "ฝ่ายตรงข้าม + と + 連携 + する",
            "word_ex": "私は彼と連携しながら故障を直します。"
        },
        {
            "id": "61",
            "kanji": "離脱",
            "n_read": "りだつ",
            "kango_easy": "抜ける",
            "e_read": "ぬける",
            "word_meaning": "แยกตัวออกจากกลุ่ม พรรค เป็นต้น",
            "word_usage": "คำนาม + を + 離脱 + する",
            "word_ex": "政党を離脱する。"
        },
        {
            "id": "62",
            "kanji": "逮捕",
            "n_read": "たいほ",
            "kango_easy": "捕まえる",
            "e_read": "つかまえる",
            "word_meaning": "จับกุม (ผู้ต้องสงสัย คนร้าย)",
            "word_usage": "กรรม + を + 逮捕 + する",
            "word_ex": "泥棒を逮捕する。"
        },
        {
            "id": "63",
            "kanji": "対応",
            "n_read": "たいおう",
            "kango_easy": "応える",
            "e_read": "こたえる",
            "word_meaning": "ทำสิ่งใดสิ่งหนึ่งโดยรองรับหรือตอบสนองต่อสถานการณ์ หรือสนับสนุน",
            "word_usage": "คำนาม + に + 対応 + する",
            "word_ex": "この問題に対応する。"
        },
        {
            "id": "64",
            "kanji": "就任",
            "n_read": "しゅうにん",
            "kango_easy": "",
            "e_read": "なる",
            "word_meaning": "รับตำแหน่งงาน รับหน้าที่เป็น เช่น รับตำแหน่งนายก",
            "word_usage": "คำนาม + に + 就任 + する",
            "word_ex": "彼は1月20日に米国大統領に就任する。"
        },
        {
            "id": "65",
            "kanji": "就任",
            "n_read": "しゅうにん",
            "kango_easy": "（任務に）つく",
            "e_read": "（にんむに）つく",
            "word_meaning": "รับตำแหน่งงาน รับหน้าที่เป็น เช่น รับตำแหน่งนายก",
            "word_usage": "คำนาม + に + 就任 + する",
            "word_ex": "彼は1月20日に米国大統領に就任する。"
        },
        {
            "id": "66",
            "kanji": "実施",
            "n_read": "じっし",
            "kango_easy": "行う",
            "e_read": "おこなう",
            "word_meaning": "ปฏิบัติจริง(ตามแผนการที่วางไว้) หรือ บังคบใช้(กฎ กฎหมาย)",
            "word_usage": "คำนาม + を + 実施 + する",
            "word_ex": "試験を実施した。\r\n法律を実施する。"
        },
        {
            "id": "67",
            "kanji": "制限",
            "n_read": "せいげん",
            "kango_easy": "限る",
            "e_read": "かぎる",
            "word_meaning": "จำกัด กำหนดขอบเขต",
            "word_usage": "คำนาม + を + 制限 + する",
            "word_ex": "人の活動を制限する。"
        },
        {
            "id": "68",
            "kanji": "撮影",
            "n_read": "さつえい",
            "kango_easy": "撮る",
            "e_read": "とる",
            "word_meaning": "ถ่ายรูป (รูป หนัง)",
            "word_usage": "คำนาม + を + 撮影 + する",
            "word_ex": "その映画は一部パリで撮影された。\r\n彼女が泳いでいるところを撮影する。"
        },
        {
            "id": "69",
            "kanji": "反対",
            "n_read": "はんたい",
            "kango_easy": "反対する",
            "e_read": "はんたいする",
            "word_meaning": "ตรงกันข้าม (ทิศทาง คำพูด ความคิดเห็น) คัดค้าน ไม่เห็นด้วย",
            "word_usage": "คำนาม + に + 反対 + する",
            "word_ex": "彼は我々の計画に反対した。"
        },
        {
            "id": "70",
            "kanji": "発生",
            "n_read": "はっせい",
            "kango_easy": "起こる",
            "e_read": "おこる",
            "word_meaning": "เกิดขึ้น ทำให้เกิด",
            "word_usage": "คำนาม + を + 発生 + する\r\nคำนาม + が + 発生 + する",
            "word_ex": "熱を発生する。\r\n事件が発生する。"
        },
        {
            "id": "71",
            "kanji": "利用",
            "n_read": "りよう",
            "kango_easy": "使う",
            "e_read": "つかう",
            "word_meaning": "ใช้ (ใช้กับสิ่งท่ีเป็นประโยชน์ต่อตัวเอง ตัวเองได้รับผลดี)",
            "word_usage": "คำนาม + を + 利用 + する",
            "word_ex": "勉強するのに図書館を利用する。"
        },
        {
            "id": "72",
            "kanji": "提供",
            "n_read": "ていきょう",
            "kango_easy": "与える",
            "e_read": "あたえる",
            "word_meaning": "เสนอ (นำสิ่งที่ตัวเองมีให้คนอื่น) หรือเป็นผู้สนับสนุนรายการทีวีหรือวิทยุ",
            "word_usage": "คำนาม + を + 提供 + する",
            "word_ex": "サービスを提供する。"
        },
        {
            "id": "73",
            "kanji": "紹介",
            "n_read": "しょうかい",
            "kango_easy": "知らせる",
            "e_read": "しらせる",
            "word_meaning": "แนะนำ (คนที่ไม่รู้จักกัน) ประกาศสิ่งที่ไม่รู้ให้คนอื่นรับรู้",
            "word_usage": "คำนาม + を + 紹介 + する",
            "word_ex": "私の友達を紹介します。\r\n私は彼に良いお店を紹介する。"
        },
        {
            "id": "74",
            "kanji": "拒否",
            "n_read": "きょひ",
            "kango_easy": "断る",
            "e_read": "ことわる",
            "word_meaning": "ปฏิเสธ​ (ไม่รับข้อเสนอ) ไม่อนุมัติ",
            "word_usage": "คำนาม \b+ を + 拒否 + する",
            "word_ex": "上司は彼の提案を拒否した。"
        },
        {
            "id": "75",
            "kanji": "演説",
            "n_read": "えんぜつ",
            "kango_easy": "",
            "e_read": "スピーチ",
            "word_meaning": "ปราศรัย (พูดแสดงความเห็น จุดยืนต่อหน้าคนหมู่มาก)",
            "word_usage": "สถานที่ + で + 演説 + する\r\nบุคคล + は + 演説 + する",
            "word_ex": "会議で演説する。\r\n彼は演説していた。"
        },
        {
            "id": "76",
            "kanji": "分析",
            "n_read": "ぶんせき",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "วิเคราะห์",
            "word_usage": "คำนาม + を + 分析 + する",
            "word_ex": "花粉を分析する。"
        },
        {
            "id": "77",
            "kanji": "滞在",
            "n_read": "たいざい",
            "kango_easy": "",
            "e_read": "いる",
            "word_meaning": "พำนัก อาศัยอยู่ (พักอยู่ในสถานที่ที่ห่างจากครอบครัว)",
            "word_usage": "สถานที่ + に + 滞在 + する",
            "word_ex": "東京に滞在する。"
        },
        {
            "id": "78",
            "kanji": "延期",
            "n_read": "えんき",
            "kango_easy": "延びる",
            "e_read": "のびる",
            "word_meaning": "เลื่อน (เลื่อนวันจากกำหนดการเดิม)",
            "word_usage": "คำนาม + を + 延期 + する",
            "word_ex": "イベントを延期しました。"
        },
        {
            "id": "79",
            "kanji": "悪化",
            "n_read": "あっか",
            "kango_easy": "悪くなる",
            "e_read": "わるくなる",
            "word_meaning": "(สถานการณ์) เลวร้ายลง แย่ลง",
            "word_usage": "คำนาม + が\b/は + 悪化 + する",
            "word_ex": "病状が悪化する。"
        },
        {
            "id": "80",
            "kanji": "署名",
            "n_read": "しょめい",
            "kango_easy": "",
            "e_read": "サイン",
            "word_meaning": "\bลงชื่อ เซ็นชื่อ ประทับตรา",
            "word_usage": "คำนาม + に + 署名 + する",
            "word_ex": "手紙に署名する。"
        },
        {
            "id": "81",
            "kanji": "隔離",
            "n_read": "かくり",
            "kango_easy": "離れる",
            "e_read": "はなれる",
            "word_meaning": "แบ่งแยก (คนป่วย เชื้อชาติ) แยกไม่ให้ปะปนกัน",
            "word_usage": "คำนาม + を + 隔離 + する",
            "word_ex": "その患者を隔離しておく。"
        },
        {
            "id": "82",
            "kanji": "提出",
            "n_read": "ていしゅつ",
            "kango_easy": "出す",
            "e_read": "だす",
            "word_meaning": "ยื่น (ข้อเสนอ เอกสาร) ส่ง (รายงานเอกสาร)",
            "word_usage": "คำนาม + に + 提出 + する",
            "word_ex": "法案を議会に提出する。"
        },
        {
            "id": "83",
            "kanji": "判断",
            "n_read": "はんだん",
            "kango_easy": "決める",
            "e_read": "きめる",
            "word_meaning": "ตัดสิน (คิดทำความเช้าใจและตัดสินใจ) ลงความเห็น ดุลพินิจ",
            "word_usage": "คำนาม + を + 判断 + する",
            "word_ex": "夢を判断する。"
        },
        {
            "id": "84",
            "kanji": "対立",
            "n_read": "たいりつ",
            "kango_easy": "対する",
            "e_read": "たいする",
            "word_meaning": "เผชิญหน้า ( ของ 2 ฝ่ายที่มีความเห็นตรงกข้ามกัน) ",
            "word_usage": "คำนาม + が + 対立 + する",
            "word_ex": "私の会社では、部長と課長が対立しています。"
        },
        {
            "id": "85",
            "kanji": "確保",
            "n_read": "かくほ",
            "kango_easy": "保つ",
            "e_read": "たもつ",
            "word_meaning": "หามาให้ได้ รักษาไว้เป็นของตัวเอง",
            "word_usage": "คำนาม + を + 確保 + する",
            "word_ex": "彼女のために席を確保する。"
        },
        {
            "id": "86",
            "kanji": "宣言",
            "n_read": "せんげん",
            "kango_easy": "言う",
            "e_read": "いう",
            "word_meaning": "ประกาศ (ความคิด มาตรการ ขององค์กร หรือส่วนตัว)",
            "word_usage": "คำนาม + を + 宣言 + する",
            "word_ex": "彼はオリンピックの開会を宣言した。"
        },
        {
            "id": "87",
            "kanji": "出発",
            "n_read": "しゅっぱつ",
            "kango_easy": "出かける",
            "e_read": "でかける",
            "word_meaning": "ออกเดินทาง เริ่มต้น",
            "word_usage": "สถานที่ + を + 出発 + する\r\nเวลา + に + 出発 + する",
            "word_ex": "家を出発する。\r\n何時に出発しますか。"
        },
        {
            "id": "88",
            "kanji": "獲得",
            "n_read": "かくとく",
            "kango_easy": "得る",
            "e_read": "える",
            "word_meaning": "ได้รับ (หลังจากที่พยายาม เหนื่อยยากเพื่อให้ได้มา)",
            "word_usage": "คำนาม + を + 獲得 + する",
            "word_ex": " 金メダルを獲得する。"
        },
        {
            "id": "89",
            "kanji": "獲得",
            "n_read": "かくとく",
            "kango_easy": "受ける",
            "e_read": "うける",
            "word_meaning": "ได้รับ (หลังจากที่พยายาม เหนื่อยยากเพื่อให้ได้มา)",
            "word_usage": "คำนาม + を + 獲得 + する",
            "word_ex": " 金メダルを獲得する。"
        },
        {
            "id": "90",
            "kanji": "示唆",
            "n_read": "しさ",
            "kango_easy": "",
            "e_read": "ヒント",
            "word_meaning": "ชี้แนะ แนะนำ (ไม่ได้บอกตรง ๆ คล้าย ๆ บอกใบ้ ให้รู้ด้วยตัวเอง)",
            "word_usage": "คำนาม + を + 示唆 + する",
            "word_ex": "この結果はそのような可能性を示唆している。"
        },
        {
            "id": "91",
            "kanji": "対抗",
            "n_read": "たいこう",
            "kango_easy": "対する",
            "e_read": "たいする",
            "word_meaning": "แข่งขัน ประชันกัน",
            "word_usage": "คำนาม + に + 対抗 + する",
            "word_ex": "小さな商店は安売りでスーパーに対抗した。"
        },
        {
            "id": "92",
            "kanji": "対抗",
            "n_read": "たいこう",
            "kango_easy": "試合する",
            "e_read": "しあいする",
            "word_meaning": "แข่งขัน ประชันกัน",
            "word_usage": "คำนาม + に + 対抗 + する",
            "word_ex": "小さな商店は安売りでスーパーに対抗した。"
        },
        {
            "id": "93",
            "kanji": "展開",
            "n_read": "てんかい",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "ดำเนินไปต่อ (ดำเนินเรื่อง)",
            "word_usage": "คำนาม + を + 展開 + する",
            "word_ex": "理論を展開する。"
        },
        {
            "id": "94",
            "kanji": "展開",
            "n_read": "てんかい",
            "kango_easy": "進める",
            "e_read": "すすめる",
            "word_meaning": "ดำเนินไปต่อ (ดำเนินเรื่อง)",
            "word_usage": "คำนาม + を + 展開 + する",
            "word_ex": "理論を展開する。"
        },
        {
            "id": "95",
            "kanji": "展開",
            "n_read": "てんかい",
            "kango_easy": "広げる",
            "e_read": "ひろげる",
            "word_meaning": "ดำเนินไปต่อ (ดำเนินเรื่อง)",
            "word_usage": "คำนาม + を + 展開 + する",
            "word_ex": "理論を展開する。"
        },
        {
            "id": "96",
            "kanji": "減少",
            "n_read": "げんしょう",
            "kango_easy": "減る",
            "e_read": "へる",
            "word_meaning": "ลดลง (จนเหลือน้อย)",
            "word_usage": "คำนาม + が + 減少 + する",
            "word_ex": "人口が減少する。"
        },
        {
            "id": "97",
            "kanji": "減少",
            "n_read": "げんしょう",
            "kango_easy": "減らす",
            "e_read": "へらす",
            "word_meaning": "ลดลง (จนเหลือน้อย)",
            "word_usage": "คำนาม + が + 減少 + する",
            "word_ex": "人口が減少する。"
        },
        {
            "id": "98",
            "kanji": "要請",
            "n_read": "ようせい",
            "kango_easy": "求める",
            "e_read": "もとめる",
            "word_meaning": "ร้องขอ ต้องการ (สิ่งที่จำเป็น)",
            "word_usage": "คำนาม + を + 要請 + する",
            "word_ex": "鈴木さんにリストの作成を要請しています。"
        },
        {
            "id": "99",
            "kanji": "言及",
            "n_read": "げんきゅう",
            "kango_easy": "言う",
            "e_read": "いう",
            "word_meaning": "พูดถึง กล่าวถึง เช่น กล่าวถึงปัญหาขาดแคลนน้ำ เป็นต้น",
            "word_usage": "คำนาม + に + 言及 + する",
            "word_ex": "彼は同僚の作品に言及した。"
        },
        {
            "id": "100",
            "kanji": "違反",
            "n_read": "いはん",
            "kango_easy": "守らない",
            "e_read": "まもらない",
            "word_meaning": "ฝ่าฝืน (ไม่ทำตามกฎ กฎหมาย ข้อตกลง สัญญา คำสั่ง)",
            "word_usage": "คำนาม + に + 違反 + する",
            "word_ex": "法律に違反する。"
        },
        {
            "id": "101",
            "kanji": "違反",
            "n_read": "いはん",
            "kango_easy": "破る",
            "e_read": "やぶる",
            "word_meaning": "ฝ่าฝืน (ไม่ทำตามกฎ กฎหมาย ข้อตกลง สัญญา คำสั่ง)",
            "word_usage": "คำนาม + に + 違反 + する",
            "word_ex": "法律に違反する。"
        },
        {
            "id": "102",
            "kanji": "議論",
            "n_read": "ぎろん",
            "kango_easy": "言う",
            "e_read": "いう",
            "word_meaning": "ถกเถียง ถกความเห็น (แต่ละคนพูดเรื่องที่ตัวเองคิดออกมา)",
            "word_usage": "คำนาม + を + 議論 + する",
            "word_ex": "私たちはこの件を議論する。"
        },
        {
            "id": "103",
            "kanji": "議論",
            "n_read": "ぎろん",
            "kango_easy": "言い合う",
            "e_read": "いいあう",
            "word_meaning": "ถกเถียง ถกความเห็น (แต่ละคนพูดเรื่องที่ตัวเองคิดออกมา)",
            "word_usage": "คำนาม + を + 議論 + する",
            "word_ex": "私たちはこの件を議論する。"
        },
        {
            "id": "104",
            "kanji": "関連",
            "n_read": "かんれん",
            "kango_easy": "関わる",
            "e_read": "かかわる",
            "word_meaning": "มีความเกี่ยวข้อง มีความเชื่อมโยง (ระหว่าง 2 สิ่ง)",
            "word_usage": "คำนาม + に + 関連 + する",
            "word_ex": "私はその事故に関連する本を読んだ。"
        },
        {
            "id": "105",
            "kanji": "否定",
            "n_read": "ひてい",
            "kango_easy": "断る",
            "e_read": "ことわる",
            "word_meaning": "ปฏิเสธ (ข่าวลือ ความคิดของคนอื่น)",
            "word_usage": "คำนาม + を + 否定 + する",
            "word_ex": "そのうわさをきっぱり否定する。"
        },
        {
            "id": "106",
            "kanji": "設置",
            "n_read": "せっち",
            "kango_easy": "設ける",
            "e_read": "もうける",
            "word_meaning": "ติดตั้ง ก่อตั้ง (โรงเรียน สภา คณะกรรมการ)",
            "word_usage": "คำนาม + を + 設置 + する",
            "word_ex": "エアコンを設置する。"
        },
        {
            "id": "107",
            "kanji": "設置",
            "n_read": "せっち",
            "kango_easy": "備える",
            "e_read": "そなえる",
            "word_meaning": "ติดตั้ง ก่อตั้ง (โรงเรียน สภา คณะกรรมการ)",
            "word_usage": "คำนาม + を + 設置 + する",
            "word_ex": "エアコンを設置する。"
        },
        {
            "id": "108",
            "kanji": "加速",
            "n_read": "かそく",
            "kango_easy": "速くする",
            "e_read": "はやくする",
            "word_meaning": "เพิ่มความเร็ว ทำให้เร็วขึ้น",
            "word_usage": "คำนาม + を + 加速 + する",
            "word_ex": "車を加速する。"
        },
        {
            "id": "109",
            "kanji": "出国",
            "n_read": "しゅっこく",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "ออกนอกประเทศ",
            "word_usage": "สถานที่ + を + 出国 + する",
            "word_ex": "私は中国を出国しなくてはならなかった。"
        },
        {
            "id": "110",
            "kanji": "駐留",
            "n_read": "ちゅうりゅう",
            "kango_easy": "",
            "e_read": "いる",
            "word_meaning": "ประจำการต่างถิ่น (ของทหาร)",
            "word_usage": "สถานที่ + に + 駐留 + する",
            "word_ex": "海外に駐留する英国軍人が使用する。"
        },
        {
            "id": "111",
            "kanji": "指示",
            "n_read": "しじ",
            "kango_easy": "示す",
            "e_read": "しめす",
            "word_meaning": "คำสั่ง ชี้แนะ (ให้ทำตาม)",
            "word_usage": "คำนาม + を + 指示 + する",
            "word_ex": "オペレータに監視を指示する。"
        },
        {
            "id": "112",
            "kanji": "指示",
            "n_read": "しじ",
            "kango_easy": "指す",
            "e_read": "さす",
            "word_meaning": "คำสั่ง ชี้แนะ (ให้ทำตาม)",
            "word_usage": "คำนาม + を + 指示 + する",
            "word_ex": "オペレータに監視を指示する。"
        },
        {
            "id": "113",
            "kanji": "歓迎",
            "n_read": "かんげい",
            "kango_easy": "迎える",
            "e_read": "むかえる",
            "word_meaning": "ต้อนรับ (ด้วยความยินดี\b)",
            "word_usage": "คำนาม + を + 歓迎 + する",
            "word_ex": "新入生を歓迎する。"
        },
        {
            "id": "114",
            "kanji": "抗議",
            "n_read": "こうぎ",
            "kango_easy": "反対",
            "e_read": "はんたい",
            "word_meaning": "คัดค้าน ประท้วง (ใช้กับการกระทำ ความเห็น การร้องเรียน)",
            "word_usage": "คำนาม + に + 抗議 + する",
            "word_ex": "性差別に抗議する。"
        },
        {
            "id": "115",
            "kanji": "注視",
            "n_read": "ちゅうし",
            "kango_easy": "見る",
            "e_read": "みる",
            "word_meaning": "จับตามอง พินิจ ",
            "word_usage": "คำนาม + を + 注視 + する",
            "word_ex": "状況を注視する。"
        },
        {
            "id": "116",
            "kanji": "起訴",
            "n_read": "きそ",
            "kango_easy": "訴える",
            "e_read": "うったえる",
            "word_meaning": "ส่งฟ้อง ฟ้องร้อง",
            "word_usage": "ข้อหา + で + 起訴 + する",
            "word_ex": "彼は殺人罪で起訴された。"
        },
        {
            "id": "117",
            "kanji": "起訴",
            "n_read": "きそ",
            "kango_easy": "教える",
            "e_read": "おしえる",
            "word_meaning": "ส่งฟ้อง ฟ้องร้อง",
            "word_usage": "ข้อหา + で + 起訴 + する",
            "word_ex": "彼は殺人罪で起訴された。"
        },
        {
            "id": "118",
            "kanji": "報告",
            "n_read": "ほうこく",
            "kango_easy": "知らせる",
            "e_read": "しらせる",
            "word_meaning": "รายงาน (วิจัย ผลการสำรวจ หรือผลของงานที่ได้รับมอบหมาย)",
            "word_usage": "คำนาม + を + 報告 + する",
            "word_ex": "その結果を報告します。"
        },
        {
            "id": "119",
            "kanji": "可決",
            "n_read": "かけつ",
            "kango_easy": "認める",
            "e_read": "みとめる",
            "word_meaning": "มีมติเห็นชอบ (ร่างต่าง ๆ ) ให้ผ่าน",
            "word_usage": "คำนาม + を + 可決 + する",
            "word_ex": "法案を可決する。"
        },
        {
            "id": "120",
            "kanji": "重視",
            "n_read": "じゅうし",
            "kango_easy": "大切",
            "e_read": "たいせつ",
            "word_meaning": "ให้ความสำคัญ",
            "word_usage": "คำนาม + を + 重視 + する",
            "word_ex": "その問題についての彼の意見を重視する。"
        },
        {
            "id": "121",
            "kanji": "避難",
            "n_read": "ひなん",
            "kango_easy": "避ける",
            "e_read": "さける",
            "word_meaning": "อพยพ (เวลาเกิดภัยพิบัติ)",
            "word_usage": "สถานที่ + に + 避難 + する",
            "word_ex": "安全な場所に避難する。"
        },
        {
            "id": "122",
            "kanji": "避難",
            "n_read": "ひなん",
            "kango_easy": "逃げる",
            "e_read": "にげる",
            "word_meaning": "อพยพ (เวลาเกิดภัยพิบัติ)",
            "word_usage": "สถานที่ + に + 避難 + する",
            "word_ex": "安全な場所に避難する。"
        },
        {
            "id": "123",
            "kanji": "建設",
            "n_read": "けんせつ",
            "kango_easy": "建てる",
            "e_read": "たてる",
            "word_meaning": "ก่อสร้าง (ตึก ถนน เขื่อน ประเทศ)",
            "word_usage": "คำนาม + を + 建設 + する",
            "word_ex": "新しい国家を建設する。"
        },
        {
            "id": "124",
            "kanji": "墜落",
            "n_read": "ついらく",
            "kango_easy": "落ちる",
            "e_read": "おちる",
            "word_meaning": "1) ความประพฤติแย่ลง ชีวิตออกนอกลู่นอกทาง ทำลายตัวเอง\r\n2) หล่นลงมาสู่ที่ต่ำ ตกอยู่ในสถานการณ์ที่ยากลำบาก\r\n3) ตก หล่น",
            "word_usage": "ประธาน​ + が + 堕落 + する\r\nคำนาม + を + 堕落 + させる",
            "word_ex": "\r\n酒がもとで彼は堕落した。\r\n俗悪番組は子供を堕落させる危険がある。"
        },
        {
            "id": "125",
            "kanji": "提案",
            "n_read": "ていあん",
            "kango_easy": "出す",
            "e_read": "だす",
            "word_meaning": "เสนอร่างรายงานการประชุม เสนอความคิด ",
            "word_usage": "คำนาม + を + 提案 + する",
            "word_ex": "具体策を提案する。"
        },
        {
            "id": "126",
            "kanji": "警告",
            "n_read": "けいこく",
            "kango_easy": "注意",
            "e_read": "ちゅうい",
            "word_meaning": "เตือนไว้ล่วงหน้า เพื่อไม่ให้สถานการณ์ยุ่งยากขึ้น หรือกลายเป็นปัญหา",
            "word_usage": "คน + に คำนาม + を + 警告 + する",
            "word_ex": "立て札で警告する。"
        },
        {
            "id": "127",
            "kanji": "主導",
            "n_read": "しゅどう",
            "kango_easy": "導く",
            "e_read": "みちびく",
            "word_meaning": "เป็นศูนย์กลาง และชี้นำ เช่น นำการประชุม",
            "word_usage": "คำนาม + を + 主導 + する",
            "word_ex": "会議を主導する。"
        },
        {
            "id": "128",
            "kanji": "採択",
            "n_read": "さいたく",
            "kango_easy": "選ぶ",
            "e_read": "えらぶ",
            "word_meaning": "เลือกสิ่งใดสิ่งหนึ่งมาจากสิ่งของ/ตัวเลือกจำนวนหนึ่ง เช่น เลือกญัตติ",
            "word_usage": "คำนาม + を + 採択 + する",
            "word_ex": "動議を採択する。"
        },
        {
            "id": "129",
            "kanji": "解決",
            "n_read": "かいけつ",
            "kango_easy": "解く",
            "e_read": "とく",
            "word_meaning": "แก้ไขเรื่องราวที่ที่ซับซ้อน คิดบทสรุปสำหรับปัญหา การที่เรื่องราว ข้อสงสัย หรือปัญหานั้น ๆ คลี่คลาย",
            "word_usage": "คำนาม + を + 解決 + する\r\nคำนาม + が + 解決 + する",
            "word_ex": "紛争を解決する。\r\n疑問が解決する。"
        },
        {
            "id": "130",
            "kanji": "解決",
            "n_read": "かいけつ",
            "kango_easy": "片付ける",
            "e_read": "かたづける",
            "word_meaning": "แก้ไขเรื่องราวที่ที่ซับซ้อน คิดบทสรุปสำหรับปัญหา การที่เรื่องราว ข้อสงสัย หรือปัญหานั้น ๆ คลี่คลาย",
            "word_usage": "คำนาม + を + 解決 + する\r\nคำนาม + が + 解決 + する",
            "word_ex": "紛争を解決する。\r\n疑問が解決する。"
        },
        {
            "id": "131",
            "kanji": "入国",
            "n_read": "にゅうこく",
            "kango_easy": "入る",
            "e_read": "はいる",
            "word_meaning": "การเข้าไปยังประเทศอื่น",
            "word_usage": "ชื่อประเทศ + に + 入国 + する",
            "word_ex": "アメリカに入国する。"
        },
        {
            "id": "132",
            "kanji": "更新",
            "n_read": "こうしん",
            "kango_easy": "新しくする",
            "e_read": "あたらしくする",
            "word_meaning": "1) เปลี่ยนให้เป็นสิ่งใหม่ ได้รับการปรับปรุงแก้ไข เช่น ปรับปรุงสถิติให้เป็นปัจจุบัน\r\n2) การต่อสัญญา เช่น สัญญาซื้อขาย เมื่อสัญญาเดิมหมดอายุ\r\n3) ในอุตสากรรมกรรมป่าไม้ หมายถึงการตัดต้นไม้ที่โตแล้วทิ้ง แล้วปลูกต้นใหม่ทดแทน",
            "word_usage": "คำนาม + を + 更新 + する",
            "word_ex": "記録を更新する。\r\n契約を更新する。"
        },
        {
            "id": "133",
            "kanji": "導入",
            "n_read": "どうにゅう",
            "kango_easy": "導く",
            "e_read": "みちびく",
            "word_meaning": "นำเข้ามา",
            "word_usage": "คำนาม + を + 導入+ する",
            "word_ex": "新型機器を導入する。"
        },
        {
            "id": "134",
            "kanji": "導入",
            "n_read": "どうにゅう",
            "kango_easy": "使い始める",
            "e_read": "つかいはじめる",
            "word_meaning": "นำเข้ามา",
            "word_usage": "คำนาม + を + 導入+ する",
            "word_ex": "新型機器を導入する。"
        },
        {
            "id": "135",
            "kanji": "受賞",
            "n_read": "じゅしょう",
            "kango_easy": "",
            "e_read": "もらう",
            "word_meaning": "รับรางวัล",
            "word_usage": "คำนาม + を + 受賞 + する",
            "word_ex": "ノーベル賞を受賞する。"
        },
        {
            "id": "136",
            "kanji": "披露",
            "n_read": "ひろう",
            "kango_easy": "見せる",
            "e_read": "みせる",
            "word_meaning": "1) แจ้งให้ผู้คนทราบอย่างกว้างขวาง ประกาศสู่สาธารณะ\r\n2) แจ้งเรื่องการแต่งงาน การเปิดปิดร้านให้ทราบอย่างกว้างขวาง หรืองานเลี้ยงเฉลิมฉลอง\r\n3) พูดความเห็น หรือแสดงให้ดู",
            "word_usage": "คน + に + คำนาม + を + 披露 + する",
            "word_ex": "昨晩の出来事を皆に披露する。"
        },
        {
            "id": "137",
            "kanji": "延長",
            "n_read": "えんちょう",
            "kango_easy": "延びる",
            "e_read": "のびる",
            "word_meaning": "ทำให้ความยาวยืดออกไป หรือขยายเวลาจากกำหนดการเดิม ส่วนต่อขยาย เช่น ขยายทางด่วน",
            "word_usage": "คำนาม + を + 延長 + する",
            "word_ex": "高速道路を延長する。\r\n国会の会期を延長する。"
        },
        {
            "id": "138",
            "kanji": "中止",
            "n_read": "ちゅうし",
            "kango_easy": "止める、やめる",
            "e_read": "とめる",
            "word_meaning": "หยุดบางสิ่งบางอย่างกลางคัน หรือยกเลิกแผนการที่เตรียมไว้ก่อนลงมือทำจริง",
            "word_usage": "คำนาม + を + 中止 + する",
            "word_ex": "会議を中止する。"
        },
        {
            "id": "139",
            "kanji": "中止",
            "n_read": "ちゅうし",
            "kango_easy": "",
            "e_read": "やめる",
            "word_meaning": "หยุดบางสิ่งบางอย่างกลางคัน หรือยกเลิกแผนการที่เตรียมไว้ก่อนลงมือทำจริง",
            "word_usage": "คำนาม + を + 中止 + する",
            "word_ex": "会議を中止する。"
        },
        {
            "id": "140",
            "kanji": "開発",
            "n_read": "かいはつ",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "1)ถางป่าหรือที่ว่างเพื่อใช้ประโยชน์ในการดำรงชีวิตของมนุษย์\r\n2)นำพลังงานธรรมชาติมาใช้งานในอุตสาหกรรม\r\n3)ดึงศักยภาพที่ซ้อนเร้นอยู่มาพัฒนา\r\n4)คิดสิ่งใหม่ ๆ เพื่อนำไปใช้จริง",
            "word_usage": "คำนาม + を + 開発 + する",
            "word_ex": "農地を開発する。\r\n新製品を開発する。\r\n能力を開発する。"
        },
        {
            "id": "141",
            "kanji": "開発",
            "n_read": "かいはつ",
            "kango_easy": "開く",
            "e_read": "ひらく",
            "word_meaning": "1)ถางป่าหรือที่ว่างเพื่อใช้ประโยชน์ในการดำรงชีวิตของมนุษย์\r\n2)นำพลังงานธรรมชาติมาใช้งานในอุตสาหกรรม\r\n3)ดึงศักยภาพที่ซ้อนเร้นอยู่มาพัฒนา\r\n4)คิดสิ่งใหม่ ๆ เพื่อนำไปใช้จริง",
            "word_usage": "คำนาม + を + 開発 + する",
            "word_ex": "農地を開発する。\r\n新製品を開発する。\r\n能力を開発する。"
        },
        {
            "id": "142",
            "kanji": "共有",
            "n_read": "きょうゆう",
            "kango_easy": "シェア",
            "e_read": "",
            "word_meaning": "การที่คนจำนวนหลายคนหรือกลุ่มเป็นเจ้าของของสิ่ง ๆ หนึ่งร่วมกัน",
            "word_usage": "คำนาม + を + 共有 + する",
            "word_ex": "秘密を共有する。"
        },
        {
            "id": "143",
            "kanji": "増加",
            "n_read": "ぞうか",
            "kango_easy": "増える",
            "e_read": "ふえる",
            "word_meaning": "จำนวนเพิ่มมากขึ้น เพิ่มจำนวน",
            "word_usage": "คำนาม + を + 増加 + する\r\nคำนาม + が + 増加 + する",
            "word_ex": "人口が増加する。\r\n広告予算を増加する。"
        },
        {
            "id": "144",
            "kanji": "上昇",
            "n_read": "じょうしょう",
            "kango_easy": "上がる",
            "e_read": "あがる",
            "word_meaning": "การมุ่งไปยังตำแหน่งที่สูงขึ้น หรือระดับที่สูงขึ้น การขึ้นไปข้างบน เช่น ค่าครองชีพสูงขึ้น",
            "word_usage": "คำนาม + を + 上昇 + する",
            "word_ex": "気温が上昇する。"
        },
        {
            "id": "145",
            "kanji": "上昇",
            "n_read": "じょうしょう",
            "kango_easy": "昇る",
            "e_read": "のぼる",
            "word_meaning": "การมุ่งไปยังตำแหน่งที่สูงขึ้น หรือระดับที่สูงขึ้น การขึ้นไปข้างบน เช่น ค่าครองชีพสูงขึ้น",
            "word_usage": "คำนาม + を + 上昇 + する",
            "word_ex": "気温が上昇する。"
        },
        {
            "id": "146",
            "kanji": "移動",
            "n_read": "いどう",
            "kango_easy": "移る",
            "e_read": "うつる",
            "word_meaning": "เปลี่ยนตำแหน่ง เคลื่อนที่ หรือทำให้เคลื่อนที่จากสถานที่หนึ่งไปยังอีกสถานที่หนึ่ง",
            "word_usage": "สถานที่ + に/へ + 移動 +する\r\nคำนาม + を + 移動 +する",
            "word_ex": "次の会場へ移動する。\r\n車両を移動する。 "
        },
        {
            "id": "147",
            "kanji": "移動",
            "n_read": "いどう",
            "kango_easy": "動く",
            "e_read": "うごく",
            "word_meaning": "เปลี่ยนตำแหน่ง เคลื่อนที่ หรือทำให้เคลื่อนที่จากสถานที่หนึ่งไปยังอีกสถานที่หนึ่ง",
            "word_usage": "สถานที่ + に/へ + 移動 +する\r\nคำนาม + を + 移動 +する",
            "word_ex": "次の会場へ移動する。\r\n車両を移動する。 "
        },
        {
            "id": "148",
            "kanji": "撃墜",
            "n_read": "げきつい",
            "kango_easy": "撃つ",
            "e_read": "うつ",
            "word_meaning": "โจมตีให้อากาศยานของฝ่ายศัตรูตกลงมา",
            "word_usage": "คำนาม + を + 撃墜 + する",
            "word_ex": "敵機を全機撃墜する。"
        },
        {
            "id": "149",
            "kanji": "記録",
            "n_read": "きろく",
            "kango_easy": "書く",
            "e_read": "かく",
            "word_meaning": "จดบันทึกสิ่งต่าง ๆ เพื่อให้เหลือไว้จนถึงอนาคต สิ่งที่บันทึกไว้",
            "word_usage": "คำนาม + を + 記録 + する",
            "word_ex": "名前を記録する。"
        },
        {
            "id": "150",
            "kanji": "撤退",
            "n_read": "てったい",
            "kango_easy": "逃げる",
            "e_read": "にげる",
            "word_meaning": "ถอนกำลังออกจากที่มั่นของกองกำลังทหาร เช่น ถอนกำลังออกจากแนวหน้า หรือใช้กับการถอนตัวขององค์กร เช่น ถอนตัวจากตลาดต่างประเทศ ถอนตัวจากอุตสาหกรรมผลิตรถยนต์",
            "word_usage": "คำนาม + から + 撤退 + する",
            "word_ex": "前線から撤退する。\r\nヨーロッパ市場から撤退する。"
        },
        {
            "id": "151",
            "kanji": "承認",
            "n_read": "しょうにん",
            "kango_easy": "認める",
            "e_read": "みとめる",
            "word_meaning": "1) ยอมรับว่าเรื่องราวนั้นเหมาะสมหรือเป็นความจริง เช่น อนุมัติสิทธิ์ในการเป็นเจ้าของ\r\n2) รับฟังสิ่งที่ผู้อื่นพูด เช่น ยอมรับว่าจะทำตามคำตัดสินของศาล\r\n3) ยอมรับสถานะ (เช่น สถานะของประเทศ รัฐบาล หรือกลุ่มประเทศที่จะเข้าร่วมสงคราม เป็นต้น)ในฐานะแกนหลักภายใต้กฎหมายระหว่างประเทศ เช่น ได้รับการยอมรับว่าเป็นประเทศพันธมิตร",
            "word_usage": "คำนาม + を + 承認 + する",
            "word_ex": "相手の所有権を承認する。\r\n裁定に従うことを双方が承認した。\r\n国連に承認された国。"
        },
        {
            "id": "152",
            "kanji": "承認",
            "n_read": "しょうにん",
            "kango_easy": "許す",
            "e_read": "ゆるす",
            "word_meaning": "1) ยอมรับว่าเรื่องราวนั้นเหมาะสมหรือเป็นความจริง เช่น อนุมัติสิทธิ์ในการเป็นเจ้าของ\r\n2) รับฟังสิ่งที่ผู้อื่นพูด เช่น ยอมรับว่าจะทำตามคำตัดสินของศาล\r\n3) ยอมรับสถานะ (เช่น สถานะของประเทศ รัฐบาล หรือกลุ่มประเทศที่จะเข้าร่วมสงคราม เป็นต้น)ในฐานะแกนหลักภายใต้กฎหมายระหว่างประเทศ เช่น ได้รับการยอมรับว่าเป็นประเทศพันธมิตร",
            "word_usage": "คำนาม + を + 承認 + する",
            "word_ex": "相手の所有権を承認する。\r\n裁定に従うことを双方が承認した。\r\n国連に承認された国。"
        },
        {
            "id": "153",
            "kanji": "発展",
            "n_read": "はってん",
            "kango_easy": "良くなる",
            "e_read": "よくなる",
            "word_meaning": "สิ่งต่าง ๆ เจริญเฟื่องฟู หรือพัฒนาไปยังจุดที่สูงขึ้น เช่น เศรษฐกิจพัฒนา",
            "word_usage": "คำนาม + が + 発展 + する",
            "word_ex": "経済が発展する。"
        },
        {
            "id": "154",
            "kanji": "発展",
            "n_read": "はってん",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "สิ่งต่าง ๆ เจริญเฟื่องฟู หรือพัฒนาไปยังจุดที่สูงขึ้น เช่น เศรษฐกิจพัฒนา",
            "word_usage": "คำนาม + が + 発展 + する",
            "word_ex": "経済が発展する。"
        },
        {
            "id": "155",
            "kanji": "攻撃",
            "n_read": "こうげき",
            "kango_easy": "攻める",
            "e_read": "せめる",
            "word_meaning": "1) โจมตีฝ่ายตรงข้ามในสงครามหรือการแข่งขันกีฬา\r\n2) วิจารณ์ฝ่ายตรงข้ามอย่างรุนแรง",
            "word_usage": "คำนาม + を + 攻撃 + する",
            "word_ex": "敵軍の背後を攻撃する。\r\n失政を攻撃する。"
        },
        {
            "id": "156",
            "kanji": "安定",
            "n_read": "あんてい",
            "kango_easy": "変わらない",
            "e_read": "かわらない",
            "word_meaning": "1) สภาพที่สงบ ไม่มีการเปลี่ยนแปลงอย่างต่อเนื่อง\r\n2) การทำให้เกิดความเปลี่ยนแปลงกับสภาวะสมดุล สภาพเดิมกับสภาพที่ถูกทำให้เปลี่ยนแปลงมีความแตกต่างกันเล็กน้อยมาก\r\n3) วัสดุหรือสสารที่ ไม่ถูกแยก ตอบสนอง หรือพังทลายโดยง่าย เช่น องค์ประกอบทางเคมีเสถียร",
            "word_usage": "ประธาน + が + 安定 + する",
            "word_ex": "物価が安定する。\r\nこの元素は安定している。"
        },
        {
            "id": "157",
            "kanji": "安定",
            "n_read": "あんてい",
            "kango_easy": "落ち着く",
            "e_read": "おちつく",
            "word_meaning": "1) สภาพที่สงบ ไม่มีการเปลี่ยนแปลงอย่างต่อเนื่อง\r\n2) การทำให้เกิดความเปลี่ยนแปลงกับสภาวะสมดุล สภาพเดิมกับสภาพที่ถูกทำให้เปลี่ยนแปลงมีความแตกต่างกันเล็กน้อยมาก\r\n3) วัสดุหรือสสารที่ ไม่ถูกแยก ตอบสนอง หรือพังทลายโดยง่าย เช่น องค์ประกอบทางเคมีเสถียร",
            "word_usage": "ประธาน + が + 安定 + する",
            "word_ex": "物価が安定する。\r\nこの元素は安定している。"
        },
        {
            "id": "158",
            "kanji": "下落",
            "n_read": "げらく",
            "kango_easy": "下がる",
            "e_read": "さがる",
            "word_meaning": "ค่าครองชีพ ราคาท้องตลาด หรือคุณค่าของสิ่งใดสิ่งหนึ่งลดลง",
            "word_usage": "คำนาม + が + 下落 + する",
            "word_ex": "株価が下落する。"
        },
        {
            "id": "159",
            "kanji": "成功",
            "n_read": "せいこう",
            "kango_easy": "",
            "e_read": "できる",
            "word_meaning": "1) งานหรือแผนการเป็นไปอย่างราบรื่น บรรลุจุดประสงค์\r\n2) ได้รับตำแหน่งหรือทรัพย์สินที่เหมาะสม",
            "word_usage": "คำนาม + が + 成功 + する",
            "word_ex": "実験が成功する。\r\n実業界で成功する。"
        },
        {
            "id": "160",
            "kanji": "徹底",
            "n_read": "てってい",
            "kango_easy": "",
            "e_read": "しっかりする",
            "word_meaning": "1) ให้ความใส่ใจ รอบคอบในทุก ๆ ด้าน ทุกซอกทุกมุม\r\n2) ความคิดหรือความประพฤติมีความหนักแน่น มั่นคง",
            "word_usage": "คำนาม + を + 徹底 + させる\r\nคำนาม + が + 徹底 + する",
            "word_ex": "趣旨を徹底させる。\r\nサービスが徹底している。"
        },
        {
            "id": "161",
            "kanji": "徹底",
            "n_read": "てってい",
            "kango_easy": "広める",
            "e_read": "ひろめる",
            "word_meaning": "1) ให้ความใส่ใจ รอบคอบในทุก ๆ ด้าน ทุกซอกทุกมุม\r\n2) ความคิดหรือความประพฤติมีความหนักแน่น มั่นคง",
            "word_usage": "คำนาม + を + 徹底 + させる\r\nคำนาม + が + 徹底 + する",
            "word_ex": "趣旨を徹底させる。\r\nサービスが徹底している。"
        },
        {
            "id": "162",
            "kanji": "閉鎖",
            "n_read": "へいさ",
            "kango_easy": "閉じる",
            "e_read": "とじる",
            "word_meaning": "1) ปิดทางเข้าออก\r\n2) ปิดสิ่งก่อสร้างหนึ่งและหยุดการทำงาน ปิดกั้น",
            "word_usage": "คำนาม + を + 閉鎖 + する",
            "word_ex": "門を閉鎖する。\r\n工場を閉鎖する。"
        },
        {
            "id": "163",
            "kanji": "決定",
            "n_read": "けってい",
            "kango_easy": "決める",
            "e_read": "きめる",
            "word_meaning": "ตัดสินใจอย่างชัดเจน เรื่องที่กำหนดไว้แล้ว",
            "word_usage": "คำนาม + を + 決定 + する",
            "word_ex": "活動方針を決定する。"
        },
        {
            "id": "164",
            "kanji": "辞任",
            "n_read": "じにん",
            "kango_easy": "辞める",
            "e_read": "やめる",
            "word_meaning": "ลาออกจากหน้าที่ด้วยตัวเอง",
            "word_usage": "คำนาม + を + 辞任 + する",
            "word_ex": "首相を辞任する。"
        },
        {
            "id": "165",
            "kanji": "排除",
            "n_read": "はいじょ",
            "kango_easy": "消えす",
            "e_read": "きえす",
            "word_meaning": "ผลักออกไป กำจัดไปจากตรงนั้น",
            "word_usage": "คำนาม + を + 排除 + する",
            "word_ex": "抵抗する者を排除する。"
        },
        {
            "id": "166",
            "kanji": "排除",
            "n_read": "はいじょ",
            "kango_easy": "除く",
            "e_read": "のぞく",
            "word_meaning": "ผลักออกไป กำจัดไปจากตรงนั้น",
            "word_usage": "คำนาม + を + 排除 + する",
            "word_ex": "抵抗する者を排除する。"
        },
        {
            "id": "167",
            "kanji": "主催",
            "n_read": "しゅさい",
            "kango_easy": "センターになる",
            "e_read": "",
            "word_meaning": "เป็นศูนย์กลางในการจัดงานประชุมหรือกิจกรรมต่าง ๆ (เป็นเจ้าภาพ)",
            "word_usage": "คำนาม + を + 主催 + する",
            "word_ex": "コンサートを主催する。"
        },
        {
            "id": "168",
            "kanji": "主催",
            "n_read": "しゅさい",
            "kango_easy": "真ん中",
            "e_read": "まんなか",
            "word_meaning": "เป็นศูนย์กลางในการจัดงานประชุมหรือกิจกรรมต่าง ๆ (เป็นเจ้าภาพ)",
            "word_usage": "คำนาม + を + 主催 + する",
            "word_ex": "コンサートを主催する。"
        },
        {
            "id": "169",
            "kanji": "改善",
            "n_read": "かいぜん",
            "kango_easy": "良くする",
            "e_read": "よくする",
            "word_meaning": "แก้ไขสิ่งต่าง ๆ ให้เปลี่ยนไปในทางที่ดีขึ้น",
            "word_usage": "คำนาม + を + 改善 + する",
            "word_ex": "生活を改善する。"
        },
        {
            "id": "170",
            "kanji": "改善",
            "n_read": "かいぜん",
            "kango_easy": "改める",
            "e_read": "あらためる",
            "word_meaning": "แก้ไขสิ่งต่าง ๆ ให้เปลี่ยนไปในทางที่ดีขึ้น",
            "word_usage": "คำนาม + を + 改善 + する",
            "word_ex": "生活を改善する。"
        },
        {
            "id": "171",
            "kanji": "調査",
            "n_read": "ちょうさ",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "ค้นคว้าเพื่อทำให้ความเป็นจริงหรือแนวโน้มของบางสิ่งชัดเจน เช่น สำรวจพฤติกรรมการใข้ภาษาในเมือง",
            "word_usage": "คำนาม + を +  調査 + する",
            "word_ex": "都市の言語生活を調査する。"
        },
        {
            "id": "172",
            "kanji": "関与",
            "n_read": "かんよ",
            "kango_easy": "関わる",
            "e_read": "かかわる",
            "word_meaning": "มีความเกี่ยวข้องกับสิ่ง ๆ หนึ่ง มีส่วนร่วม",
            "word_usage": "คำนาม + に +  関与 + する",
            "word_ex": "政策決定に関与する。"
        },
        {
            "id": "173",
            "kanji": "販売",
            "n_read": "はんばい",
            "kango_easy": "売る",
            "e_read": "うる",
            "word_meaning": "ขายสินค้า",
            "word_usage": "คำนาม + を +  販売 + する",
            "word_ex": "古本を販売する。"
        },
        {
            "id": "174",
            "kanji": "成立",
            "n_read": "せいりつ",
            "kango_easy": "出来上がる",
            "e_read": "できあがる",
            "word_meaning": "สิ่งที่ใช้การได้ เสร็จเรียบร้อย ข้อตกลงที่สรุปได้แล้ว",
            "word_usage": "คำนาม + を + 成立 + させる\r\nคำนาม + が + 成立 + する",
            "word_ex": "予算案が成立する。\r\n交渉を成立させる。"
        },
        {
            "id": "175",
            "kanji": "衝突",
            "n_read": "しょうとつ",
            "kango_easy": "つき当たる",
            "e_read": "つきあたる",
            "word_meaning": "1) วิ่งชน ชน\r\n2) ผลประโยชน์หรือความเห็นของฝั่งตรงข้ามขัดแย้งกัน",
            "word_usage": "คำนาม + に + 衝突 + する\r\nคำนาม + が + 衝突 + する",
            "word_ex": "電柱に衝突する。\r\n意見が衝突する。"
        },
        {
            "id": "176",
            "kanji": "衝突",
            "n_read": "しょうとつ",
            "kango_easy": "",
            "e_read": "ぶつかる",
            "word_meaning": "1) วิ่งชน ชน\r\n2) ผลประโยชน์หรือความเห็นของฝั่งตรงข้ามขัดแย้งกัน",
            "word_usage": "คำนาม + に + 衝突 + する\r\nคำนาม + が + 衝突 + する",
            "word_ex": "電柱に衝突する。\r\n意見が衝突する。"
        },
        {
            "id": "177",
            "kanji": "勝利",
            "n_read": "しょうり",
            "kango_easy": "勝つ",
            "e_read": "かつ",
            "word_meaning": "ชนะในการต่อสู้หรือการแข่งขัน",
            "word_usage": "คำนาม + に + 勝利 + する",
            "word_ex": "争いに勝利する。"
        },
        {
            "id": "178",
            "kanji": "実行",
            "n_read": "じっこう",
            "kango_easy": "",
            "e_read": "する",
            "word_meaning": "1) ปฏิบัติจริง เช่น ทำตามกำหนดการ\r\n2) ในกฎหมายอาญา หมายถึงลงมือกระทำการความผิดบางอย่างที่เข้าข่ายกฎหมายทางอาญาโดยเจตนา\r\n3) ทำให้คอมพิวเตอร์ทำงานตามโปรแกรม",
            "word_usage": "คำนาม + を + 実行 + する\r\nคำนาม + どおり + 実行 + する",
            "word_ex": "計画を実行する。\r\n予定どおりに実行する。"
        },
        {
            "id": "179",
            "kanji": "実行",
            "n_read": "じっこう",
            "kango_easy": "行う",
            "e_read": "おこなう",
            "word_meaning": "1) ปฏิบัติจริง เช่น ทำตามกำหนดการ\r\n2) ในกฎหมายอาญา หมายถึงลงมือกระทำการความผิดบางอย่างที่เข้าข่ายกฎหมายทางอาญาโดยเจตนา\r\n3) ทำให้คอมพิวเตอร์ทำงานตามโปรแกรม",
            "word_usage": "คำนาม + を + 実行 + する\r\nคำนาม + どおり + 実行 + する",
            "word_ex": "計画を実行する。\r\n予定どおりに実行する。"
        },
        {
            "id": "180",
            "kanji": "実行",
            "n_read": "じっこう",
            "kango_easy": "",
            "e_read": "やる",
            "word_meaning": "1) ปฏิบัติจริง เช่น ทำตามกำหนดการ\r\n2) ในกฎหมายอาญา หมายถึงลงมือกระทำการความผิดบางอย่างที่เข้าข่ายกฎหมายทางอาญาโดยเจตนา\r\n3) ทำให้คอมพิวเตอร์ทำงานตามโปรแกรม",
            "word_usage": "คำนาม + を + 実行 + する\r\nคำนาม + どおり + 実行 + する",
            "word_ex": "計画を実行する。\r\n予定どおりに実行する。"
        },
        {
            "id": "181",
            "kanji": "代表",
            "n_read": "だいひょう",
            "kango_easy": "表す",
            "e_read": "あらわす",
            "word_meaning": "1) แสดงภาพรวมทั้งหมดของกลุ่ม ๆ หนึ่ง ด้วยสิ่งใดสิ่งหนึ่งเพียงอย่างเดียว หรือสิ่งที่โดดเด่นที่สุดในกลุ่ม\r\n2) เป็นตัวแทนของนิติบุคคลหรือกลุ่ม ในการแสดงความเห็นให้ผู้อื่นทราบ",
            "word_usage": "คำนาม + を +  代表 + する",
            "word_ex": "日本を代表する風景。\r\n卒業生を代表して答辞を述べる。"
        },
        {
            "id": "182",
            "kanji": "掲載",
            "n_read": "けいさい",
            "kango_easy": "載せる",
            "e_read": "のせる",
            "word_meaning": "ตีพิมพ์บทความหรือรูปภาพลงบนหนังสือพิมพ์หรือนิตยสาร",
            "word_usage": "คำนาม + を +  掲載 + する",
            "word_ex": "新聞に観戦記を掲載する。"
        },
        {
            "id": "183",
            "kanji": "立候補",
            "n_read": "りっこうほ",
            "kango_easy": "代表",
            "e_read": "だいひょう",
            "word_meaning": "1) ในการเลือกตั้ง  ผู้ที่มีคุณสมบัติเหมาะสมจะถูกประกาศว่าเป็นผู้สมัครรับเลือกตั้ง\r\n2) เสนอชื่อในฐานะผู้สมัคร",
            "word_usage": "คำนาม + を +  立候補 + する",
            "word_ex": "大会開催地として立候補する。"
        },
        {
            "id": "184",
            "kanji": "立候補",
            "n_read": "りっこうほ",
            "kango_easy": "名乗り",
            "e_read": "なのり",
            "word_meaning": "1) ในการเลือกตั้ง  ผู้ที่มีคุณสมบัติเหมาะสมจะถูกประกาศว่าเป็นผู้สมัครรับเลือกตั้ง\r\n2) เสนอชื่อในฐานะผู้สมัคร",
            "word_usage": "คำนาม + を +  立候補 + する",
            "word_ex": "大会開催地として立候補する。"
        },
        {
            "id": "185",
            "kanji": "捜査",
            "n_read": "そうさ",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "ตรวจสอบ ค้นหา โดยเฉพาะในการรวบรวมหลักฐาน เพื่อยืนยันตัวคนร้าย (สืบสวน สอบสวน)",
            "word_usage": "คำนาม + を +  捜査 + する",
            "word_ex": "殺人事件を捜査する。"
        },
        {
            "id": "186",
            "kanji": "捜査",
            "n_read": "そうさ",
            "kango_easy": "捜す",
            "e_read": "さがす",
            "word_meaning": "ตรวจสอบ ค้นหา โดยเฉพาะในการรวบรวมหลักฐาน เพื่อยืนยันตัวคนร้าย (สืบสวน สอบสวน)",
            "word_usage": "คำนาม + を +  捜査 + する",
            "word_ex": "殺人事件を捜査する。"
        },
        {
            "id": "187",
            "kanji": "反論",
            "n_read": "はんろん",
            "kango_easy": "反対する",
            "e_read": "はんたいする",
            "word_meaning": "แสดงความเห็นที่ตรงกันข้ามกับความเห็นหรือการตัดสินใจของอีกฝ่าย",
            "word_usage": "คำนาม + に + 反論 + する",
            "word_ex": "政策批判に反論する。"
        },
        {
            "id": "188",
            "kanji": "進出",
            "n_read": "しんしゅつ",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "1) พัฒนาแขนงใหม่ ๆ ขยายขอบเขตในการทำกิจกรรม เช่น ขยายตลาด\r\n2) ก้าวไปข้างหน้า​ คืบหน้า เคลื่อนไปข้างหน้า",
            "word_usage": "คำนาม + が + คำนาม に/へ + 進出 +する",
            "word_ex": "日本商品が海外に進出する。\r\n準決勝に進出する。"
        },
        {
            "id": "189",
            "kanji": "襲撃",
            "n_read": "しゅうげき",
            "kango_easy": "襲う",
            "e_read": "おそう",
            "word_meaning": "โจมตีตอนศัตรูเผลอ",
            "word_usage": "คำนาม + を +  襲撃 + する",
            "word_ex": "敵の移動中を襲撃する。"
        },
        {
            "id": "190",
            "kanji": "要求",
            "n_read": "ようきゅう",
            "kango_easy": "欲しい",
            "e_read": "ほしい",
            "word_meaning": "เรียกร้องจากอีกฝ่ายอย่างแรงกล้า เพราะมีความจำเป็นหรือเป็นสิทธิพื้นฐานที่ควรจะได้รับ",
            "word_usage": "คำนาม + を + 要求 + する",
            "word_ex": "賃上げを要求する。"
        },
        {
            "id": "191",
            "kanji": "要求",
            "n_read": "ようきゅう",
            "kango_easy": "求める",
            "e_read": "もとめる",
            "word_meaning": "เรียกร้องจากอีกฝ่ายอย่างแรงกล้า เพราะมีความจำเป็นหรือเป็นสิทธิพื้นฐานที่ควรจะได้รับ",
            "word_usage": "คำนาม + を + 要求 + する",
            "word_ex": "賃上げを要求する。"
        },
        {
            "id": "192",
            "kanji": "直面",
            "n_read": "ちょくめん",
            "kango_easy": "会う",
            "e_read": "あう",
            "word_meaning": "เผชิญหน้ากับบางสิ่งบางอย่างโดยตรง",
            "word_usage": "คำนาม + に + 直面 + する",
            "word_ex": "困難な事態に直面する。"
        },
        {
            "id": "193",
            "kanji": "直面",
            "n_read": "ちょくめん",
            "kango_easy": "対する",
            "e_read": "たいする",
            "word_meaning": "เผชิญหน้ากับบางสิ่งบางอย่างโดยตรง",
            "word_usage": "คำนาม + に + 直面 + する",
            "word_ex": "困難な事態に直面する。"
        },
        {
            "id": "194",
            "kanji": "運航",
            "n_read": "うんこう",
            "kango_easy": "行く",
            "e_read": "いく",
            "word_meaning": "เดินเรือ หรือขับเครื่องบินไปตามเส้นทางที่กำหนดไว้",
            "word_usage": "คำนาม (จำนวน/เส้นทาง) + を + 運航 + する",
            "word_ex": "島へは一日一便だけ運航している。"
        },
        {
            "id": "195",
            "kanji": "下船",
            "n_read": "げせん",
            "kango_easy": "降りる",
            "e_read": "おりる",
            "word_meaning": "ลงจากเรือที่โดยสารมา",
            "word_usage": "สถานที่ + で + เรือ + から + 下船 + する",
            "word_ex": "寄港地で下船する。"
        },
        {
            "id": "196",
            "kanji": "破壊",
            "n_read": "はかい",
            "kango_easy": "壊す",
            "e_read": "こわす",
            "word_meaning": "ทำ(สิ่งปลูกสร้าง, สิ่งของ, ความเป็นระเบียบ, องค์กร)พัง สภาพที่พังอยู่",
            "word_usage": "คำนาม + を + 破壊 + する\r\nคำนาม + が + 破壊 + される",
            "word_ex": "生態系を破壊する。\r\n家が破壊された。"
        },
        {
            "id": "197",
            "kanji": "設立",
            "n_read": "せつりつ",
            "kango_easy": "建てる",
            "e_read": "たてる",
            "word_meaning": "สร้างสถาบัน องค์กร เช่น โรงเรียนหรือบริษัท, สิ่งอำนวยความสะดวก, ระบบขึ้นมาใหม่",
            "word_usage": "คำนาม + を + 設立 + する",
            "word_ex": "病院を設立する。"
        },
        {
            "id": "198",
            "kanji": "展示",
            "n_read": "てんじ",
            "kango_easy": "見せる",
            "e_read": "みせる",
            "word_meaning": "นำผลงาน สินค้า หรืออื่น ๆ มาจัดเรียง เพื่อให้คนจำนวนมากเข้ามาชม",
            "word_usage": "คำนาม + を + 展示 + する",
            "word_ex": "生徒の絵を展示する。"
        },
        {
            "id": "199",
            "kanji": "計画",
            "n_read": "けいかく",
            "kango_easy": "スケジュール",
            "e_read": "",
            "word_meaning": "คิดวิธีการหรือขั้นตอนไว้ล่วงหน้า ก่อนลงมือทำ วางแผน เช่น วางแผนการท่องเที่ยว",
            "word_usage": "คำนาม​ + を + 計画 + する",
            "word_ex": "旅行を計画する。"
        },
        {
            "id": "200",
            "kanji": "使用",
            "n_read": "しよう",
            "kango_easy": "使う",
            "e_read": "つかう",
            "word_meaning": "ใช้ ใช้งานสิ่งของหรือคน",
            "word_usage": "คำนาม​ + を + 使用 + する",
            "word_ex": "会議室を使用するには許可がいる。"
        },
        {
            "id": "201",
            "kanji": "爆発",
            "n_read": "ばくはつ",
            "kango_easy": "爆弾",
            "e_read": "ばくだん",
            "word_meaning": "1) ระเบิด (ปฏิกิริยาทางเคมี)\r\n2) อารมณ์หรือสิ่งที่เก็บไว้ภายใน ปรากฏออกมายังภายนอกด้วยแรงขับอย่างรุนแรงในคราวเดียว เช่น อารมณ์โกรธปะทุขึ้นมา",
            "word_usage": "คำนาม + が + 爆発 + する",
            "word_ex": "火薬が爆発する。\r\n怒りが爆発する。"
        },
        {
            "id": "202",
            "kanji": "爆発",
            "n_read": "ばくはつ",
            "kango_easy": "ボム",
            "e_read": "",
            "word_meaning": "1) ระเบิด (ปฏิกิริยาทางเคมี)\r\n2) อารมณ์หรือสิ่งที่เก็บไว้ภายใน ปรากฏออกมายังภายนอกด้วยแรงขับอย่างรุนแรงในคราวเดียว เช่น อารมณ์โกรธปะทุขึ้นมา",
            "word_usage": "คำนาม + が + 爆発 + する",
            "word_ex": "火薬が爆発する。\r\n怒りが爆発する。"
        },
        {
            "id": "203",
            "kanji": "倒壊",
            "n_read": "とうかい",
            "kango_easy": "倒れる",
            "e_read": "たおれる",
            "word_meaning": "สิ่งปลูกสร้างพังถล่มลงมา พลังทลาย",
            "word_usage": "คำนาม + が + 倒壊 + する",
            "word_ex": "地震で家屋が倒壊する。"
        },
        {
            "id": "204",
            "kanji": "指定",
            "n_read": "してい",
            "kango_easy": "選ぶ",
            "e_read": "えらぶ",
            "word_meaning": "1)เลือกหรือกำหนดสิ่งใดสิ่งหนึ่งจากตัวเลือกจำนวนหนึ่ง (คน, เวลา, สถานที่, สิ่งของ) เช่น กำหนดที่นั่งในรถไฟ\r\n2)การที่หน่วยงานรัฐกำหนดสิ่งใดสิ่งหนึ่งพร้อมให้ใบรับรองตามกฎหมายที่ได้ประกาศไว้ เช่น กำหนดให้เป็นอุทยานแห่งชาติ",
            "word_usage": "คำนาม + に + 指定 + する",
            "word_ex": "約束の場所を指定する。\r\n国定公園に指定する。"
        },
        {
            "id": "205",
            "kanji": "指定",
            "n_read": "してい",
            "kango_easy": "指す",
            "e_read": "さす",
            "word_meaning": "1)เลือกหรือกำหนดสิ่งใดสิ่งหนึ่งจากตัวเลือกจำนวนหนึ่ง (คน, เวลา, สถานที่, สิ่งของ) เช่น กำหนดที่นั่งในรถไฟ\r\n2)การที่หน่วยงานรัฐกำหนดสิ่งใดสิ่งหนึ่งพร้อมให้ใบรับรองตามกฎหมายที่ได้ประกาศไว้ เช่น กำหนดให้เป็นอุทยานแห่งชาติ",
            "word_usage": "คำนาม + に + 指定 + する",
            "word_ex": "約束の場所を指定する。\r\n国定公園に指定する。"
        },
        {
            "id": "206",
            "kanji": "感謝",
            "n_read": "かんしゃ",
            "kango_easy": "ありがとう",
            "e_read": "ありがとう",
            "word_meaning": "รู้สึกขอบคุณ แสดงความสำนึกในบุญคุณ",
            "word_usage": "คำนาม + に + 感謝 + する\r\nคำนาม + を + 感謝 + する",
            "word_ex": "母に感謝する。\r\n受けた恩を感謝する。"
        },
        {
            "id": "207",
            "kanji": "発見",
            "n_read": "はっけん",
            "kango_easy": "見つける",
            "e_read": "みつける",
            "word_meaning": "พบ เจอสิ่งที่ไม่เคยรู้มาก่อน เช่น ค้บพบเชื้อจุลินทรีย์",
            "word_usage": "คำนาม​ + を + 発見 + する",
            "word_ex": "犯人のアジトを発見する。"
        },
        {
            "id": "208",
            "kanji": "調整",
            "n_read": "ちょうせい",
            "kango_easy": "直す",
            "e_read": "なおす",
            "word_meaning": "1) จัดการกับสภาพที่ไม่ดี\r\n2) จัดให้ถูกต้องตามมาตรฐานหนึ่ง ๆ\r\n3) ทำให้อยู่ในสภาพที่พอดี ไม่ขาดไม่เกิน",
            "word_usage": "คำนาม​ + を + 調整 + する",
            "word_ex": "開幕に向けて、チームを調整する。\r\n関係各国の意見を調整する。\r\n日程を調整する。"
        },
        {
            "id": "209",
            "kanji": "開幕",
            "n_read": "かいまく",
            "kango_easy": "始まる",
            "e_read": "はじまる",
            "word_meaning": "1) เปิดม่านบนเวที เช่นในการแสดงละครเวที\r\n2) การที่สิ่งใดสิ่งหนึ่งเริ่มต้น เมื่อถึงเวลา",
            "word_usage": "คำนาม + を + 開幕 + する\r\nคำนาม + が + 開幕 + する",
            "word_ex": "5月21日に今年のシーズンを開幕する。\r\nオリンピックの試合が開幕する。"
        },
        {
            "id": "210",
            "kanji": "入院",
            "n_read": "にゅういん",
            "kango_easy": "入る",
            "e_read": "はいる",
            "word_meaning": "เข้าโรงพยาบาล อยู่ที่โรงพยาบาลระยะหนึ่งเพื่อรับการรักษา",
            "word_usage": "คำนาม + が + 入院 + する",
            "word_ex": "精密検査のために入院する"
        },
        {
            "id": "211",
            "kanji": "難航",
            "n_read": "なんこう",
            "kango_easy": "難しくなる",
            "e_read": "むずかしくなる",
            "word_meaning": "1) การเดินเรือ หรือเที่ยวบินเป็นไปอย่างยากลำบากเนื่องจากพายุหรือภัยธรรมชาติอื่น ๆ\r\n2) ไม่คืบหน้า เนื่องจากมีอุปสรรคมาก เช่น การก่อสร้างไม่คืบหน้า การเจรจาไม่คืบหน้า",
            "word_usage": "คำนาม + が + 難航 + する",
            "word_ex": "飛行機が難航する。\r\nこの話し合いが難航する。"
        },
        {
            "id": "212",
            "kanji": "難航",
            "n_read": "なんこう",
            "kango_easy": "進まない",
            "e_read": "すすまない",
            "word_meaning": "1) การเดินเรือ หรือเที่ยวบินเป็นไปอย่างยากลำบากเนื่องจากพายุหรือภัยธรรมชาติอื่น ๆ\r\n2) ไม่คืบหน้า เนื่องจากมีอุปสรรคมาก เช่น การก่อสร้างไม่คืบหน้า การเจรจาไม่คืบหน้า",
            "word_usage": "คำนาม + が + 難航 + する",
            "word_ex": "飛行機が難航する。\r\nこの話し合いが難航する。"
        },
        {
            "id": "213",
            "kanji": "理解",
            "n_read": "りかい",
            "kango_easy": "",
            "e_read": "わかる",
            "word_meaning": "1) รู้และตัดสินเรื่องราวหรือสถานการณ์ต่าง ๆ ได้อย่างถูกต้อง โดยการใช้เหตุและผล ยอมรับ เข้าถึงเรื่องราวนั้น ๆ ได้\r\n2) เข้าใจความรู้สึก หรือจุดยืนของผู้อื่น",
            "word_usage": "คำนาม​ + を + 理解 + する",
            "word_ex": "内容を正しく理解する。\r\n彼女の気持ちを理解する。"
        },
        {
            "id": "214",
            "kanji": "開始",
            "n_read": "かいし",
            "kango_easy": "始める",
            "e_read": "はじめる",
            "word_meaning": "เริ่ม เริ่มต้นขึ้น",
            "word_usage": "คำนาม + を + 開始 + する\r\nคำนาม + が + 開始 + される",
            "word_ex": "交渉を開始する。\r\n試合が開始される。"
        },
        {
            "id": "215",
            "kanji": "開始",
            "n_read": "かいし",
            "kango_easy": "始まる",
            "e_read": "はじまる",
            "word_meaning": "เริ่ม เริ่มต้นขึ้น",
            "word_usage": "คำนาม + を + 開始 + する\r\nคำนาม + が + 開始 + される",
            "word_ex": "交渉を開始する。\r\n試合が開始される。"
        },
        {
            "id": "216",
            "kanji": "回復",
            "n_read": "かいふく",
            "kango_easy": "戻す",
            "e_read": "もどす",
            "word_meaning": "1) สิ่งที่อยู่ในสภาพที่ย่ำแย่ คืนกลับสู่สภาพเดิม เช่น สภาพอากาศ, สภาพเศรษฐกิจกลับมาเป็นปกติ\r\n2) ทำให้สิ่งที่สูญเสียไปแล้วครั้งหนึ่งกลับมา เช่น กอบกู้ชื่อเสียง เรียกคืนความมั่นใจ",
            "word_usage": "คำนาม + が + 回復 + する\r\nคำนาม + を + 回復 + する",
            "word_ex": "健康が回復する。\r\n名誉を回復する。"
        },
        {
            "id": "217",
            "kanji": "回復",
            "n_read": "かいふく",
            "kango_easy": "戻る",
            "e_read": "もどる",
            "word_meaning": "1) สิ่งที่อยู่ในสภาพที่ย่ำแย่ คืนกลับสู่สภาพเดิม เช่น สภาพอากาศ, สภาพเศรษฐกิจกลับมาเป็นปกติ\r\n2) ทำให้สิ่งที่สูญเสียไปแล้วครั้งหนึ่งกลับมา เช่น กอบกู้ชื่อเสียง เรียกคืนความมั่นใจ",
            "word_usage": "คำนาม + が + 回復 + する\r\nคำนาม + を + 回復 + する",
            "word_ex": "健康が回復する。\r\n名誉を回復する。"
        },
        {
            "id": "218",
            "kanji": "活用",
            "n_read": "かつよう",
            "kango_easy": "使う",
            "e_read": "つかう",
            "word_meaning": "ดึงคุณสมบัติหรือการทำงานของสิ่งหนึ่งมาใช้ได้อย่างเหมาะสม ใช้ได้อย่างคล่องแคล่ว",
            "word_usage": "คำนาม​ + を + 活用 + する",
            "word_ex": "学んだ知識を活用する。"
        },
        {
            "id": "219",
            "kanji": "発足",
            "n_read": "ほっそく",
            "kango_easy": "始める",
            "e_read": "はじめる",
            "word_meaning": "1) เริ่มต้นกิจกรรมของกลุ่มหรือองค์กรที่ถูกสร้างขึ้นมาใหม่\r\n2) ออกเดินทาง",
            "word_usage": "คำนาม + が + 発足 + する\r\nคำนาม (สถานที่) + を + 発足 + する",
            "word_ex": "協議会が発足する。\r\n静岡を発足する。"
        },
        {
            "id": "220",
            "kanji": "発足",
            "n_read": "ほっそく",
            "kango_easy": "始まる",
            "e_read": "はじまる",
            "word_meaning": "1) เริ่มต้นกิจกรรมของกลุ่มหรือองค์กรที่ถูกสร้างขึ้นมาใหม่\r\n2) ออกเดินทาง",
            "word_usage": "คำนาม + が + 発足 + する\r\nคำนาม (สถานที่) + を + 発足 + する",
            "word_ex": "協議会が発足する。\r\n静岡を発足する。"
        },
        {
            "id": "221",
            "kanji": "約束",
            "n_read": "やくそく",
            "kango_easy": "約する",
            "e_read": "やくする",
            "word_meaning": "1) ตกลงกันระหว่างผู้ที่เกี่ยวข้อง (สัญญาว่า)\r\n2) การที่เรื่องนั้น ๆ ถูกมองว่าจะเกิดขึ้นจริงอย่างแน่นอน",
            "word_usage": "คำนาม + を + 約束 + する\r\nคำนาม + が + 約束 + される\r\nรูปปกติ + と + 約束 + する",
            "word_ex": "秘密を守ることを約束する。\r\n社長の椅子が約束される。\r\n嘘をつかないと約束する。"
        },
        {
            "id": "222",
            "kanji": "解放",
            "n_read": "かいほう",
            "kango_easy": "自由にする",
            "e_read": "じゆうにする",
            "word_meaning": "ปลดปล่อยร่างกายหรือจิตใจจากสิ่งที่กักขังหรือจำกัดไว้",
            "word_usage": "(คำนาม + から) + คำนาม + を + 解放 + する\r\n(คำนาม + から) + คำนาม + が + 解放 + される",
            "word_ex": "国民を圧制から解放する。\r\n貧困から解放される。"
        },
        {
            "id": "223",
            "kanji": "解放",
            "n_read": "かいほう",
            "kango_easy": "放す",
            "e_read": "はなす",
            "word_meaning": "ปลดปล่อยร่างกายหรือจิตใจจากสิ่งที่กักขังหรือจำกัดไว้",
            "word_usage": "(คำนาม + から) + คำนาม + を + 解放 + する\r\n(คำนาม + から) + คำนาม + が + 解放 + される",
            "word_ex": "国民を圧制から解放する。\r\n貧困から解放される。"
        },
        {
            "id": "224",
            "kanji": "撤廃",
            "n_read": "てっぱい",
            "kango_easy": "",
            "e_read": "やめる",
            "word_meaning": "ยกเลิก ทำให้เป็นโมฆะ โดยเฉพาะการล้มเลิกสิ่งที่เคยมีมา เช่น ระบบ กฎระเบียบ",
            "word_usage": "คำนาม​ + を + 撤廃 + する",
            "word_ex": "規則を撤廃する。"
        },
        {
            "id": "225",
            "kanji": "加盟",
            "n_read": "かめい",
            "kango_easy": "入る",
            "e_read": "はいる",
            "word_meaning": "เข้ามาเป็นสมาชิกในกลุ่มหรือองค์กร เข้าร่วมสมาพันธ์",
            "word_usage": "คำนาม + に + 加盟 + する",
            "word_ex": "組合に加盟する。"
        },
        {
            "id": "226",
            "kanji": "継続",
            "n_read": "けいぞく",
            "kango_easy": "続ける",
            "e_read": "つづける",
            "word_meaning": "1) สภาพที่ดำเนินต่อเนื่องมาตั้งแต่ก่อนหน้า ดำเนินต่อไป\r\n2) รับช่วงต่อ",
            "word_usage": "คำนาม​ + を + 継続 + する",
            "word_ex": "討議を継続する。"
        },
        {
            "id": "227",
            "kanji": "希望",
            "n_read": "きぼう",
            "kango_easy": "望む",
            "e_read": "のぞむ",
            "word_meaning": "คาดหวัง ปราถนา หรือประสงค์ให้เรื่องหนึ่งกลายเป็นความจริง",
            "word_usage": "คำนาม​ + を + 希望 + する",
            "word_ex": "入社を希望する。"
        },
        {
            "id": "228",
            "kanji": "不足",
            "n_read": "ふそく",
            "kango_easy": "足りない",
            "e_read": "たりない",
            "word_meaning": "ขาด ไม่เพียงพอ",
            "word_usage": "คำนาม​ + が + 不足 + する",
            "word_ex": "料金が不足する。"
        },
        {
            "id": "229",
            "kanji": "影響",
            "n_read": "えいきょう",
            "kango_easy": "インパクト",
            "e_read": "",
            "word_meaning": "การที่สิ่งหนึ่งส่งผลกระทบต่ออีกสิ่งหนึ่งจนเกิดความเปลี่ยนแปลง หรือมีการตอบสนองต่อสิ่งนั้น เนื่องจากมีความสัมพันธ์ที่ใกล้ชิดกัน เช่น การเลือกตั้งส่งผลต่อราคาหุ้น",
            "word_usage": "คำนาม​ + が + คำนาม + に + 影響 + する",
            "word_ex": "選挙の結果が株価に影響する。"
        },
        {
            "id": "230",
            "kanji": "影響",
            "n_read": "えいきょう",
            "kango_easy": "関わる",
            "e_read": "かかわる",
            "word_meaning": "การที่สิ่งหนึ่งส่งผลกระทบต่ออีกสิ่งหนึ่งจนเกิดความเปลี่ยนแปลง หรือมีการตอบสนองต่อสิ่งนั้น เนื่องจากมีความสัมพันธ์ที่ใกล้ชิดกัน เช่น การเลือกตั้งส่งผลต่อราคาหุ้น",
            "word_usage": "คำนาม​ + が + คำนาม + に + 影響 + する",
            "word_ex": "選挙の結果が株価に影響する。"
        },
        {
            "id": "231",
            "kanji": "影響",
            "n_read": "えいきょう",
            "kango_easy": "左右する",
            "e_read": "さゆうする",
            "word_meaning": "การที่สิ่งหนึ่งส่งผลกระทบต่ออีกสิ่งหนึ่งจนเกิดความเปลี่ยนแปลง หรือมีการตอบสนองต่อสิ่งนั้น เนื่องจากมีความสัมพันธ์ที่ใกล้ชิดกัน เช่น การเลือกตั้งส่งผลต่อราคาหุ้น",
            "word_usage": "คำนาม​ + が + คำนาม + に + 影響 + する",
            "word_ex": "選挙の結果が株価に影響する。"
        },
        {
            "id": "232",
            "kanji": "発信",
            "n_read": "はっしん",
            "kango_easy": "送る",
            "e_read": "おくる",
            "word_meaning": "1) ส่งโทรเลข หรือปล่อยสัญญาณออกไป\r\n2) ส่งพัสดุไปรษณีย์\r\n3) แจ้งข้อมูลให้ทราบ",
            "word_usage": "คำนาม​ + を + 発信 + する",
            "word_ex": "SOSを発信する。\r\n祝電を発信する。\r\n町の魅力を発信する。"
        },
        {
            "id": "233",
            "kanji": "搭載",
            "n_read": "とうさい",
            "kango_easy": "持っている",
            "e_read": "もっている",
            "word_meaning": "1) บรรทุกของลงบนเรือ รถ หรือเครื่องบิน หรือติดอาวุธ เช่น ติดตั้งขีปนาวุธที่เรือดำน้ำพลังงานนิวเคลียร์\r\n2) ติดตั้งอุปกรณ์หรือฟังก์ชันบางอย่างที่เครื่องจักร เครื่องมืออิเล็กทรอนิกส์ หรือรถยนต์ เช่น ติดตั้งฟังก์ชันกล้องถ่ายรูปในโทรศัพท์มือถือ",
            "word_usage": "คำนาม​ + を + 搭載 + する",
            "word_ex": "原子力潜水艦にミサイルを搭載する。\r\n無線機を搭載する。"
        },
        {
            "id": "234",
            "kanji": "追悼",
            "n_read": "ついとう",
            "kango_easy": "思う",
            "e_read": "おもう",
            "word_meaning": "ระลึกถึงผู้ตายตอนที่ยังมีชีวิตอยู่ (ไว้อาลัย)",
            "word_usage": "คำนาม (ผู้ตาย) + を + 追悼 + する",
            "word_ex": "故人を追悼する。"
        },
        {
            "id": "235",
            "kanji": "追悼",
            "n_read": "ついとう",
            "kango_easy": "考える",
            "e_read": "かんがえる",
            "word_meaning": "ระลึกถึงผู้ตายตอนที่ยังมีชีวิตอยู่ (ไว้อาลัย)",
            "word_usage": "คำนาม (ผู้ตาย) + を + 追悼 + する",
            "word_ex": "故人を追悼する。"
        },
        {
            "id": "236",
            "kanji": "解除",
            "n_read": "かいじょ",
            "kango_easy": "消す",
            "e_read": "けす",
            "word_meaning": "ยกเลิกระบบ ข้อห้าม หรือสถานการณ์พิเศษที่เคยมีมา ทำให้กลับสู่สภาพเดิม",
            "word_usage": "คำนาม​ + を + 解除 + する",
            "word_ex": "夜間外出禁止令を解除する。"
        },
        {
            "id": "237",
            "kanji": "解除",
            "n_read": "かいじょ",
            "kango_easy": "キャンセル",
            "e_read": "",
            "word_meaning": "ยกเลิกระบบ ข้อห้าม หรือสถานการณ์พิเศษที่เคยมีมา ทำให้กลับสู่สภาพเดิม",
            "word_usage": "คำนาม​ + を + 解除 + する",
            "word_ex": "夜間外出禁止令を解除する。"
        },
        {
            "id": "238",
            "kanji": "尊重",
            "n_read": "そんちょう",
            "kango_easy": "尊ぶ",
            "e_read": "たっとぶ",
            "word_meaning": "เคารพ หรือให้เกียรติสิ่งที่มีคุณค่า เช่น เคารพความเห็นของผู้อื่น",
            "word_usage": "คำนาม​ + を + 尊重 + する",
            "word_ex": "人権を尊重する。"
        },
        {
            "id": "239",
            "kanji": "活動",
            "n_read": "かつどう",
            "kango_easy": "",
            "e_read": "する",
            "word_meaning": "เคลื่อนไหวอย่างกระฉับกระเฉง ทำงาน ใช้กับการเคลื่อนไหวของสัตว์ได้ด้วย ",
            "word_usage": "คำนาม​ + が + 活動 + する",
            "word_ex": "暖かくなって虫が活動し始める。"
        },
        {
            "id": "240",
            "kanji": "活動",
            "n_read": "かつどう",
            "kango_easy": "動く",
            "e_read": "うごく",
            "word_meaning": "เคลื่อนไหวอย่างกระฉับกระเฉง ทำงาน ใช้กับการเคลื่อนไหวของสัตว์ได้ด้วย ",
            "word_usage": "คำนาม​ + が + 活動 + する",
            "word_ex": "暖かくなって虫が活動し始める。"
        },
        {
            "id": "241",
            "kanji": "活動",
            "n_read": "かつどう",
            "kango_easy": "働く",
            "e_read": "はたらく",
            "word_meaning": "เคลื่อนไหวอย่างกระฉับกระเฉง ทำงาน ใช้กับการเคลื่อนไหวของสัตว์ได้ด้วย ",
            "word_usage": "คำนาม​ + が + 活動 + する",
            "word_ex": "暖かくなって虫が活動し始める。"
        },
        {
            "id": "242",
            "kanji": "運営",
            "n_read": "うんえい",
            "kango_easy": "動かす",
            "e_read": "うごかす",
            "word_meaning": "ขับเคลื่อนองค์กรหรือกลไกบางอย่างให้เกิดประสิทธิภาพ (จัดการ, บริหาร)",
            "word_usage": "คำนาม​ + を + 運営 + する",
            "word_ex": "大会を運営する。"
        },
        {
            "id": "243",
            "kanji": "運営",
            "n_read": "うんえい",
            "kango_easy": "営む",
            "e_read": "いとなむ",
            "word_meaning": "ขับเคลื่อนองค์กรหรือกลไกบางอย่างให้เกิดประสิทธิภาพ (จัดการ, บริหาร)",
            "word_usage": "คำนาม​ + を + 運営 + する",
            "word_ex": "大会を運営する。"
        },
        {
            "id": "244",
            "kanji": "変更",
            "n_read": "へんこう",
            "kango_easy": "変える",
            "e_read": "かえる",
            "word_meaning": "เปลี่ยนสิ่งที่กำหนดไว้ เปลี่ยนใหม่",
            "word_usage": "คำนาม​ + を + 変更 + する",
            "word_ex": "計画を変更する。"
        },
        {
            "id": "245",
            "kanji": "関係",
            "n_read": "かんけい",
            "kango_easy": "関わる",
            "e_read": "かかわる",
            "word_meaning": "คนหรือสิ่งของตั้งแต่สองสิ่งขึ้นไปมีความสัมพันธ์ซึ่งกันแหละกัน",
            "word_usage": "คำนาม + に + 関係 + する",
            "word_ex": "彼は収賄事件に関係する。"
        },
        {
            "id": "246",
            "kanji": "急増",
            "n_read": "きゅうぞう",
            "kango_easy": "増える",
            "e_read": "ふえる",
            "word_meaning": "เพิ่มขึ้นอย่างรวดเร็ว",
            "word_usage": "คำนาม​ + が + 急増 + する",
            "word_ex": "人口が急増する。"
        },
        {
            "id": "247",
            "kanji": "削減",
            "n_read": "さくげん",
            "kango_easy": "減らす",
            "e_read": "減らす",
            "word_meaning": "ลดสิ่งที่มีอยู่ลง เช่น ลดงบประมาณ",
            "word_usage": "คำนาม​ + を + 削減 + する",
            "word_ex": "軍事予算を削減する。"
        },
        {
            "id": "248",
            "kanji": "封鎖",
            "n_read": "ふうさ",
            "kango_easy": "閉じる",
            "e_read": "とじる",
            "word_meaning": "ปิด ไม่ให้เข้าออก, ไม่ให้พาเข้ามาหรือนำออกไป เช่น ปิดถนน ปิดประเทศ",
            "word_usage": "คำนาม​ + を + 封鎖 + する",
            "word_ex": "道路を封鎖する。"
        },
        {
            "id": "249",
            "kanji": "駐在",
            "n_read": "ちゅうざい",
            "kango_easy": "住む",
            "e_read": "すむ",
            "word_meaning": "อาศัยในที่ที่กำหนดไว้ โดยเฉพาะการอาศัยเพื่อทำหน้าที่ที่ได้รับมอบหมายในต่างถิ่นหรือต่างแดน",
            "word_usage": "คำนาม (สถานที่) + に + 駐在 + する",
            "word_ex": "海外に駐在する。"
        },
        {
            "id": "250",
            "kanji": "購入",
            "n_read": "こうにゅう",
            "kango_easy": "買う",
            "e_read": "かう",
            "word_meaning": "ซื้อ",
            "word_usage": "คำนาม​ + を + 購入 + する",
            "word_ex": "日用品を購入する。"
        },
        {
            "id": "251",
            "kanji": "認定",
            "n_read": "にんてい",
            "kango_easy": "認める",
            "e_read": "みとめる",
            "word_meaning": "การกำหนด หลังจากตรวจสอบคุณสมบัติหรือความจริงแล้ว (อนุญาต, ยอมรับ, รับรองว่า...) เช่น (รับทราบแล้วว่า)เป็นความผิดพลาดระหว่างการทำงาน (มีการพิจารณาจากปัจจัยอื่น ๆ แล้ว จึงกำหนดว่าเป็นข้อผิดพลาดระหว่างการทำงาน)",
            "word_usage": "คำนาม + と + 認定 + する",
            "word_ex": "業務上の過失と認定する。"
        },
        {
            "id": "252",
            "kanji": "認定",
            "n_read": "にんてい",
            "kango_easy": "決める",
            "e_read": "きめる",
            "word_meaning": "การกำหนด หลังจากตรวจสอบคุณสมบัติหรือความจริงแล้ว (อนุญาต, ยอมรับ, รับรองว่า...) เช่น (รับทราบแล้วว่า)เป็นความผิดพลาดระหว่างการทำงาน (มีการพิจารณาจากปัจจัยอื่น ๆ แล้ว จึงกำหนดว่าเป็นข้อผิดพลาดระหว่างการทำงาน)",
            "word_usage": "คำนาม + と + 認定 + する",
            "word_ex": "業務上の過失と認定する。"
        },
        {
            "id": "253",
            "kanji": "配備",
            "n_read": "はいび",
            "kango_easy": "備える",
            "e_read": "そなえる",
            "word_meaning": "จัดเตรียมเพื่อให้พร้อมใช้งาน เช่น เตรียมกำลังพล เตรียมเครื่องมือ",
            "word_usage": "คำนาม​ + を + 配備 + する",
            "word_ex": "新機種を配備する。"
        },
        {
            "id": "254",
            "kanji": "撤回",
            "n_read": "てっかい",
            "kango_easy": "消す",
            "e_read": "けす",
            "word_meaning": "ถอนคำพูด, ความเห็นที่ได้กล่าวออกไป ในทางกฎหมาย หมายถึง บุคคลดังกล่าวแสดงเจตนาโดยชัดแจ้งว่าการดังกล่าวจะไม่มีผลผูกพันอีกต่อไป ",
            "word_usage": "คำนาม​ + を + 撤回 + する",
            "word_ex": "前言を撤回する。"
        },
        {
            "id": "255",
            "kanji": "輸入",
            "n_read": "ゆにゅう",
            "kango_easy": "受ける",
            "e_read": "うける",
            "word_meaning": "รับสินค้า วิทยาการ ระบบ วัฒนธรรมของประเทศอื่นเข้ามาในประเทศตัวเอง โดยเฉพาะการนำสินค้าเข้ามาขายในประเทศตัวเอง (นำเข้า)",
            "word_usage": "คำนาม​ + を + 輸入 + する",
            "word_ex": "食糧を輸入する。"
        },
        {
            "id": "256",
            "kanji": "輸入",
            "n_read": "ゆにゅう",
            "kango_easy": "入る",
            "e_read": "はいる",
            "word_meaning": "รับสินค้า วิทยาการ ระบบ วัฒนธรรมของประเทศอื่นเข้ามาในประเทศตัวเอง โดยเฉพาะการนำสินค้าเข้ามาขายในประเทศตัวเอง (นำเข้า)",
            "word_usage": "คำนาม​ + を + 輸入 + する",
            "word_ex": "食糧を輸入する。"
        },
        {
            "id": "257",
            "kanji": "保護",
            "n_read": "ほご",
            "kango_easy": "守る",
            "e_read": "まもる",
            "word_meaning": "1) ปกป้อง คุ้มกันจากภัยอันตรายภายนอก การถูกคุกคาม การถูกทำลาย เช่น ป้องกันปากแผล รักษาป่าไม้\r\n2) ฝากไว้กับตำรวจ เพื่อช่วยเหลือในกรณีฉุกเฉิน (คุ้มครอง) เช่น คุ้มครองเด็กหลงทาง",
            "word_usage": "คำนาม​ + を + 保護 + する",
            "word_ex": "森林を保護する。\r\n迷子を保護する。"
        },
        {
            "id": "258",
            "kanji": "指名",
            "n_read": "しめい",
            "kango_easy": "指す",
            "e_read": "さす",
            "word_meaning": "เอ่ยชื่อเพื่อระบุตัวคนคนนั้น, เรียกชื่อ, เสนอชื่อ เช่น เสนอชื่อให้เป็นประธาน",
            "word_usage": "คำนาม (ชื่อตำแหน่ง) + を + 指名 + する\r\nคำนาม (ชื่อตำแหน่ง) + に + 指名 + される",
            "word_ex": "総理大臣を指名する。\r\n議長に指名される。"
        },
        {
            "id": "259",
            "kanji": "完成",
            "n_read": "かんせい",
            "kango_easy": "",
            "e_read": "できる",
            "word_meaning": "ทำให้เสร็จสมบูรณ์, สภาพที่ถูกทำให้เสร็จสมบูรณ์แล้ว",
            "word_usage": "คำนาม + を + 完成 + する\r\nคำนาม + が + 完成 + する",
            "word_ex": "大作を完成する。\r\n新校舎が完成する。"
        },
        {
            "id": "260",
            "kanji": "輸出",
            "n_read": "ゆしゅつ",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "ส่งออก (สินค้า วัฒนธรรม การแสดง)",
            "word_usage": "สถานที่ + に + 輸出 + する",
            "word_ex": "日本はカメラを世界各国に輸出している。"
        },
        {
            "id": "261",
            "kanji": "輸出",
            "n_read": "ゆしゅつ",
            "kango_easy": "送る",
            "e_read": "おくる",
            "word_meaning": "ส่งออก (สินค้า วัฒนธรรม การแสดง)",
            "word_usage": "สถานที่ + に + 輸出 + する",
            "word_ex": "日本はカメラを世界各国に輸出している。"
        },
        {
            "id": "262",
            "kanji": "乱射",
            "n_read": "らんしゃ",
            "kango_easy": "射つ",
            "e_read": "うつ",
            "word_meaning": "กราดยิง (ยิงแแบบไม่กำหนดเป้าหมาย)",
            "word_usage": "คำนาม + を + 乱射 + する",
            "word_ex": "ライフルを乱射する。"
        },
        {
            "id": "263",
            "kanji": "登録",
            "n_read": "とうろく",
            "kango_easy": "録する",
            "e_read": "ろくする",
            "word_meaning": "ลงทะเบียน (เพื่อเป็นหลักฐานรับรอง)",
            "word_usage": "คำนาม + を + 登録 + する",
            "word_ex": "科目を登録しなければなりません。"
        },
        {
            "id": "264",
            "kanji": "面会",
            "n_read": "めんかい",
            "kango_easy": "会う",
            "e_read": "あう",
            "word_meaning": "พบ เข้าพบ เยี่ยม",
            "word_usage": "คำนาม + と + 面会 + する\r\nคำนาม + に + 面会 + する",
            "word_ex": "先生に面会します。\r\n客と面会する。"
        },
        {
            "id": "265",
            "kanji": "所属",
            "n_read": "しょぞく",
            "kango_easy": "勤める",
            "e_read": "つとめる",
            "word_meaning": "สังกัด (ในองค์กร บริษัท แผนก กลุ่ม)",
            "word_usage": "คำนาม + に + 所属 + する",
            "word_ex": "彼は営業部に所属している。"
        },
        {
            "id": "266",
            "kanji": "対処",
            "n_read": "たいしょ",
            "kango_easy": "扱う",
            "e_read": "あつかう",
            "word_meaning": "รับมือ จัดการ (ปัญหา)",
            "word_usage": "คำนาม + に + 対処 + する",
            "word_ex": "問題に対処する。"
        },
        {
            "id": "267",
            "kanji": "接触",
            "n_read": "せっしょく",
            "kango_easy": "当たる",
            "e_read": "あたる",
            "word_meaning": "สัมผัส แตะ คบค้าสมาคม เจรจาติดต่อ",
            "word_usage": "คำนาม + に + 接触 + する",
            "word_ex": "彼の車は前の車に接触した。"
        },
        {
            "id": "268",
            "kanji": "努力",
            "n_read": "どりょく",
            "kango_easy": "頑張る",
            "e_read": "がんばる",
            "word_meaning": "เพียรพยายาม อุตสาหะ",
            "word_usage": "ประโยค + と + 努力 + する",
            "word_ex": "奨学金をもらおうと努力する。"
        },
        {
            "id": "269",
            "kanji": "保有",
            "n_read": "ほゆう",
            "kango_easy": "",
            "e_read": "いる",
            "word_meaning": "ครอบครอง ถือครอง \bเป็นเจ้าของ",
            "word_usage": "คำนาม + を + 保有 + する",
            "word_ex": "財産を保有する。"
        },
        {
            "id": "270",
            "kanji": "保有",
            "n_read": "ほゆう",
            "kango_easy": "",
            "e_read": "ある",
            "word_meaning": "ครอบครอง ถือครอง \bเป็นเจ้าของ",
            "word_usage": "คำนาม + を + 保有 + する",
            "word_ex": "財産を保有する。"
        },
        {
            "id": "271",
            "kanji": "保有",
            "n_read": "ほゆう",
            "kango_easy": "保つ",
            "e_read": "たもつ",
            "word_meaning": "ครอบครอง ถือครอง \bเป็นเจ้าของ",
            "word_usage": "คำนาม + を + 保有 + する",
            "word_ex": "財産を保有する。"
        },
        {
            "id": "272",
            "kanji": "規制",
            "n_read": "きせい",
            "kango_easy": "コントロール",
            "e_read": "",
            "word_meaning": "จำกัด ควบคุม (ตามกฎที่มีอยู่)",
            "word_usage": "คำนาม + を + 規制 + する",
            "word_ex": "数または量を規制する。"
        },
        {
            "id": "273",
            "kanji": "発動",
            "n_read": "はつどう",
            "kango_easy": "動かす",
            "e_read": "うごかす",
            "word_meaning": "เริ่มเคลื่อนไหว ใช้มาตรการ",
            "word_usage": "คำนาม + を + 発動 + する",
            "word_ex": "サーキットブレーカーを発動する。"
        },
        {
            "id": "274",
            "kanji": "発動",
            "n_read": "はつどう",
            "kango_easy": "使う",
            "e_read": "つかう",
            "word_meaning": "เริ่มเคลื่อนไหว ใช้มาตรการ",
            "word_usage": "คำนาม + を + 発動 + する",
            "word_ex": "サーキットブレーカーを発動する。"
        },
        {
            "id": "275",
            "kanji": "生産",
            "n_read": "せいさん",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "ผลิต (สิ่งที่มีความจำเป็นต่อการดำรงชีวิต เช่น อาหาร ไฟฟ้า เป็นต้น)\r\nเกิด ",
            "word_usage": "คำนาม + を + 生産 + する",
            "word_ex": "お米を生産する。"
        },
        {
            "id": "276",
            "kanji": "生産",
            "n_read": "せいさん",
            "kango_easy": "産む",
            "e_read": "うむ",
            "word_meaning": "ผลิต (สิ่งที่มีความจำเป็นต่อการดำรงชีวิต เช่น อาหาร ไฟฟ้า เป็นต้น)\r\nเกิด ",
            "word_usage": "คำนาม + を + 生産 + する",
            "word_ex": "お米を生産する。"
        },
        {
            "id": "277",
            "kanji": "停滞",
            "n_read": "ていたい",
            "kango_easy": "止まる",
            "e_read": "とまる",
            "word_meaning": "ชะลอ (ดำเนินต่อไปอย่างช้า ๆ )",
            "word_usage": "คำนาม + が + 停滞 + する",
            "word_ex": "事務が停滞する。"
        },
        {
            "id": "278",
            "kanji": "停滞",
            "n_read": "ていたい",
            "kango_easy": "遅れる",
            "e_read": "おくれる",
            "word_meaning": "ชะลอ (ดำเนินต่อไปอย่างช้า ๆ )",
            "word_usage": "คำนาม + が + 停滞 + する",
            "word_ex": "事務が停滞する。"
        },
        {
            "id": "279",
            "kanji": "発効",
            "n_read": "はっこう",
            "kango_easy": "効く",
            "e_read": "きく",
            "word_meaning": "มีผลบังคับใช้ (สัญญา กฎหมาย)",
            "word_usage": "คำนาม + を + 発効 + する",
            "word_ex": "法律を発効する。"
        },
        {
            "id": "280",
            "kanji": "記念",
            "n_read": "きねん",
            "kango_easy": "記す",
            "e_read": "きす",
            "word_meaning": "ที่ระลึก",
            "word_usage": "คำนาม + を + 記念 + する",
            "word_ex": "独立を記念する日。"
        },
        {
            "id": "281",
            "kanji": "視察",
            "n_read": "しさつ",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "ตรวจดู (ที่เกิดเหตุ) เฝ้าสังเกตการณ์",
            "word_usage": "คำนาม + を + 視察 + する",
            "word_ex": "現場を視察する。"
        },
        {
            "id": "282",
            "kanji": "視察",
            "n_read": "しさつ",
            "kango_easy": "改める",
            "e_read": "あらためる",
            "word_meaning": "ตรวจดู (ที่เกิดเหตุ) เฝ้าสังเกตการณ์",
            "word_usage": "คำนาม + を + 視察 + する",
            "word_ex": "現場を視察する。"
        },
        {
            "id": "283",
            "kanji": "視察",
            "n_read": "しさつ",
            "kango_easy": "見る",
            "e_read": "みる",
            "word_meaning": "ตรวจดู (ที่เกิดเหตุ) เฝ้าสังเกตการณ์",
            "word_usage": "คำนาม + を + 視察 + する",
            "word_ex": "現場を視察する。"
        },
        {
            "id": "284",
            "kanji": "躍進",
            "n_read": "やくしん",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "ก้าวหน้า พัฒนาอย่างก้าวกระโดด(ด้วยแรงขับเคลื่อนบางอย่าง)",
            "word_usage": "ประโยค + を+ 躍進 + する",
            "word_ex": "いつもベストの技術を目標に、私たちは躍進します。"
        },
        {
            "id": "285",
            "kanji": "投票",
            "n_read": "とうひょう",
            "kango_easy": "選ぶ",
            "e_read": "えらぶ",
            "word_meaning": "ลงคะแนนเสียง (โหวต)",
            "word_usage": "คำนาม + に + 投票 + する",
            "word_ex": "あの方に投票する。"
        },
        {
            "id": "286",
            "kanji": "認識",
            "n_read": "にんしき",
            "kango_easy": "気づく",
            "e_read": "きづく",
            "word_meaning": "สำนึก รับรู้ ",
            "word_usage": "คำนาม + を + 認識 + する",
            "word_ex": "政府はその問題を認識し始めた。"
        },
        {
            "id": "287",
            "kanji": "妨害",
            "n_read": "ぼうがい",
            "kango_easy": "邪魔する",
            "e_read": "じゃまする",
            "word_meaning": "กีดขวาง อุปสรรค",
            "word_usage": "คำนาม + を + 妨害 + する",
            "word_ex": "営業を妨害する。"
        },
        {
            "id": "288",
            "kanji": "妨害",
            "n_read": "ぼうがい",
            "kango_easy": "刺す",
            "e_read": "さす",
            "word_meaning": "กีดขวาง อุปสรรค",
            "word_usage": "คำนาม + を + 妨害 + する",
            "word_ex": "営業を妨害する。"
        },
        {
            "id": "289",
            "kanji": "終了",
            "n_read": "しゅうりょう",
            "kango_easy": "終わる",
            "e_read": "おわる",
            "word_meaning": "จบ เสร็จสิ้น",
            "word_usage": "คำนาม + は + 終了 + する",
            "word_ex": "試合は終了しました。"
        },
        {
            "id": "290",
            "kanji": "崩壊",
            "n_read": "ほうかい",
            "kango_easy": "崩れる",
            "e_read": "くずれる",
            "word_meaning": "พังทลาย ล่มสลาย พังลงมา",
            "word_usage": "คำนาม + は/が + 崩壊 + する",
            "word_ex": "組織が崩壊する。"
        },
        {
            "id": "291",
            "kanji": "警戒",
            "n_read": "けいかい",
            "kango_easy": "見る",
            "e_read": "みる",
            "word_meaning": "เฝ้าระวัง เตรียมพร้อมรับมือ",
            "word_usage": "คำนาม + を + 警戒 + する",
            "word_ex": "パンチを警戒する。"
        },
        {
            "id": "292",
            "kanji": "警戒",
            "n_read": "けいかい",
            "kango_easy": "気をつく",
            "e_read": "きをつく",
            "word_meaning": "เฝ้าระวัง เตรียมพร้อมรับมือ",
            "word_usage": "คำนาม + を + 警戒 + する",
            "word_ex": "パンチを警戒する。"
        },
        {
            "id": "293",
            "kanji": "警戒",
            "n_read": "けいかい",
            "kango_easy": "備える",
            "e_read": "そなえる",
            "word_meaning": "เฝ้าระวัง เตรียมพร้อมรับมือ",
            "word_usage": "คำนาม + を + 警戒 + する",
            "word_ex": "パンチを警戒する。"
        },
        {
            "id": "294",
            "kanji": "貢献",
            "n_read": "こうけん",
            "kango_easy": "役に立つ",
            "e_read": "やくにたつ",
            "word_meaning": "อุทิศตน (ทำสิ่งที่เป็นผลดีต่อสังคม)",
            "word_usage": "คำนาม + に + 貢献 + する",
            "word_ex": "私はこの仕事で社会に貢献する。"
        },
        {
            "id": "295",
            "kanji": "優先",
            "n_read": "ゆうせん",
            "kango_easy": "先",
            "e_read": "さき",
            "word_meaning": "ให้สิทธิ์ก่อน ให้ความสำคัญเป็นอันดับแรก",
            "word_usage": "คำนาม + を + 優先 + する",
            "word_ex": "私たちは寝ることを優先する。"
        },
        {
            "id": "296",
            "kanji": "任命",
            "n_read": "にんめい",
            "kango_easy": "命ずる",
            "e_read": "めいずる",
            "word_meaning": "แต่งตั้ง (ให้ทำหน้าที่ในตำแหน่งต่าง ๆ)",
            "word_usage": "ตำแหน่ง + に + 任命 + する",
            "word_ex": "議長に任命する。"
        },
        {
            "id": "297",
            "kanji": "任命",
            "n_read": "にんめい",
            "kango_easy": "任せる",
            "e_read": "まかせる",
            "word_meaning": "แต่งตั้ง (ให้ทำหน้าที่ในตำแหน่งต่าง ๆ)",
            "word_usage": "ตำแหน่ง + に + 任命 + する",
            "word_ex": "議長に任命する。"
        },
        {
            "id": "298",
            "kanji": "除外",
            "n_read": "じょがい",
            "kango_easy": "除く",
            "e_read": "のぞく",
            "word_meaning": "ยกเว้น ละเว้น งด",
            "word_usage": "คำนาม + を + 除外 + する",
            "word_ex": "ファイルシステムを除外する。"
        },
        {
            "id": "299",
            "kanji": "集中",
            "n_read": "しゅうちゅう",
            "kango_easy": "寄る",
            "e_read": "よる",
            "word_meaning": "มีสมาธิ (จดจ่ออยู่กับสิ่งที่ทำ)",
            "word_usage": "คำนาม + を + 集中 + する",
            "word_ex": "考えを集中する。"
        },
        {
            "id": "300",
            "kanji": "否決",
            "n_read": "ひけつ",
            "kango_easy": "拒む",
            "e_read": "こばむ",
            "word_meaning": "(สภา ที่ประชุม) มีมติไม่เห็นชอบ",
            "word_usage": "คำนาม + を + 否決 + する",
            "word_ex": "議会が議案を否決する。"
        },
        {
            "id": "301",
            "kanji": "飛行",
            "n_read": "ひこう",
            "kango_easy": "飛ぶ",
            "e_read": "とぶ",
            "word_meaning": "บิน (อย่างอิสระบนท้องฟ้า)",
            "word_usage": "คำนาม + を + 飛行 + する",
            "word_ex": "大空を飛行する。"
        },
        {
            "id": "302",
            "kanji": "謝罪",
            "n_read": "しゃざい",
            "kango_easy": "謝る",
            "e_read": "あやまる",
            "word_meaning": "ขอโทษ ขออภัย (ในความผิดที่ก่อ)",
            "word_usage": "ประโยค + を + 謝罪 + する\r\nบุคคล + に + 謝罪 + する",
            "word_ex": "迷惑をかけたことを謝罪する。\r\n私はあなたに謝罪する。"
        },
        {
            "id": "303",
            "kanji": "緩和",
            "n_read": "かんわ",
            "kango_easy": "緩める",
            "e_read": "ゆるめる",
            "word_meaning": "บรรเทา ผ่อนคลาย (ความตึงเครียดของสถานการณ์)",
            "word_usage": "คำนาม + を + 緩和 + する",
            "word_ex": "痛みを緩和する。"
        },
        {
            "id": "304",
            "kanji": "追及",
            "n_read": "ついきゅう",
            "kango_easy": "調査する",
            "e_read": "ちょうさする",
            "word_meaning": "การถามหาสาเหตุ ความรับผิดชอบ ข้อบกพร่อง\r\nไล่ตาม",
            "word_usage": "คำนาม + を + 追及 + する",
            "word_ex": "犯人の行方を追及する。\r\n彼らはその事故に対する彼の責任を追及した。"
        },
        {
            "id": "305",
            "kanji": "減速",
            "n_read": "げんそく",
            "kango_easy": "遅くする",
            "e_read": "おそくする",
            "word_meaning": "ลดความเร็วลง",
            "word_usage": "คำนาม + を + 減速 + する",
            "word_ex": "減速ギア部５はモータ３の回転を減速する。"
        },
        {
            "id": "306",
            "kanji": "証言",
            "n_read": "しょうげん",
            "kango_easy": "教える",
            "e_read": "おしえる",
            "word_meaning": "ยื่นคำให้การ เบิกคำให้การของพยาน",
            "word_usage": "คำนาม + を + 証言 + する",
            "word_ex": "ある事実を証言する。"
        },
        {
            "id": "307",
            "kanji": "証言",
            "n_read": "しょうげん",
            "kango_easy": "言う",
            "e_read": "いう",
            "word_meaning": "ยื่นคำให้การ เบิกคำให้การของพยาน",
            "word_usage": "คำนาม + を + 証言 + する",
            "word_ex": "ある事実を証言する。"
        },
        {
            "id": "308",
            "kanji": "着陸",
            "n_read": "ちゃくりく",
            "kango_easy": "着く",
            "e_read": "つく",
            "word_meaning": "ลงจอด (ใช้กับยานพาหนะจำพวกเครื่องบิน)",
            "word_usage": "สถานที่ + に + 着陸 + する",
            "word_ex": "羽田空港に無事着陸する。"
        },
        {
            "id": "309",
            "kanji": "監視",
            "n_read": "かんし",
            "kango_easy": "視る",
            "e_read": "みる",
            "word_meaning": "เฝ้าระวัง จับตามอง (เพื่อไม่ให้เกิดเรื่องไม่ดี หรือเหตุอันตราย)",
            "word_usage": "คำนาม + を + 監視 + する",
            "word_ex": "囚人を監視する人。"
        },
        {
            "id": "310",
            "kanji": "緊迫",
            "n_read": "きんぱく",
            "kango_easy": "緊張する",
            "e_read": "きんちょうする",
            "word_meaning": "กังวล ตึงเครียด (สถานการณ์)",
            "word_usage": "คำนาม + が + 緊迫 + する",
            "word_ex": "事態が緊迫する。"
        },
        {
            "id": "311",
            "kanji": "発砲",
            "n_read": "はっぽう",
            "kango_easy": "撃つ",
            "e_read": "うつ",
            "word_meaning": "ยิงของที่มีกระสุน (แบบเล็ง)",
            "word_usage": "คำนาม + を + 発砲 + する",
            "word_ex": "敵に向けて銃を発砲する。"
        },
        {
            "id": "312",
            "kanji": "支配",
            "n_read": "しはい",
            "kango_easy": "制する",
            "e_read": "せいする",
            "word_meaning": "ปกครอง ครอบงำ บัญชาการ",
            "word_usage": "คำนาม + を + 支配 + する",
            "word_ex": "国を支配する。"
        },
        {
            "id": "313",
            "kanji": "放送",
            "n_read": "ほうそう",
            "kango_easy": "送る",
            "e_read": "おくる",
            "word_meaning": "ออกอากาศ (ถ่ายทอดผ่านจานดาวเทียม)",
            "word_usage": "คำนาม + を + 放送 + する",
            "word_ex": "ニュースを放送する"
        },
        {
            "id": "314",
            "kanji": "放送",
            "n_read": "ほうそう",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "ออกอากาศ (ถ่ายทอดผ่านจานดาวเทียม)",
            "word_usage": "คำนาม + を + 放送 + する",
            "word_ex": "ニュースを放送する"
        },
        {
            "id": "315",
            "kanji": "活躍",
            "n_read": "かつやく",
            "kango_easy": "",
            "e_read": "やる",
            "word_meaning": "มีผลงาน มีบทบาท (ในวงการต่าง ๆ เช่นวงการบันเทิง วงการวรรณกรรม)",
            "word_usage": "คำนาม + が + คำนาม (สถานที่) + ​​で + 活躍する",
            "word_ex": "海外で活躍する。"
        },
        {
            "id": "316",
            "kanji": "反映",
            "n_read": "はんえい",
            "kango_easy": "映る",
            "e_read": "うつる",
            "word_meaning": "สะท้อน (แสง สภาพสังคมเศรษฐกิจ) มีอิทธิพลต่อ",
            "word_usage": "คำนาม + を + 反映 + する",
            "word_ex": "光や色などを反映する。\r\n影響を反映する。"
        },
        {
            "id": "317",
            "kanji": "放送",
            "n_read": "ほうそう",
            "kango_easy": "送る",
            "e_read": "おくる",
            "word_meaning": "ออกอากาศ (ถ่ายทอดผ่านจานดาวเทียม)",
            "word_usage": "คำนาม + を + 放送 + する",
            "word_ex": "ニュースを放送する"
        },
        {
            "id": "318",
            "kanji": "隣接",
            "n_read": "りんせつ",
            "kango_easy": "隣",
            "e_read": "となり",
            "word_meaning": "ติดกัน ข้างเคียง (ดินแดน อาณาเขต)",
            "word_usage": "สถานที่ + に + 隣接 + する",
            "word_ex": "フランスはスペインに隣接する。"
        },
        {
            "id": "319",
            "kanji": "回避",
            "n_read": "かいひ",
            "kango_easy": "避ける",
            "e_read": "さける",
            "word_meaning": "หลีกเลี่ยง หลบหลีก เอาตัวรอด",
            "word_usage": "คำนาม + を + 回避 + する",
            "word_ex": "責任を回避する。"
        },
        {
            "id": "320",
            "kanji": "回避",
            "n_read": "かいひ",
            "kango_easy": "逃げる",
            "e_read": "にげる",
            "word_meaning": "หลีกเลี่ยง หลบหลีก เอาตัวรอด",
            "word_usage": "คำนาม + を + 回避 + する",
            "word_ex": "責任を回避する。"
        },
        {
            "id": "321",
            "kanji": "逃亡",
            "n_read": "とうぼう",
            "kango_easy": "逃げる",
            "e_read": "にげる",
            "word_meaning": "หลบหนี หนีคดี (คนร้าย)",
            "word_usage": "คำนาม + から + 逃亡 + する",
            "word_ex": "刑務所から逃亡する。"
        },
        {
            "id": "322",
            "kanji": "管理",
            "n_read": "かんり",
            "kango_easy": "メンテナンス",
            "e_read": "",
            "word_meaning": "ดูแลรักษา \bบริหารจัดการ",
            "word_usage": "คำนาม + を + 管理 + する",
            "word_ex": "彼が会社のお金を管理している。"
        },
        {
            "id": "323",
            "kanji": "参列",
            "n_read": "さんれつ",
            "kango_easy": "出席する",
            "e_read": "しゅっせきする",
            "word_meaning": "เข้าร่วมพิธี (ทางการ)",
            "word_usage": "คำนาม + に + 隣接 + する",
            "word_ex": "礼拝に参列する。"
        },
        {
            "id": "324",
            "kanji": "参列",
            "n_read": "さんれつ",
            "kango_easy": "集まる",
            "e_read": "あつまる",
            "word_meaning": "เข้าร่วมพิธี (ทางการ)",
            "word_usage": "คำนาม + に + 隣接 + する",
            "word_ex": "礼拝に参列する。"
        },
        {
            "id": "325",
            "kanji": "通過",
            "n_read": "つうか",
            "kango_easy": "通る",
            "e_read": "とおる",
            "word_meaning": "เคลื่อนที่ผ่าน (จากจุดหนึ่งไปอีกจุดหนึ่ง)\r\nผ่านไปได้ด้วยดี",
            "word_usage": "คำนาม + を + 参列 + する",
            "word_ex": " 京都の上空を通過する。"
        },
        {
            "id": "326",
            "kanji": "拡散",
            "n_read": "かくさん",
            "kango_easy": "広がる",
            "e_read": "ひろがる",
            "word_meaning": "แพร่กระจาย กระจัดกระจาย (แก๊ส ของเหลว)",
            "word_usage": "คำนาม + を + 拡散 + する",
            "word_ex": "ガスを拡散する。"
        },
        {
            "id": "327",
            "kanji": "講演",
            "n_read": "こうえん",
            "kango_easy": "レクチャー",
            "e_read": "",
            "word_meaning": "บรรยาย ปราศรัย",
            "word_usage": "คำนาม + について + 講演 + する",
            "word_ex": "地球温暖化について講演する。"
        },
        {
            "id": "328",
            "kanji": "講演",
            "n_read": "こうえん",
            "kango_easy": "教える",
            "e_read": "おしえる",
            "word_meaning": "บรรยาย ปราศรัย",
            "word_usage": "คำนาม + について + 講演 + する",
            "word_ex": "地球温暖化について講演する。"
        },
        {
            "id": "329",
            "kanji": "進展",
            "n_read": "しんてん",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "ก้าวไปข้างหน้า (เน้นว่าเกิดสิ่งใหม่ ไม่สนว่าดีหรือไม่ดี)",
            "word_usage": "คำนาม + は/が + 進展 + する",
            "word_ex": "彼の考えが進展するのに長い年月がかかった。"
        },
        {
            "id": "330",
            "kanji": "推進",
            "n_read": "すいしん",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "ผลักดัน ขับเคลื่อน มุ่งไปข้างหน้า (ให้ถึงเป้าหมาย)",
            "word_usage": "คำนาม + を + 推進 + する",
            "word_ex": "彼はその活動を推進する。"
        },
        {
            "id": "331",
            "kanji": "誕生",
            "n_read": "たんじょう",
            "kango_easy": "生まれる",
            "e_read": "うまれる",
            "word_meaning": "เกิด กำเนิด",
            "word_usage": "สถานที่ + で + 誕生 + する",
            "word_ex": "京都で誕生する。"
        },
        {
            "id": "332",
            "kanji": "投入",
            "n_read": "とうにゅう",
            "kango_easy": "投げる",
            "e_read": "なげる",
            "word_meaning": "ขว้าง\r\nลงทุน (ทุน แรงงาน เป็นต้น)",
            "word_usage": "คำนาม + を + 投入 + する",
            "word_ex": "経済活動で,資本を投入する。"
        },
        {
            "id": "333",
            "kanji": "投入",
            "n_read": "とうにゅう",
            "kango_easy": "入れる",
            "e_read": "なげる、いれる",
            "word_meaning": "ขว้าง\r\nลงทุน (ทุน แรงงาน เป็นต้น)",
            "word_usage": "คำนาม + を + 投入 + する",
            "word_ex": "経済活動で,資本を投入する。"
        },
        {
            "id": "334",
            "kanji": "圧勝",
            "n_read": "あっしょう",
            "kango_easy": "勝つ",
            "e_read": "かつ",
            "word_meaning": "ชนะขาดลอย",
            "word_usage": "คะแนน/การแข่งขัน + で + 圧勝 + する",
            "word_ex": "ジャイアンツはタイガースに10対1で圧勝した。"
        },
        {
            "id": "335",
            "kanji": "低迷",
            "n_read": "ていめい",
            "kango_easy": "悪い",
            "e_read": "わるい",
            "word_meaning": "(เมฆ) ลอยต่ำ\r\nสถานการณ์ย่ำแย่ ตกต่ำ​(เศรษฐกิจ)",
            "word_usage": "คำนาม + は/が + 低迷 + する",
            "word_ex": "暗雲が低迷する。\r\n景気が低迷する。"
        },
        {
            "id": "336",
            "kanji": "低迷",
            "n_read": "ていめい",
            "kango_easy": "迷う",
            "e_read": "まよう",
            "word_meaning": "(เมฆ) ลอยต่ำ\r\nสถานการณ์ย่ำแย่ ตกต่ำ​(เศรษฐกิจ)",
            "word_usage": "คำนาม + は/が + 低迷 + する",
            "word_ex": "暗雲が低迷する。\r\n景気が低迷する。"
        },
        {
            "id": "337",
            "kanji": "確定",
            "n_read": "かくてい",
            "kango_easy": "決める",
            "e_read": "きめる",
            "word_meaning": "กำหนดแน่นอน ตัดสินชี้ขาด",
            "word_usage": "คำนาม + を + 確定 + する",
            "word_ex": "会合の日を確定する。"
        },
        {
            "id": "338",
            "kanji": "確定",
            "n_read": "かくてい",
            "kango_easy": "確か",
            "e_read": "たしか",
            "word_meaning": "กำหนดแน่นอน ตัดสินชี้ขาด",
            "word_usage": "คำนาม + を + 確定 + する",
            "word_ex": "会合の日を確定する。"
        },
        {
            "id": "339",
            "kanji": "入手",
            "n_read": "にゅうしゅ",
            "kango_easy": "入る",
            "e_read": "はいる",
            "word_meaning": "เป็นเจ้าของ (ได้รับมาเป็นของตัวเอง)",
            "word_usage": "คำนาม + を + 入手 + する",
            "word_ex": "情報を入手する。"
        },
        {
            "id": "340",
            "kanji": "入手",
            "n_read": "にゅうしゅ",
            "kango_easy": "",
            "e_read": "もらう",
            "word_meaning": "เป็นเจ้าของ (ได้รับมาเป็นของตัวเอง)",
            "word_usage": "คำนาม + を + 入手 + する",
            "word_ex": "情報を入手する。"
        },
        {
            "id": "341",
            "kanji": "行動",
            "n_read": "こうどう",
            "kango_easy": "",
            "e_read": "やる",
            "word_meaning": "กระทำ ลงมือ เคลื่อนไหว",
            "word_usage": "คำนาม + は/が + 行動 + する",
            "word_ex": "私は前向きに行動する。"
        },
        {
            "id": "342",
            "kanji": "行動",
            "n_read": "こうどう",
            "kango_easy": "動く",
            "e_read": "うごく",
            "word_meaning": "กระทำ ลงมือ เคลื่อนไหว",
            "word_usage": "คำนาม + は/が + 行動 + する",
            "word_ex": "私は前向きに行動する。"
        },
        {
            "id": "343",
            "kanji": "整備",
            "n_read": "せいび",
            "kango_easy": "整える",
            "e_read": "ととのえる",
            "word_meaning": "เตรียมความพร้อม\r\nปรับให้เหมาะสม",
            "word_usage": "คำนาม + を + 整備 + する",
            "word_ex": "野球場を整備する。"
        },
        {
            "id": "344",
            "kanji": "整備",
            "n_read": "せいび",
            "kango_easy": "備える",
            "e_read": "そなえる",
            "word_meaning": "เตรียมความพร้อม\r\nปรับให้เหมาะสม",
            "word_usage": "คำนาม + を + 整備 + する",
            "word_ex": "野球場を整備する。"
        },
        {
            "id": "345",
            "kanji": "解消",
            "n_read": "かいしょう",
            "kango_easy": "",
            "e_read": "キャンセル",
            "word_meaning": "ยกเลิก (สัญญา งานหมั้น)\r\nผ่อนคลาย (ความเครียด)",
            "word_usage": "คำนาม + を + 解消 + する",
            "word_ex": "契約を解消する。"
        },
        {
            "id": "346",
            "kanji": "発言",
            "n_read": "はつげん",
            "kango_easy": "話す",
            "e_read": "はなす",
            "word_meaning": "พูด (แสดงความเห็นออกมา)",
            "word_usage": "คำนาม + は/が + 発言 + する",
            "word_ex": "あなたは発言するか静かにしているかどちらかにしてください。"
        },
        {
            "id": "347",
            "kanji": "発言",
            "n_read": "はつげん",
            "kango_easy": "意見",
            "e_read": "いけん",
            "word_meaning": "พูด (แสดงความเห็นออกมา)",
            "word_usage": "คำนาม + は/が + 発言 + する",
            "word_ex": "あなたは発言するか静かにしているかどちらかにしてください。"
        },
        {
            "id": "348",
            "kanji": "当選",
            "n_read": "とうせん",
            "kango_easy": "選ばれる",
            "e_read": "えらばれる",
            "word_meaning": "ได้รับเลือก (จากการเลือกตั้ง โหวต)",
            "word_usage": "คำนาม + に + 当選 + する",
            "word_ex": "国会議員に当選する。"
        },
        {
            "id": "349",
            "kanji": "落札",
            "n_read": "らくさつ",
            "kango_easy": "勝つ",
            "e_read": "かつ",
            "word_meaning": "ชนะประมูล",
            "word_usage": "คำนาม + を + 落札 + する",
            "word_ex": "我が社はそのビル建設の請負契約を落札する。"
        },
        {
            "id": "350",
            "kanji": "射殺",
            "n_read": "しゃさつ",
            "kango_easy": "射つ",
            "e_read": "うつ",
            "word_meaning": "ฆ่าด้วยการยิงปืนหรือธนู",
            "word_usage": "กรรม + を + 落札 + する",
            "word_ex": "俺は彼を射殺してやる。"
        },
        {
            "id": "351",
            "kanji": "出演",
            "n_read": "しゅつえん",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "เล่น ละคร แสดง​ (ละคร ภาพยนต์)",
            "word_usage": "คำนาม + に + 出演 + する",
            "word_ex": "彼女はドラマに出演しています。"
        },
        {
            "id": "352",
            "kanji": "出演",
            "n_read": "しゅつえん",
            "kango_easy": "演じる",
            "e_read": "えんじる",
            "word_meaning": "เล่น ละคร แสดง​ (ละคร ภาพยนต์)",
            "word_usage": "คำนาม + に + 出演 + する",
            "word_ex": "彼女はドラマに出演しています。"
        },
        {
            "id": "353",
            "kanji": "中断",
            "n_read": "ちゅうだん",
            "kango_easy": "止める",
            "e_read": "とめる",
            "word_meaning": "ขัดจังหวะ ไม่ต่อเนื่อง",
            "word_usage": "คำนาม + を + 中断 + する",
            "word_ex": "人の思考の流れを中断する。"
        },
        {
            "id": "354",
            "kanji": "結束",
            "n_read": "けっそく",
            "kango_easy": "一緒にする",
            "e_read": "いっしょにする",
            "word_meaning": "ผูกหรือมัดรวมไว้ด้วยเชือก\r\nเป็นน้ำหนึ่งใจเดียวกัน",
            "word_usage": "คำนาม + を + 結束 + する",
            "word_ex": "紐で部品を結束する。"
        },
        {
            "id": "355",
            "kanji": "招待",
            "n_read": "しょうたい",
            "kango_easy": "招く",
            "e_read": "まねく",
            "word_meaning": "เชิญ เรียนเชิญ",
            "word_usage": "คำนาม + に + 招待 + する",
            "word_ex": "私は彼女をご飯に招待するつもりです。"
        },
        {
            "id": "356",
            "kanji": "所有",
            "n_read": "しょゆう",
            "kango_easy": "",
            "e_read": "ある",
            "word_meaning": "ครอบครอง กรรมสิทธิ์",
            "word_usage": "คำนาม + を + 所有 + する",
            "word_ex": "小さな店を所有する。"
        },
        {
            "id": "357",
            "kanji": "所有",
            "n_read": "しょゆう",
            "kango_easy": "持っている",
            "e_read": "もっている",
            "word_meaning": "ครอบครอง กรรมสิทธิ์",
            "word_usage": "คำนาม + を + 所有 + する",
            "word_ex": "小さな店を所有する。"
        },
        {
            "id": "358",
            "kanji": "解任",
            "n_read": "かいにん",
            "kango_easy": "",
            "e_read": "やめる",
            "word_meaning": "ปลด (ออกจากตำแหน่ง หน้าที่ งานที่มอบหมาย)",
            "word_usage": "คำนาม + を + 解任 + する",
            "word_ex": "会長を解任する。"
        },
        {
            "id": "359",
            "kanji": "発行",
            "n_read": "はっこう",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "ตีพิมพ์ พิมพ์ออกมา",
            "word_usage": "คำนาม + を + 発行 + する",
            "word_ex": "切手を発行する。"
        },
        {
            "id": "360",
            "kanji": "履行",
            "n_read": "りこう",
            "kango_easy": "",
            "e_read": "やる",
            "word_meaning": "ทำตาม (คำสั่ง สัญญา)",
            "word_usage": "คำนาม + を + 履行 + する",
            "word_ex": "約束を履行する。"
        },
        {
            "id": "361",
            "kanji": "推定",
            "n_read": "すいてい",
            "kango_easy": "測る",
            "e_read": "はかる",
            "word_meaning": "สันนิษฐาน คาดเดา (รวบรวมหลักฐานแล้วค่อยตัดสินใจ)",
            "word_usage": "คำนาม + を + 推定 + する",
            "word_ex": "心を推定する能力。"
        },
        {
            "id": "362",
            "kanji": "手配",
            "n_read": "てはい",
            "kango_easy": "準備する",
            "e_read": "じゅんびする",
            "word_meaning": "เตรียมการจัดการ (จัดเตรียมตามขั้นตอนต่าง ๆ ก่อนที่จะทำบางสิ่ง)",
            "word_usage": "คำนาม + を + 手配 + する",
            "word_ex": "航空券を手配する。"
        },
        {
            "id": "363",
            "kanji": "適用",
            "n_read": "てきよう",
            "kango_easy": "当てはまる",
            "e_read": "あてはまる",
            "word_meaning": "นำมาใช้ (กฎ กฎหมาย) ประยุกต์ใช้",
            "word_usage": "คำนาม + を + 適用 + する",
            "word_ex": "私たちはその工事にこの工法を適用する。"
        },
        {
            "id": "364",
            "kanji": "収集",
            "n_read": "しゅうしゅう",
            "kango_easy": "集める",
            "e_read": "あつめる",
            "word_meaning": "เก็บ สะสม รวบรวม",
            "word_usage": "คำนาม + を + 収集 + する",
            "word_ex": "情報を収集する。"
        },
        {
            "id": "365",
            "kanji": "阻止",
            "n_read": "そし",
            "kango_easy": "",
            "e_read": "やめる",
            "word_meaning": "ระงับ ล้มเลิก (ไม่ให้ฝ่ายตรงข้ามทำสิ่งที่อยากทำ)",
            "word_usage": "คำนาม + を + 阻止 + する",
            "word_ex": "計画を阻止する。"
        },
        {
            "id": "366",
            "kanji": "予測",
            "n_read": "よそく",
            "kango_easy": "測る",
            "e_read": "はかる",
            "word_meaning": "คาดคะเน กะปริมาณ คาดเดา (ถึงเรื่องในอนาคต)",
            "word_usage": "คำนาม + を + 予測 + する",
            "word_ex": "未来を予測する。"
        },
        {
            "id": "367",
            "kanji": "乗船",
            "n_read": "じょうせん",
            "kango_easy": "乗る",
            "e_read": "のる",
            "word_meaning": "ขึ้นเรือ",
            "word_usage": "คำนาม + に + 乗船 + する",
            "word_ex": "フェリーに乗船する"
        },
        {
            "id": "368",
            "kanji": "敵対",
            "n_read": "てきたい",
            "kango_easy": "",
            "e_read": "ライバル",
            "word_meaning": "เป็นศัตรู ตั้งตนเป็นปรปักษ์",
            "word_usage": "คำนาม + に + 敵対 + する",
            "word_ex": "相手に敵対しようとする心"
        },
        {
            "id": "369",
            "kanji": "失効",
            "n_read": "しっこう",
            "kango_easy": "効かない",
            "e_read": "きかない",
            "word_meaning": "ไม่มีผลบังคับใช้ (กฎหมายหรือใบรับประกัน)",
            "word_usage": "คำนาม + は/が + 失効 + する",
            "word_ex": "優先権は失効する。"
        },
        {
            "id": "370",
            "kanji": "締結",
            "n_read": "ていけつ",
            "kango_easy": "",
            "e_read": "やる",
            "word_meaning": "ทำ (สนธิสัญญา)",
            "word_usage": "คำนาม + を + 締結 + する",
            "word_ex": "平和条約を締結する。"
        },
        {
            "id": "371",
            "kanji": "罷免",
            "n_read": "ひめん",
            "kango_easy": "",
            "e_read": "やめる",
            "word_meaning": "ถอดถอน ให้ออกจากงาน (เนื่องจากทำผิด)",
            "word_usage": "คำนาม + を + 罷免 + する",
            "word_ex": "国務大臣を罷免する。"
        },
        {
            "id": "372",
            "kanji": "拿捕",
            "n_read": "だほ",
            "kango_easy": "捕まえる",
            "e_read": "つかまえる",
            "word_meaning": "จับกุม (เรือ เรื่องต่างประเทศ)",
            "word_usage": "คำนาม + を + 拿捕 + する",
            "word_ex": "日本の漁船を拿捕する。"
        },
        {
            "id": "373",
            "kanji": "観測",
            "n_read": "かんそく",
            "kango_easy": "見つける",
            "e_read": "みつける",
            "word_meaning": "สังเกตการณ์ (สภาพอากาศ ดาราศาสตร์)",
            "word_usage": "คำนาม + を + 観測 + する",
            "word_ex": "毎夜星を観測する。"
        },
        {
            "id": "374",
            "kanji": "観測",
            "n_read": "かんそく",
            "kango_easy": "察する",
            "e_read": "さっする",
            "word_meaning": "สังเกตการณ์ (สภาพอากาศ ดาราศาสตร์)",
            "word_usage": "คำนาม + を + 観測 + する",
            "word_ex": "毎夜星を観測する。"
        },
        {
            "id": "375",
            "kanji": "達成",
            "n_read": "たっせい",
            "kango_easy": "",
            "e_read": "できる",
            "word_meaning": "ประสบความสำเร็จ",
            "word_usage": "คำนาม + を + 達成 + する",
            "word_ex": "目標を達成する。"
        },
        {
            "id": "376",
            "kanji": "製造",
            "n_read": "せいぞう",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "ผลิต (นำวัตถุดิบมาผลิตเป็นสินค้า)",
            "word_usage": "คำนาม + を + 製造 + する",
            "word_ex": "多くの会社が海外で商品を製造し始めた。"
        },
        {
            "id": "377",
            "kanji": "救助",
            "n_read": "きゅうじょ",
            "kango_easy": "助ける",
            "e_read": "たすける",
            "word_meaning": "ให้ความช่วยเหลือ (ชีวิต)",
            "word_usage": "คำนาม + を + 救助 + する",
            "word_ex": "人命を救助する。"
        },
        {
            "id": "378",
            "kanji": "考慮",
            "n_read": "こうりょ",
            "kango_easy": "考える",
            "e_read": "かんがえる",
            "word_meaning": "พิจารณา ไตร่ตรอง ใคร่ครวญ (คิดแล้วคิดอีก)",
            "word_usage": "คำนาม + を + 考慮 + する",
            "word_ex": "彼の要求を考慮する。"
        },
        {
            "id": "379",
            "kanji": "失敗",
            "n_read": "しっぱい",
            "kango_easy": "誤まる",
            "e_read": "あやまる",
            "word_meaning": "ผิดพลาด ล้มเหลว",
            "word_usage": "คำนาม + に + 失敗 + する",
            "word_ex": "彼は試験に失敗した。"
        },
        {
            "id": "380",
            "kanji": "特定",
            "n_read": "とくてい",
            "kango_easy": "特に",
            "e_read": "とくに",
            "word_meaning": "เจาะจงโดยเฉพาะ",
            "word_usage": "คำนาม + を + 特定 + する",
            "word_ex": "その船の位置を特定する。"
        },
        {
            "id": "381",
            "kanji": "特定",
            "n_read": "とくてい",
            "kango_easy": "決める",
            "e_read": "きめる",
            "word_meaning": "เจาะจงโดยเฉพาะ",
            "word_usage": "คำนาม + を + 特定 + する",
            "word_ex": "その船の位置を特定する。"
        },
        {
            "id": "382",
            "kanji": "特定",
            "n_read": "とくてい",
            "kango_easy": "選ぶ",
            "e_read": "えらぶ",
            "word_meaning": "เจาะจงโดยเฉพาะ",
            "word_usage": "คำนาม + を + 特定 + する",
            "word_ex": "その船の位置を特定する。"
        },
        {
            "id": "383",
            "kanji": "通知",
            "n_read": "つうち",
            "kango_easy": "知らせる",
            "e_read": "しらせる",
            "word_meaning": "แจ้ง ประกาศ (แจ้งเตือนให้ทราบ)",
            "word_usage": "คำนาม + を + 通知 + する",
            "word_ex": "新しい住所を通知する。"
        },
        {
            "id": "384",
            "kanji": "回答",
            "n_read": "かいとう",
            "kango_easy": "答える",
            "e_read": "こたえる",
            "word_meaning": "ตอบ (คำถาม)",
            "word_usage": "คำนาม + に + 回答 + する",
            "word_ex": "質問に回答します。"
        },
        {
            "id": "385",
            "kanji": "把握",
            "n_read": "はあく",
            "kango_easy": "分かる",
            "e_read": "わかる",
            "word_meaning": "จับประเด็น จับใจความสำคัญ",
            "word_usage": "คำนาม + を + 把握 + する",
            "word_ex": "その意味を把握する。"
        },
        {
            "id": "386",
            "kanji": "流出",
            "n_read": "りゅうしゅつ",
            "kango_easy": "流れる",
            "e_read": "ながれる",
            "word_meaning": "ไหลออก (ทรัพย์สิน ความลับ)",
            "word_usage": "จุดหมาย + に + 流出 + する",
            "word_ex": "金銭などが外部に流出する。"
        },
        {
            "id": "387",
            "kanji": "模索",
            "n_read": "もさく",
            "kango_easy": "探す",
            "e_read": "さがす",
            "word_meaning": "ควานหา ค้นหา (เพื่อให้ได้คำตอบ)",
            "word_usage": "คำนาม + を + 模索 + する",
            "word_ex": "彼は自分の本当の気持ちを表現してくれる言葉を模索した。"
        },
        {
            "id": "388",
            "kanji": "制圧",
            "n_read": "せいあつ",
            "kango_easy": "コントロール",
            "e_read": "",
            "word_meaning": "กำราบ ควบคุม (คน)",
            "word_usage": "คำนาม + を + 制圧 + する",
            "word_ex": "敵を制圧する。"
        },
        {
            "id": "389",
            "kanji": "搬送",
            "n_read": "はんそう",
            "kango_easy": "運ぶ",
            "e_read": "はこぶ",
            "word_meaning": "ส่ง (โรงพยาบาล) ขนส่ง โยกย้าย",
            "word_usage": "สถานที่ + に/まで + 搬送 + する",
            "word_ex": "負傷者が病院に搬送される。"
        },
        {
            "id": "390",
            "kanji": "配慮",
            "n_read": "はいりょ",
            "kango_easy": "思いやり",
            "e_read": "おもいやる",
            "word_meaning": "เอาใจใส่ คิดถึงผู้อื่น คำนึงถึง",
            "word_usage": "คำนาม + を + 配慮 + する\r\nคำนาม + に + 配慮 + する",
            "word_ex": "彼の気持ちを配慮する。\r\n判決を下す際に彼の若さに配慮する。"
        },
        {
            "id": "391",
            "kanji": "発症",
            "n_read": "はっしょう",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "อาการ (ของโรค) ออก เกิดโรคขึ้น",
            "word_usage": "ชื่อโรค + を + 発症 + する",
            "word_ex": "彼は脳出血を発症する。"
        },
        {
            "id": "392",
            "kanji": "経由",
            "n_read": "けいゆ",
            "kango_easy": "通る",
            "e_read": "とおる",
            "word_meaning": "เดินทางผ่าน ผ่านทาง...",
            "word_usage": "คำนาม + を + 経由 + する",
            "word_ex": "仏教は朝鮮を経由して日本へ伝わった。"
        },
        {
            "id": "393",
            "kanji": "順守",
            "n_read": "じゅんしゅ",
            "kango_easy": "守る",
            "e_read": "まもる",
            "word_meaning": "ปฏิบัติตาม (กฎหมาย) อย่างเคร่งครัด",
            "word_usage": "คำนาม + を + 順守 + する",
            "word_ex": "法律を順守する。"
        },
        {
            "id": "394",
            "kanji": "激化",
            "n_read": "げきか",
            "kango_easy": "悪くなる",
            "e_read": "わるくなる",
            "word_meaning": "ร้ายแรงขึ้น รุนแรงขึ้น เลยร้ายกว่าเดิม",
            "word_usage": "คำนาม + は/が + 激化 + する",
            "word_ex": "店舗間の競争は激化する。"
        },
        {
            "id": "395",
            "kanji": "登場",
            "n_read": "とうじょう",
            "kango_easy": "表す",
            "e_read": "あらわす",
            "word_meaning": "ปรากฏตัว (คน สิ่งของ)",
            "word_usage": "คำนาม + に + 登場 + する",
            "word_ex": "あの歌手は最近よくテレビのクイズ番組に登場している。"
        },
        {
            "id": "396",
            "kanji": "釈放",
            "n_read": "しゃくほう",
            "kango_easy": "放す",
            "e_read": "はなす",
            "word_meaning": "ปลดปล่อย ปล่อยตัว",
            "word_usage": "คำนาม + を + 釈放 + する",
            "word_ex": "囚人を釈放する。"
        },
        {
            "id": "397",
            "kanji": "独立",
            "n_read": "どくりつ",
            "kango_easy": "自立",
            "e_read": "じりつ",
            "word_meaning": "เป็นอิสระ เป็นเอกราช แยกออกมาจาก",
            "word_usage": "คำนาม + から + 独立 + する",
            "word_ex": "インドは1947年英国から独立した。"
        },
        {
            "id": "398",
            "kanji": "独立",
            "n_read": "どくりつ",
            "kango_easy": "自由になる",
            "e_read": "じゆうになる",
            "word_meaning": "เป็นอิสระ เป็นเอกราช แยกออกมาจาก",
            "word_usage": "คำนาม + から + 独立 + する",
            "word_ex": "インドは1947年英国から独立した。"
        },
        {
            "id": "399",
            "kanji": "前進",
            "n_read": "ぜんしん",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "เดินหน้า ไปข้างหน้า",
            "word_usage": "คำนาม + を + 前進 + する",
            "word_ex": "国を前進する。"
        },
        {
            "id": "400",
            "kanji": "航行",
            "n_read": "こうこう",
            "kango_easy": "行く",
            "e_read": "いく",
            "word_meaning": "เดินเรือ (เรือ ยานอวกาศ)",
            "word_usage": "สถานที่ + を + 航行 + する",
            "word_ex": "太平洋を航行する。"
        },
        {
            "id": "401",
            "kanji": "取得",
            "n_read": "しゅとく",
            "kango_easy": "得る",
            "e_read": "える",
            "word_meaning": "หามาได้ ได้รับ ไขว่คว้ามาได้)",
            "word_usage": "คำนาม + を + 取得 + する",
            "word_ex": "同社の株式の7パーセントを取得する。"
        },
        {
            "id": "402",
            "kanji": "行進",
            "n_read": "こうしん",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "เดินขบวน เดินพาเรด",
            "word_usage": "สถานที่ + を + 行進 + する\r\nประธาน + は/が + 行進 + する",
            "word_ex": "町中を行進する。"
        },
        {
            "id": "403",
            "kanji": "存在",
            "n_read": "そんざい",
            "kango_easy": "",
            "e_read": "いる",
            "word_meaning": "มีตัวตนอยู่ มีอยู่",
            "word_usage": "คำนาม + は/が + 存在 + する",
            "word_ex": "ウィルスは人類が存在する限り存在するであろう。"
        },
        {
            "id": "404",
            "kanji": "存在",
            "n_read": "そんざい",
            "kango_easy": "",
            "e_read": "ある",
            "word_meaning": "มีตัวตนอยู่ มีอยู่",
            "word_usage": "คำนาม + は/が + 存在 + する",
            "word_ex": "ウィルスは人類が存在する限り存在するであろう。"
        },
        {
            "id": "405",
            "kanji": "無視",
            "n_read": "むし",
            "kango_easy": "見ない",
            "e_read": "みない",
            "word_meaning": "ไม่สนใจ เมิน มองข้าม",
            "word_usage": "คำนาม + を + 無視 + する",
            "word_ex": "少数意見を無視する。"
        },
        {
            "id": "406",
            "kanji": "無視",
            "n_read": "むし",
            "kango_easy": "見捨てる",
            "e_read": "みすてる",
            "word_meaning": "ไม่สนใจ เมิน มองข้าม",
            "word_usage": "คำนาม + を + 無視 + する",
            "word_ex": "少数意見を無視する。"
        },
        {
            "id": "407",
            "kanji": "依存",
            "n_read": "いぞん",
            "kango_easy": "頼る",
            "e_read": "たよる",
            "word_meaning": "พึ่ง (คนอื่น)",
            "word_usage": "คำนาม + を + 依存 + する",
            "word_ex": "日本は外国に石油を依存している。"
        },
        {
            "id": "408",
            "kanji": "流行",
            "n_read": "りゅうこう",
            "kango_easy": "人気",
            "e_read": "にんき",
            "word_meaning": "\bเป็นที่นิยม (แฟชั่น) ฮิต",
            "word_usage": "คำนาม + は/が + 流行 + する",
            "word_ex": "ロングスカートが流行したのはいつでしたか。"
        },
        {
            "id": "409",
            "kanji": "退院",
            "n_read": "たいいん",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "ออกจากโรงพยาบาล",
            "word_usage": "คำนาม + は/が + 退院 + する",
            "word_ex": "患者は退院した。"
        },
        {
            "id": "410",
            "kanji": "想定",
            "n_read": "そうてい",
            "kango_easy": "測る",
            "e_read": "はかる",
            "word_meaning": "คาดเดา คาดคะเน (ดูเงื่อนไข)",
            "word_usage": "คำนาม + を + 想定 + する",
            "word_ex": "食料を自国で生産すると仮定して、消費される水量を想定する。"
        },
        {
            "id": "411",
            "kanji": "想定",
            "n_read": "そうてい",
            "kango_easy": "思う",
            "e_read": "おもう",
            "word_meaning": "คาดเดา คาดคะเน (ดูเงื่อนไข)",
            "word_usage": "คำนาม + を + 想定 + する",
            "word_ex": "食料を自国で生産すると仮定して、消費される水量を想定する。"
        },
        {
            "id": "412",
            "kanji": "表示",
            "n_read": "ひょうじ",
            "kango_easy": "示す",
            "e_read": "しめす",
            "word_meaning": "แสดงให้เข้าใจ แสดงให้เห็นด้วยตาราง",
            "word_usage": "คำนาม + を + 表示 + する",
            "word_ex": "湿度計は80パーセントを表示している。"
        },
        {
            "id": "413",
            "kanji": "表示",
            "n_read": "ひょうじ",
            "kango_easy": "表す",
            "e_read": "あらわす",
            "word_meaning": "แสดงให้เข้าใจ แสดงให้เห็นด้วยตาราง",
            "word_usage": "คำนาม + を + 表示 + する",
            "word_ex": "湿度計は80パーセントを表示している。"
        },
        {
            "id": "414",
            "kanji": "検出",
            "n_read": "けんしゅつ",
            "kango_easy": "見つける",
            "e_read": "みつける",
            "word_meaning": "ตรวจหา ตรวจพบ (เชื้อ สาร ของที่มองไม่เห็น)",
            "word_usage": "คำนาม + を + 検出 + する",
            "word_ex": "DNAを検出する。"
        },
        {
            "id": "415",
            "kanji": "修正",
            "n_read": "しゅうせい",
            "kango_easy": "直す",
            "e_read": "なおす",
            "word_meaning": "แก้ไข ซ่อมแซม\r\nแปรบัญญัติกฎหมาย",
            "word_usage": "คำนาม + を + 修正 + する",
            "word_ex": " そのデータを修正する。"
        },
        {
            "id": "416",
            "kanji": "修正",
            "n_read": "しゅうせい",
            "kango_easy": "正しくする",
            "e_read": "ただしくする",
            "word_meaning": "แก้ไข ซ่อมแซม\r\nแปรบัญญัติกฎหมาย",
            "word_usage": "คำนาม + を + 修正 + する",
            "word_ex": " そのデータを修正する。"
        },
        {
            "id": "417",
            "kanji": "縮小",
            "n_read": "しゅくしょう",
            "kango_easy": "小さくする",
            "e_read": "ちいさくする",
            "word_meaning": "ย่อขนาด ลด (จำนวน ค่าใช้จ่าย คน ขนาด)",
            "word_usage": "คำนาม + を + 縮小 + する",
            "word_ex": "人員体制を縮小する。"
        },
        {
            "id": "418",
            "kanji": "縮小",
            "n_read": "しゅくしょう",
            "kango_easy": "縮める",
            "e_read": "ちぢめる",
            "word_meaning": "ย่อขนาด ลด (จำนวน ค่าใช้จ่าย คน ขนาด)",
            "word_usage": "คำนาม + を + 縮小 + する",
            "word_ex": "人員体制を縮小する。"
        },
        {
            "id": "419",
            "kanji": "低下",
            "n_read": "ていか",
            "kango_easy": "下がる",
            "e_read": "さがる",
            "word_meaning": "ลดลง แย่ลง (ควาสามารถ สุขภาพ อุณหภูมิ)",
            "word_usage": "คำนาม + は/が + 低下 + する",
            "word_ex": "学生の学力が低下した。"
        },
        {
            "id": "420",
            "kanji": "搭乗",
            "n_read": "とうじょう",
            "kango_easy": "乗る",
            "e_read": "のる",
            "word_meaning": "โดยสารหรือขึ้นเครื่องบิน",
            "word_usage": "พาหนะ + に + 搭乗 + する",
            "word_ex": "福岡行きボーイング747に搭乗する。"
        },
        {
            "id": "421",
            "kanji": "保管",
            "n_read": "ほかん",
            "kango_easy": "預かる",
            "e_read": "あずかる",
            "word_meaning": "เก็บรักษา เก็บไว้",
            "word_usage": "คำนาม + を + 保管 + する",
            "word_ex": "書類を保管する。"
        },
        {
            "id": "422",
            "kanji": "保管",
            "n_read": "ほかん",
            "kango_easy": "保つ",
            "e_read": "たもつ",
            "word_meaning": "เก็บรักษา เก็บไว้",
            "word_usage": "คำนาม + を + 保管 + する",
            "word_ex": "書類を保管する。"
        },
        {
            "id": "423",
            "kanji": "協調",
            "n_read": "きょうちょう",
            "kango_easy": "一緒にする",
            "e_read": "いっしょにする",
            "word_meaning": "ร่วมมือกัน ประสานงาน",
            "word_usage": "คำนาม + を + 協調 + する",
            "word_ex": "連合軍を協調する。"
        },
        {
            "id": "424",
            "kanji": "統括",
            "n_read": "とうかつ",
            "kango_easy": "一つにする",
            "e_read": "ひとつにする",
            "word_meaning": "รวมให้เป็นหนึ่ง",
            "word_usage": "คำนาม + を + 統括 + する",
            "word_ex": "いろいろな考えを統括する。"
        },
        {
            "id": "425",
            "kanji": "表現",
            "n_read": "ひょうげん",
            "kango_easy": "表す",
            "e_read": "あらわす",
            "word_meaning": "แสดงความรู้สึกออกมาเป็นคำพูดหรือสีหน้าท่าทาง",
            "word_usage": "คำนาม + を + 表現 + する",
            "word_ex": "その1節は彼の苦悩を表現している。"
        },
        {
            "id": "426",
            "kanji": "接近",
            "n_read": "せっきん",
            "kango_easy": "近つく",
            "e_read": "ちかつく",
            "word_meaning": "เข้าใกล้ เข้ามาใกล้",
            "word_usage": "คำนาม + を + 接近 + する\r\nคำนาม + に + 接近 + する",
            "word_ex": "彼らは年齢が接近している。\r\n台風が九州に接近している。"
        },
        {
            "id": "427",
            "kanji": "提示",
            "n_read": "ていじ",
            "kango_easy": "見せる",
            "e_read": "みせる",
            "word_meaning": "นำออกมาแสดง (ให้ดู) ยื่น​ (เอกสาร)",
            "word_usage": "คำนาม + を + 提示 + する",
            "word_ex": "パスポートを提示する。"
        },
        {
            "id": "428",
            "kanji": "沈没",
            "n_read": "ちんぼつ",
            "kango_easy": "沈む",
            "e_read": "しずむ",
            "word_meaning": "จมหาย อับปาง",
            "word_usage": "คำนาม + は/が + 沈没 + する",
            "word_ex": "船が沈没する時は船長が最後に船を去る。"
        },
        {
            "id": "429",
            "kanji": "上映",
            "n_read": "じょうえい",
            "kango_easy": "映す",
            "e_read": "うつす",
            "word_meaning": "ฉาย (ภาพยนต์)",
            "word_usage": "คำนาม + を + 上映 + する",
            "word_ex": "あの映画館ではどんな映画を上映していますか。"
        },
        {
            "id": "430",
            "kanji": "判明",
            "n_read": "はんめい",
            "kango_easy": "はっきり",
            "e_read": "はっきり",
            "word_meaning": "กระจ่าง (เข้าใจอย่าง) แจ่มแจ้ง",
            "word_usage": "คำนาม + は/が + 判明 + する",
            "word_ex": "その事故の原因が判明した。"
        },
        {
            "id": "431",
            "kanji": "判明",
            "n_read": "はんめい",
            "kango_easy": "明らか",
            "e_read": "あきらか",
            "word_meaning": "กระจ่าง (เข้าใจอย่าง) แจ่มแจ้ง",
            "word_usage": "คำนาม + は/が + 判明 + する",
            "word_ex": "その事故の原因が判明した。"
        },
        {
            "id": "432",
            "kanji": "記載",
            "n_read": "きさい",
            "kango_easy": "書く",
            "e_read": "かく",
            "word_meaning": "กรอก (เอกสาร) ใส่ข้อความลงไป",
            "word_usage": "คำนาม + に + 記載 + する",
            "word_ex": "会計簿に記載する。"
        },
        {
            "id": "433",
            "kanji": "発揮",
            "n_read": "はっき",
            "kango_easy": "現す",
            "e_read": "あらわす",
            "word_meaning": "แสดงศักยภาพ ความสามารถ",
            "word_usage": "คำนาม + を + 発揮 + する",
            "word_ex": "才能を発揮する。"
        },
        {
            "id": "434",
            "kanji": "発揮",
            "n_read": "はっき",
            "kango_easy": "出す",
            "e_read": "だす",
            "word_meaning": "แสดงศักยภาพ ความสามารถ",
            "word_usage": "คำนาม + を + 発揮 + する",
            "word_ex": "才能を発揮する。"
        },
        {
            "id": "435",
            "kanji": "確信",
            "n_read": "かくしん",
            "kango_easy": "信じる",
            "e_read": "しんじる",
            "word_meaning": "เชื่อมั่น มั่นใจ แน่ใจ",
            "word_usage": "คำนาม + を + 確信 + する",
            "word_ex": "私は彼の成功を確信している。"
        },
        {
            "id": "436",
            "kanji": "分裂",
            "n_read": "ぶんれつ",
            "kango_easy": "分かれる",
            "e_read": "わかれる",
            "word_meaning": "แตกแยก แตกตัว",
            "word_usage": "คำนาม + は/が + 分裂 + する",
            "word_ex": "その問題で我々の意見が分裂した。"
        },
        {
            "id": "437",
            "kanji": "変化",
            "n_read": "へんか",
            "kango_easy": "変わる",
            "e_read": "かわる",
            "word_meaning": "เปลี่ยนแปลง แปรผัน กลาย",
            "word_usage": "คำนาม + に + 変化 + する\r\nคำนาม + は/が + 変化 + する",
            "word_ex": "ガスに変化する過程。\r\n車窓の景色は時々刻々変化した。"
        },
        {
            "id": "438",
            "kanji": "変化",
            "n_read": "へんか",
            "kango_easy": "化する",
            "e_read": "かする",
            "word_meaning": "เปลี่ยนแปลง แปรผัน กลาย",
            "word_usage": "คำนาม + に + 変化 + する\r\nคำนาม + は/が + 変化 + する",
            "word_ex": "ガスに変化する過程。\r\n車窓の景色は時々刻々変化した。"
        },
        {
            "id": "439",
            "kanji": "検証",
            "n_read": "けんしょう",
            "kango_easy": "確かめる",
            "e_read": "たしかめる",
            "word_meaning": "ตรวจสอบ พิสูจน์ (ใช้ทฤษฎี ดูความจริง ตัวอย่าง หรืออะไรก็ได้ที่สามารถพิสูจน์ความจริงได้)",
            "word_usage": "คำนาม + を + 検証 + する",
            "word_ex": "統計調査によって仮説を検証する方法。"
        },
        {
            "id": "440",
            "kanji": "完了",
            "n_read": "かんりょう",
            "kango_easy": "終る",
            "e_read": "おわる",
            "word_meaning": "เสร็จสมบูรณ์",
            "word_usage": "คำนาม + を + 完了 + する",
            "word_ex": "在外研究を完了する。"
        },
        {
            "id": "441",
            "kanji": "発売",
            "n_read": "はつばい",
            "kango_easy": "売る",
            "e_read": "うる",
            "word_meaning": "ออกขาย วางตลาด เริ่มขาย",
            "word_usage": "คำนาม + を + 発売 + する",
            "word_ex": "トヨタは今秋新車を発売する。"
        },
        {
            "id": "442",
            "kanji": "象徴",
            "n_read": "しょうちょう",
            "kango_easy": "シンボル",
            "e_read": "",
            "word_meaning": "เป็นสัญลักษณ์ของ เป็นนัย ",
            "word_usage": "คำนาม + を + 象徴 + する",
            "word_ex": "国を象徴する花。"
        },
        {
            "id": "443",
            "kanji": "証明",
            "n_read": "しょうめい",
            "kango_easy": "明らかにする",
            "e_read": "あきらかにする",
            "word_meaning": "ยืนยัน พิสูจน์ (ให้เห็นความจริง)",
            "word_usage": "คำนาม + を + 証明 + する",
            "word_ex": "身分を証明する。"
        },
        {
            "id": "444",
            "kanji": "浮上",
            "n_read": "ふじょう",
            "kango_easy": "浮かぶ",
            "e_read": "うかぶ",
            "word_meaning": "ลอยขึ้นมาเหนือผิวน้ำ\r\nของที่ตอนแรกไม่โดดเด่น กลับโดดเด่น มีอำนาจขึ้นมา ปรากฏเด่นขัด",
            "word_usage": "คำนาม + に + 浮上 + する",
            "word_ex": "水面に浮上する。\r\n彼は最新の世界ランキングで順位を4つ上げ13位に浮上した。"
        },
        {
            "id": "445",
            "kanji": "浮上",
            "n_read": "ふじょう",
            "kango_easy": "上がる",
            "e_read": "あがる",
            "word_meaning": "ลอยขึ้นมาเหนือผิวน้ำ\r\nของที่ตอนแรกไม่โดดเด่น กลับโดดเด่น มีอำนาจขึ้นมา ปรากฏเด่นขัด",
            "word_usage": "คำนาม + に + 浮上 + する",
            "word_ex": "水面に浮上する。\r\n彼は最新の世界ランキングで順位を4つ上げ13位に浮上した。"
        },
        {
            "id": "446",
            "kanji": "交渉",
            "n_read": "こうしょう",
            "kango_easy": "話し合う",
            "e_read": "はなしあう",
            "word_meaning": "\bต่อรอง เจรจา",
            "word_usage": "คำนาม + を + 交渉 + する",
            "word_ex": "彼女は店員と値段を交渉した。"
        },
        {
            "id": "447",
            "kanji": "交渉",
            "n_read": "こうしょう",
            "kango_easy": "話す",
            "e_read": "はなす",
            "word_meaning": "\bต่อรอง เจรจา",
            "word_usage": "คำนาม + を + 交渉 + する",
            "word_ex": "彼女は店員と値段を交渉した。"
        },
        {
            "id": "448",
            "kanji": "交渉",
            "n_read": "こうしょう",
            "kango_easy": "駆け引き",
            "e_read": "かけひき",
            "word_meaning": "\bต่อรอง เจรจา",
            "word_usage": "คำนาม + を + 交渉 + する",
            "word_ex": "彼女は店員と値段を交渉した。"
        },
        {
            "id": "449",
            "kanji": "侵入",
            "n_read": "しんにゅう",
            "kango_easy": "入る",
            "e_read": "はいる",
            "word_meaning": "บุกรุก รุกราน (เข้าอาณาเขตพื้นที่ผู้อื่นโดยไม่ได้รับอนุญาต)",
            "word_usage": "คำนาม + に + 侵入 + する",
            "word_ex": "強盗が裏口から彼の家に侵入した。"
        },
        {
            "id": "450",
            "kanji": "行使",
            "n_read": "こうし",
            "kango_easy": "用いる",
            "e_read": "もちいる",
            "word_meaning": "ใช้ (สิทธิ์ อาวุธ กำลัง)",
            "word_usage": "คำนาม + を + 行使 + する",
            "word_ex": "国民としての権利を行使する。"
        },
        {
            "id": "451",
            "kanji": "行使",
            "n_read": "こうし",
            "kango_easy": "使う",
            "e_read": "つかう",
            "word_meaning": "ใช้ (สิทธิ์ อาวุธ กำลัง)",
            "word_usage": "คำนาม + を + 行使 + する",
            "word_ex": "国民としての権利を行使する。"
        },
        {
            "id": "452",
            "kanji": "制作",
            "n_read": "せいさく",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "ผลิต ผลงานศิลปะ ภาพยนตร์ รายการโทรทัศน์ (มักใช้กับการสร้างสรรค์ผลงานศิลปะเป็นหลัก)",
            "word_usage": "คำนาม + を + 制作 + する",
            "word_ex": "テレビ番組を制作する。"
        },
        {
            "id": "453",
            "kanji": "優勝",
            "n_read": "ゆうしょう",
            "kango_easy": "勝つ",
            "e_read": "かつ",
            "word_meaning": "1) ได้เป็นที่ 1 ในการแข่งขันหรือในการแข่งกีฬา\r\n2) โดดเด่นจนชนะผู้อื่น\r\n",
            "word_usage": "คำนาม + で + 優勝 + する",
            "word_ex": "全国大会で優勝する。"
        },
        {
            "id": "454",
            "kanji": "優勝",
            "n_read": "ゆうしょう",
            "kango_easy": "一位",
            "e_read": "いちい",
            "word_meaning": "1) ได้เป็นที่ 1 ในการแข่งขันหรือในการแข่งกีฬา\r\n2) โดดเด่นจนชนะผู้อื่น\r\n",
            "word_usage": "คำนาม + で + 優勝 + する",
            "word_ex": "全国大会で優勝する。"
        },
        {
            "id": "455",
            "kanji": "落下",
            "n_read": "らっか",
            "kango_easy": "落ちる",
            "e_read": "おちる",
            "word_meaning": "ตกลงมาจากที่สูง เช่น ป้ายร้านค้าตกลงมาบนถนน",
            "word_usage": "ประธาน + が + 落下 + する",
            "word_ex": "看板が道路に落下した。"
        },
        {
            "id": "456",
            "kanji": "通告",
            "n_read": "つうこく",
            "kango_easy": "知らせる",
            "e_read": "しらせる",
            "word_meaning": "แจ้งให้อีกฝ่ายทราบเกี่ยวกับการตัดสินใจหรือแนวทางความคิด โดยเฉพาะการประกาศเป็นหนังสือ",
            "word_usage": "คำนาม + を + 通告 + する",
            "word_ex": "解雇を通告する。"
        },
        {
            "id": "457",
            "kanji": "出場",
            "n_read": "しゅつじょう",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "1) ออกไปยังสถานที่หนึ่ง ๆ\r\n2) เข้าร่วมการแข่งขันต่าง ๆ\r\n3) การไปยังสถานที่เกิดเหตุของรถดับเพลิง รถพยาบาล\r\n4) การออกจากอาคาร หรือสถานที่โดยผ่านช่องตรวจตั๋ว ทางเข้าออก ไปสู่ภายนอก",
            "word_usage": "คำนาม + に + 出場 + する",
            "word_ex": "野球大会に出場する。"
        },
        {
            "id": "458",
            "kanji": "逃走",
            "n_read": "とうそう",
            "kango_easy": "逃げる",
            "e_read": "にげる",
            "word_meaning": "หนี หนีหายไป",
            "word_usage": "คำนาม (สถานที่) + から + 逃走 + する",
            "word_ex": "犯人は現場から逃走する。"
        },
        {
            "id": "459",
            "kanji": "破棄",
            "n_read": "はき",
            "kango_easy": "捨てる",
            "e_read": "すてる",
            "word_meaning": "1) ฉีก ทำลายทิ้ง\r\n2) ทำลายข้อตกลง หรือสัญญาเพียงฝ่ายเดียว\r\n3) ศาลฎีกายกเลิกคำตัดสินเดิม",
            "word_usage": "คำนาม + を + 破棄 + する",
            "word_ex": "不要書類を破棄する。"
        },
        {
            "id": "460",
            "kanji": "休止",
            "n_read": "きゅうし",
            "kango_easy": "休む",
            "e_read": "やすむ",
            "word_meaning": "หยุดการทำงาน กิจกรรมชั่วคราว, หยุดการเคลื่อนไหว เช่น หยุดการเดินรถ",
            "word_usage": "คำนาม + を + 休止 + する",
            "word_ex": "運転を休止する。"
        },
        {
            "id": "461",
            "kanji": "許可",
            "n_read": "きょか",
            "kango_easy": "許す",
            "e_read": "ゆるす",
            "word_meaning": "รับฟังคำขอ อนุญาตให้กระทำการบางอย่าง (อนุญาต)",
            "word_usage": "คำนาม + を + 許可 + する",
            "word_ex": "使用を許可する。"
        },
        {
            "id": "462",
            "kanji": "先行",
            "n_read": "せんこう",
            "kango_easy": "先",
            "e_read": "さき",
            "word_meaning": "1) A: ไปก่อนคนอื่น ล่วงหน้าไปก่อน เช่น ไปรวมตัวกับกลุ่มที่ล่วงหน้าไปก่อน\r\n    B: ก้าวหน้าไปก่อนสิ่งอื่น เช่น ความนิยมไปได้ไกลกว่าความสามารถ\r\n2) อยู่ในจุดที่ไกลกว่าแล้วชี้นำ นำทาง เช่น ออกไปขับรถเล่นโดยมีเพื่อนนำทางให้\r\n3) ได้แต้มก่อนอีกฝ่าย ในการแข่งขันกีฬา\r\n4) จัดขึ้นก่อนสิ่งอื่น\r\n5) ดำเนินมาก่อนหน้านี้แล้ว",
            "word_usage": "คำนาม + は/が + 先行 + する\r\nคำนาม + に + 先行 + する",
            "word_ex": "先行したグループと合流する。\r\n実力より人気が先行する。\r\n地元の友人が先行してドライブに出かける。\r\nシンポジウムに先行して講演会を開く。\r\n実存主義に先行する思想。"
        },
        {
            "id": "463",
            "kanji": "先行",
            "n_read": "せんこう",
            "kango_easy": "先立つ",
            "e_read": "さきだつ",
            "word_meaning": "1) A: ไปก่อนคนอื่น ล่วงหน้าไปก่อน เช่น ไปรวมตัวกับกลุ่มที่ล่วงหน้าไปก่อน\r\n    B: ก้าวหน้าไปก่อนสิ่งอื่น เช่น ความนิยมไปได้ไกลกว่าความสามารถ\r\n2) อยู่ในจุดที่ไกลกว่าแล้วชี้นำ นำทาง เช่น ออกไปขับรถเล่นโดยมีเพื่อนนำทางให้\r\n3) ได้แต้มก่อนอีกฝ่าย ในการแข่งขันกีฬา\r\n4) จัดขึ้นก่อนสิ่งอื่น\r\n5) ดำเนินมาก่อนหน้านี้แล้ว",
            "word_usage": "คำนาม + は/が + 先行 + する\r\nคำนาม + に + 先行 + する",
            "word_ex": "先行したグループと合流する。\r\n実力より人気が先行する。\r\n地元の友人が先行してドライブに出かける。\r\nシンポジウムに先行して講演会を開く。\r\n実存主義に先行する思想。"
        },
        {
            "id": "464",
            "kanji": "干渉",
            "n_read": "かんしょう",
            "kango_easy": "割り込む",
            "e_read": "わりこむ",
            "word_meaning": "เข้าไปแทรกเรื่องของคนอื่น แล้วพยายามบังคับให้ทำตามความคิดของตน",
            "word_usage": "คำนาม + に + 干渉 + する",
            "word_ex": "他人の生活に干渉する。"
        },
        {
            "id": "465",
            "kanji": "干渉",
            "n_read": "かんしょう",
            "kango_easy": "込む",
            "e_read": "こむ",
            "word_meaning": "เข้าไปแทรกเรื่องของคนอื่น แล้วพยายามบังคับให้ทำตามความคิดของตน",
            "word_usage": "คำนาม + に + 干渉 + する",
            "word_ex": "他人の生活に干渉する。"
        },
        {
            "id": "466",
            "kanji": "銃撃",
            "n_read": "じゅうげき",
            "kango_easy": "撃つ",
            "e_read": "うつ",
            "word_meaning": "โจมตีด้วยอาวุธปืน",
            "word_usage": "คำนาม + が + 銃撃 + する\r\nคำนาม + が + 銃撃 + される",
            "word_ex": "高所から銃撃される。"
        },
        {
            "id": "467",
            "kanji": "押収",
            "n_read": "おうしゅう",
            "kango_easy": "押さえる",
            "e_read": "おさえる",
            "word_meaning": "ศาลหรือเจ้าหน้าที่สืบสวนสอบสวน ครอบครองหรือรักษาหลักฐานหรือสิ่งที่ควรริบไว้ เช่น ยึดครองหลักฐานเอาไว้",
            "word_usage": "คำนาม + を + 押収 + する",
            "word_ex": "証拠品を押収する。"
        },
        {
            "id": "468",
            "kanji": "押収",
            "n_read": "おうしゅう",
            "kango_easy": "取る",
            "e_read": "とる",
            "word_meaning": "ศาลหรือเจ้าหน้าที่สืบสวนสอบสวน ครอบครองหรือรักษาหลักฐานหรือสิ่งที่ควรริบไว้ เช่น ยึดครองหลักฐานเอาไว้",
            "word_usage": "คำนาม + を + 押収 + する",
            "word_ex": "証拠品を押収する。"
        },
        {
            "id": "469",
            "kanji": "死去",
            "n_read": "しきょ",
            "kango_easy": "死ぬ",
            "e_read": "しぬ",
            "word_meaning": "ตายจากโลกนี้ไป",
            "word_usage": "คำนาม + が + 死去 + する",
            "word_ex": "夜死去した。"
        },
        {
            "id": "470",
            "kanji": "死去",
            "n_read": "しきょ",
            "kango_easy": "亡くなる",
            "e_read": "なくなる",
            "word_meaning": "ตายจากโลกนี้ไป",
            "word_usage": "คำนาม + が + 死去 + する",
            "word_ex": "夜死去した。"
        },
        {
            "id": "471",
            "kanji": "勧告",
            "n_read": "かんこく",
            "kango_easy": "アドバイズ",
            "e_read": "あどばいす",
            "word_meaning": "แนะนำ",
            "word_usage": "คำนาม + を + 勧告 + する",
            "word_ex": "辞職を勧告する。"
        },
        {
            "id": "472",
            "kanji": "促進",
            "n_read": "そくしん",
            "kango_easy": "頑張る",
            "e_read": "がんばる",
            "word_meaning": "ทุ่มเทในเรื่องใดเรื่องหนึ่งเพื่อให้พัฒนาอย่างรวดเร็ว",
            "word_usage": "คำนาม + を + 促進 + する",
            "word_ex": "開発を促進する。"
        },
        {
            "id": "473",
            "kanji": "促進",
            "n_read": "そくしん",
            "kango_easy": "進む",
            "e_read": "すすむ",
            "word_meaning": "ทุ่มเทในเรื่องใดเรื่องหนึ่งเพื่อให้พัฒนาอย่างรวดเร็ว",
            "word_usage": "คำนาม + を + 促進 + する",
            "word_ex": "開発を促進する。"
        },
        {
            "id": "474",
            "kanji": "混乱",
            "n_read": "こんらん",
            "kango_easy": "乱れる",
            "e_read": "みだれる",
            "word_meaning": "สิ่งของสูญเสียความเป็นระเบียบไปพร้อม ๆ กัน (สับสน วุ่นวาย โกลาหล)",
            "word_usage": "คำนาม + が + 混乱 + している",
            "word_ex": "列車のダイヤが混乱している。"
        },
        {
            "id": "475",
            "kanji": "後退",
            "n_read": "こうたい",
            "kango_easy": "下がる",
            "e_read": "さがる",
            "word_meaning": "1) ถอยไปข้างหลัง เช่น ถอยลด\r\n2) พละกำลังอ่อนแรงลง ระดับลดลง เช่น เศรษฐกิจถดถอย",
            "word_usage": "คำนาม + を + 後退 + させる\r\nคำนาม + が + 後退 + する",
            "word_ex": "車を後退させる。\r\n景気が後退する。"
        },
        {
            "id": "476",
            "kanji": "後退",
            "n_read": "こうたい",
            "kango_easy": "低くなる",
            "e_read": "ひくなる",
            "word_meaning": "1) ถอยไปข้างหลัง เช่น ถอยลด\r\n2) พละกำลังอ่อนแรงลง ระดับลดลง เช่น เศรษฐกิจถดถอย",
            "word_usage": "คำนาม + を + 後退 + させる\r\nคำนาม + が + 後退 + する",
            "word_ex": "車を後退させる。\r\n景気が後退する。"
        },
        {
            "id": "477",
            "kanji": "連行",
            "n_read": "うんこう",
            "kango_easy": "連れていく",
            "e_read": "つれていく",
            "word_meaning": "พาตัวไปยังที่ใดที่หนึ่ง ไม่ว่าเจ้าตัวจะต้องการหรือไม่ โดยเฉพาะกรณีที่เจ้าหน้าที่ตำรวจพาคนร้ายหรือผู้ต้องสงสัยไปยังสถานีตำรวจ เช่น ควบคุมตัวผู้ต้องสงสัยไปยังสถานีตำรวจ",
            "word_usage": "คำนาม + を + 連行 + する",
            "word_ex": "容疑者を連行する。"
        },
        {
            "id": "478",
            "kanji": "配置",
            "n_read": "はいち",
            "kango_easy": "任せる",
            "e_read": "まかせる",
            "word_meaning": "จัดวางคนหรือสิ่งของให้อยู่ในตำแหน่งที่เหมาะสม เช่น จัดเจ้าหน้าที่รักษาความปลอดภัยประจำอาคาร",
            "word_usage": "คำนาม + を + 配置 + する",
            "word_ex": "守備兵を配置する。"
        },
        {
            "id": "479",
            "kanji": "選出",
            "n_read": "えんしゅつ",
            "kango_easy": "選ぶ",
            "e_read": "えらぶ",
            "word_meaning": "เลือกตัวแทน หรือนักกีฬา (ออกมาจากกลุ่ม)",
            "word_usage": "คำนาม + を + 選出 + する\r\nคำนาม (ตำแหน่ง) + として + 選出 + させる",
            "word_ex": "ノミネート作品を選出する。\r\n代議士として選出される。"
        },
        {
            "id": "480",
            "kanji": "取材",
            "n_read": "しゅざい",
            "kango_easy": "集める",
            "e_read": "あつめる",
            "word_meaning": "รวบรวมข้อเท็จจริงจากเรื่องราวหรือเหตุการณ์ต่าง ๆ เพื่อนำมาเป็นแก่นของเรื่องหรือส่วนประกอบของคอลัมน์ข่าว หรือผลงานศิลปะ",
            "word_usage": "คำนาม + を + 取材 + する",
            "word_ex": "私はその町を取材する。"
        },
        {
            "id": "481",
            "kanji": "出版",
            "n_read": "しゅっぱん",
            "kango_easy": "出す",
            "e_read": "だす",
            "word_meaning": "ผลิตหนังสือ หรือนิตยสารด้วยวิธีการตีพิมพ์ หรือผลิตข้อมูลดิจิตัลขึ้นมาแล้วจัดจำหน่ายหรือแจกจ่าย",
            "word_usage": "คำนาม + を + 出版 + する",
            "word_ex": "児童書を出版する。"
        },
        {
            "id": "482",
            "kanji": "保障",
            "n_read": "ほしょう",
            "kango_easy": "守る",
            "e_read": "まもる",
            "word_meaning": "คุ้มครอง รักษาไว้เพื่อไม่ให้สภาพนั้นถูกทำลาย เช่น คุ้มครองความปลอดภัยของประชาชน",
            "word_usage": "คำนาม + を + 保障 + する",
            "word_ex": "国家の安全を保障する。"
        },
        {
            "id": "483",
            "kanji": "着弾",
            "n_read": "ちゃくだん",
            "kango_easy": "着く",
            "e_read": "つく",
            "word_meaning": "กระสุนปืนตกไปยังจุด ๆ หนึ่ง  เช่น (กระสุนปืน)​ ตกไปยังพื้นที่เป้าหมาย",
            "word_usage": "คำนาม (สถานที่) + に + 着弾 + する",
            "word_ex": "目標地に着弾する。"
        },
        {
            "id": "484",
            "kanji": "着弾",
            "n_read": "ちゃくだん",
            "kango_easy": "届く",
            "e_read": "とどく",
            "word_meaning": "กระสุนปืนตกไปยังจุด ๆ หนึ่ง  เช่น (กระสุนปืน)​ ตกไปยังพื้นที่เป้าหมาย",
            "word_usage": "คำนาม (สถานที่) + に + 着弾 + する",
            "word_ex": "目標地に着弾する。"
        },
        {
            "id": "485",
            "kanji": "保釈",
            "n_read": "ほしゃく",
            "kango_easy": "払う",
            "e_read": "はらう",
            "word_meaning": "จ่ายเงินประกันเพื่อให้ปล่อยตัวผู้ที่ถูกจับในคดีที่ยังไม่ได้ตัดสิน (ประกันตัว)",
            "word_usage": "คำนาม + を + 保釈 + する",
            "word_ex": "被告人を保釈する。"
        },
        {
            "id": "486",
            "kanji": "売却",
            "n_read": "ばいきゃく",
            "kango_easy": "売る",
            "e_read": "うる",
            "word_meaning": "ขายอย่างสมบูรณ์ เช่น ขายอสังหาริมทรัพย์",
            "word_usage": "คำนาม + を + 売却 + する",
            "word_ex": "土地を売却する。"
        },
        {
            "id": "487",
            "kanji": "生息",
            "n_read": "せいそく",
            "kango_easy": "生きている",
            "e_read": "いきている",
            "word_meaning": "1) อาศัยอยู่ที่แห่งใดแห่งหนึ่ง (มักใช้กับสัตว์)\r\n2) มีชีวิตอยู่ ใช้ชีวิตอยู่",
            "word_usage": "คำนาม (สถานที่) + に + 生息 + する",
            "word_ex": "都会に生息する。"
        },
        {
            "id": "488",
            "kanji": "生息",
            "n_read": "せいそく",
            "kango_easy": "住む",
            "e_read": "すむ",
            "word_meaning": "1) อาศัยอยู่ที่แห่งใดแห่งหนึ่ง (มักใช้กับสัตว์)\r\n2) มีชีวิตอยู่ ใช้ชีวิตอยู่",
            "word_usage": "คำนาม (สถานที่) + に + 生息 + する",
            "word_ex": "都会に生息する。"
        },
        {
            "id": "489",
            "kanji": "交代",
            "n_read": "こうたい",
            "kango_easy": "代わる",
            "e_read": "かわる",
            "word_meaning": "เปลี่ยนบทบาทหรือสถานที่ซึ่งกันและกัน เช่น แลกเวรกัน",
            "word_usage": "คำนาม + を + 交代 + する",
            "word_ex": "投手を交代する。"
        },
        {
            "id": "490",
            "kanji": "準備",
            "n_read": "じゅんび",
            "kango_easy": "備える",
            "e_read": "そなえる",
            "word_meaning": "เตรียมไว้ล่วงหน้า เพื่อให้กิจกรรมหนึ่ง ๆ ดำเนินไปได้ด้วยดี",
            "word_usage": "คำนาม + を + 準備 + する",
            "word_ex": "会議資料を準備する。"
        },
        {
            "id": "491",
            "kanji": "武装",
            "n_read": "ぶそう",
            "kango_easy": "",
            "e_read": "つける",
            "word_meaning": "ติดอุปกรณ์สำหรับเตรียมต่อสู้",
            "word_usage": "คำนาม (อุปกรณ์) + で + 武装 + する",
            "word_ex": "新兵器で武装する。"
        },
        {
            "id": "492",
            "kanji": "離陸",
            "n_read": "りりく",
            "kango_easy": "飛ぶ",
            "e_read": "とぶ",
            "word_meaning": "(เครื่องบิน) บินขึ้นสู่ท้องฟ้าออกห่างจากพื้นดิน",
            "word_usage": "คำนาม + を + 離陸 + する",
            "word_ex": "羽田空港を離陸する。"
        },
        {
            "id": "493",
            "kanji": "離陸",
            "n_read": "りりく",
            "kango_easy": "上がる",
            "e_read": "あがる",
            "word_meaning": "(เครื่องบิน) บินขึ้นสู่ท้องฟ้าออกห่างจากพื้นดิน",
            "word_usage": "คำนาม + を + 離陸 + する",
            "word_ex": "羽田空港を離陸する。"
        },
        {
            "id": "494",
            "kanji": "介入",
            "n_read": "かいにゅう",
            "kango_easy": "突っ込む",
            "e_read": "つっこむ",
            "word_meaning": "การแทรกซึมของผู้ที่ไม่เกี่ยวข้อง การเข้ามาแทรกในการแข่งขันหรือการโต้เถียง (แทรกแซง) เช่น เข้าแทรกแซงการโต้แย้งระหว่างประเทศ",
            "word_usage": "คำนาม + に + 介入 + する",
            "word_ex": "国際紛争に介入する。"
        },
        {
            "id": "495",
            "kanji": "介入",
            "n_read": "かいにゅう",
            "kango_easy": "入る",
            "e_read": "はいる",
            "word_meaning": "การแทรกซึมของผู้ที่ไม่เกี่ยวข้อง การเข้ามาแทรกในการแข่งขันหรือการโต้เถียง (แทรกแซง) เช่น เข้าแทรกแซงการโต้แย้งระหว่างประเทศ",
            "word_usage": "คำนาม + に + 介入 + する",
            "word_ex": "国際紛争に介入する。"
        },
        {
            "id": "496",
            "kanji": "指揮",
            "n_read": "しき",
            "kango_easy": "指す",
            "e_read": "さす",
            "word_meaning": "1) สั่งการโดยยืนอยู่เหนือคนอื่น เพื่อให้กลุ่มเคลื่อนไหวเป็นหนึ่งเดียวกัน (ออกคำสั่ง, ชี้นำ)\r\n2) กำกับการแสดงของวงดนตรีหรือวงประสานเสียง โดยใช้ท่าทางหรือไม้ของวาทยากร (อำนวยการแสดง)",
            "word_usage": "คำนาม + を + 指揮 + する",
            "word_ex": "軍事力を指揮する。\r\nコーラスを指揮する。"
        },
        {
            "id": "497",
            "kanji": "再選",
            "n_read": "さいせん",
            "kango_easy": "選ぶ",
            "e_read": "えらぶ",
            "word_meaning": "ในการเลือกตั้ง หมายถึง การเลือกผู้ที่เคยถูกเลือกในครั้งก่อนอีกครั้ง, ถูกเลือกอีกครั้ง",
            "word_usage": "คำนาม (ตำแหน่ง) + に + 再選 + される",
            "word_ex": "委員長に再選される。"
        },
        {
            "id": "498",
            "kanji": "受診",
            "n_read": "じゅしん",
            "kango_easy": "受ける",
            "e_read": "うける",
            "word_meaning": "เข้ารับการตรวจวินิจฉัยและการรักษาจากแพทย์ เช่น รับการตรวจสุขภาพ",
            "word_usage": "คำนาม + が + 受診 + する",
            "word_ex": "半年に一回は受診して下さい。"
        },
        {
            "id": "499",
            "kanji": "占拠",
            "n_read": "せんきょ",
            "kango_easy": "持っている",
            "e_read": "もっている",
            "word_meaning": "1) เป็นเจ้าของสถานที่แห่งหนึ่ง แล้วไม่อนุญาตให้ผู้อื่นเข้ามาใกล้สถานที่นั้น\r\n2) ยึดครอง เข่น ยึดครองฐานที่มั่นของศัตรู",
            "word_usage": "คำนาม (สถานที่)​ + を + 占拠 + する",
            "word_ex": "公園を占拠する。\r\n敵の要地を占拠する。"
        },
        {
            "id": "500",
            "kanji": "占拠",
            "n_read": "せんきょ",
            "kango_easy": "占める",
            "e_read": "しめる",
            "word_meaning": "1) เป็นเจ้าของสถานที่แห่งหนึ่ง แล้วไม่อนุญาตให้ผู้อื่นเข้ามาใกล้สถานที่นั้น\r\n2) ยึดครอง เข่น ยึดครองฐานที่มั่นของศัตรู",
            "word_usage": "คำนาม (สถานที่)​ + を + 占拠 + する",
            "word_ex": "公園を占拠する。\r\n敵の要地を占拠する。"
        },
        {
            "id": "501",
            "kanji": "位置",
            "n_read": "いち",
            "kango_easy": "場所",
            "e_read": "ばしょ",
            "word_meaning": "ตั้งอยู่ที่...",
            "word_usage": "คำนาม + に + 位置 + する",
            "word_ex": "青森県は本州の最北端に位置する。"
        },
        {
            "id": "502",
            "kanji": "分断",
            "n_read": "ぶんだん",
            "kango_easy": "分ける",
            "e_read": "わける",
            "word_meaning": "แบ่งของสิ่งหนึ่งที่เชื่อมต่อกันอยู่ให้ออกเป็นส่วน ๆ เข่น ดินถล่มทำให้ถนนแตกออกเป็นส่วน ๆ",
            "word_usage": "คำนาม + を + 分断 + する\r\nคำนาม + が + 分断 + される",
            "word_ex": "川がその町を分断している。\r\nがけ崩れで鉄道が分断される。"
        },
        {
            "id": "503",
            "kanji": "分断",
            "n_read": "ぶんだん",
            "kango_easy": "割く",
            "e_read": "さく",
            "word_meaning": "แบ่งของสิ่งหนึ่งที่เชื่อมต่อกันอยู่ให้ออกเป็นส่วน ๆ เข่น ดินถล่มทำให้ถนนแตกออกเป็นส่วน ๆ",
            "word_usage": "คำนาม + を + 分断 + する\r\nคำนาม + が + 分断 + される",
            "word_ex": "川がその町を分断している。\r\nがけ崩れで鉄道が分断される。"
        },
        {
            "id": "504",
            "kanji": "供給",
            "n_read": "きょうきゅう",
            "kango_easy": "出す",
            "e_read": "だす",
            "word_meaning": "ให้สิ่งของตามความจำเป็น หรือความต้องการ เช่น ให้เสบียงแก่ผู้ประสบภัย",
            "word_usage": "คำนาม + を + 供給 + する",
            "word_ex": "被災者に物資を供給する。"
        },
        {
            "id": "505",
            "kanji": "供給",
            "n_read": "きょうきゅう",
            "kango_easy": "与える",
            "e_read": "あたえる",
            "word_meaning": "ให้สิ่งของตามความจำเป็น หรือความต้องการ เช่น ให้เสบียงแก่ผู้ประสบภัย",
            "word_usage": "คำนาม + を + 供給 + する",
            "word_ex": "被災者に物資を供給する。"
        },
        {
            "id": "506",
            "kanji": "供給",
            "n_read": "きょうきゅう",
            "kango_easy": "あげる",
            "e_read": "あげる",
            "word_meaning": "ให้สิ่งของตามความจำเป็น หรือความต้องการ เช่น ให้เสบียงแก่ผู้ประสบภัย",
            "word_usage": "คำนาม + を + 供給 + する",
            "word_ex": "被災者に物資を供給する。"
        },
        {
            "id": "507",
            "kanji": "転覆",
            "n_read": "てんぷく",
            "kango_easy": "返す",
            "e_read": "かえす",
            "word_meaning": "1) พลิก ทำให้พลิก เช่น เรือพลิกคว่ำ\r\n2) (รัฐบาล) ถูกโค่นล้ม โค่นล้มอำนาจรัฐบาล",
            "word_usage": "คำนาม + が + 転覆 + する\r\nคำนาม + を + 転覆 + される",
            "word_ex": "船が転覆する。\r\n自国の政府を転覆させる。"
        },
        {
            "id": "508",
            "kanji": "転覆",
            "n_read": "てんぷく",
            "kango_easy": "返る",
            "e_read": "かえる",
            "word_meaning": "1) พลิก ทำให้พลิก เช่น เรือพลิกคว่ำ\r\n2) (รัฐบาล) ถูกโค่นล้ม โค่นล้มอำนาจรัฐบาล",
            "word_usage": "คำนาม + が + 転覆 + する\r\nคำนาม + を + 転覆 + される",
            "word_ex": "船が転覆する。\r\n自国の政府を転覆させる。"
        },
        {
            "id": "509",
            "kanji": "転覆",
            "n_read": "てんぷく",
            "kango_easy": "倒す",
            "e_read": "たおす",
            "word_meaning": "1) พลิก ทำให้พลิก เช่น เรือพลิกคว่ำ\r\n2) (รัฐบาล) ถูกโค่นล้ม โค่นล้มอำนาจรัฐบาล",
            "word_usage": "คำนาม + が + 転覆 + する\r\nคำนาม + を + 転覆 + される",
            "word_ex": "船が転覆する。\r\n自国の政府を転覆させる。"
        },
        {
            "id": "510",
            "kanji": "排出",
            "n_read": "はいしゅつ",
            "kango_easy": "出す",
            "e_read": "だす",
            "word_meaning": "1) ขับของที่ไม่จำเป็นซึ่งอยู่ภายในออกมาข้างนอก เช่น ระบายน้ำเสีย ปล่อยแก๊ส\r\n2) การขับของเสียที่ผลิตขึ้นภายในร่างกายของสิ่งมีชีวิต เช่น ขับเหงื่อ ถ่ายปัสสาวะ",
            "word_usage": "คำนาม + を + 排出 + する",
            "word_ex": "汚水を排出する。\r\n老廃物を排出する。"
        },
        {
            "id": "511",
            "kanji": "質問",
            "n_read": "しつもん",
            "kango_easy": "聞く",
            "e_read": "きく",
            "word_meaning": "ถามสิ่งที่สงสัย สิ่งที่ไม่เข้าใจ",
            "word_usage": "คำนาม (คน) + に + 質問 + する\r\nคำนาม + について + 質問 + する",
            "word_ex": "先生に質問する。\r\n経済政策について質問する。"
        },
        {
            "id": "512",
            "kanji": "救出",
            "n_read": "きゅうしゅつ",
            "kango_easy": "救う",
            "e_read": "すくう",
            "word_meaning": "ช่วยออกมาจากสถานการณ์ที่อันตราย",
            "word_usage": "คำนาม + を + 救出 + する",
            "word_ex": "遭難者を救出する。"
        },
        {
            "id": "513",
            "kanji": "申請",
            "n_read": "しんせい",
            "kango_easy": "願う",
            "e_read": "ねがう",
            "word_meaning": "ยื่นคำร้องเรื่องที่หวังหรือต้องการ โดยเฉพาะการขอคำอนุมัติหรือคำอนุญาตจากทางการ เช่น ยื่นขอวีซ่า",
            "word_usage": "คำนาม + を + 申請 + する",
            "word_ex": "ビザを申請する。"
        },
        {
            "id": "514",
            "kanji": "譲歩",
            "n_read": "じょうほ",
            "kango_easy": "譲る",
            "e_read": "ゆずる",
            "word_meaning": "ลดจุดยืนหรือทิ้งความเห็นของตนเองแล้วปฏิบัติตามความต้องการของอีกฝ่าย ประนีประนอม เช่น ยอมความซึ่งกันและกัน",
            "word_usage": "คำนาม + を + 譲歩 + する",
            "word_ex": "価格をもうこれ以上譲歩するわけにはいかない。"
        },
        {
            "id": "515",
            "kanji": "推移",
            "n_read": "すいい",
            "kango_easy": "変わる",
            "e_read": "かわる",
            "word_meaning": "1) การที่สถานการณ์เปลี่ยนแปลงไปตามกาลเวลา เช่น สถานการณ์เปลี่ยน\r\n2) การที่เวลาล่วงเลยไป",
            "word_usage": "คำนาม + が + 推移 + する",
            "word_ex": "情勢が推移する。\r\n時間が推移する。"
        },
        {
            "id": "516",
            "kanji": "開設",
            "n_read": "かいせつ",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "ก่อตั้งสถาบันหรือสร้างสิ่งอำนาจความสะดวก แล้วเริ่มใช้งานสิ่งนั้น เช่น สร้างร้านสาขาที่ลอนดอน เปิดบัญชีธนาคาร",
            "word_usage": "คำนาม + を + 開設 + する",
            "word_ex": "支店をロンドンに開設する。"
        },
        {
            "id": "517",
            "kanji": "構成",
            "n_read": "こうせい",
            "kango_easy": "組み立てる",
            "e_read": "くみたてる",
            "word_meaning": "1) รวมส่วนประกอบหลาย ๆ ส่วนให้เป็นชื้นเดียว หรือหนึ่งเดียวกัน เช่น สร้างสังคม สร้างทีม\r\n2) นำองค์ประกอบในการจัดแสดงแต่ละอย่างมาประกอบสร้างเป็นผลงานด้วยเทคนิคเฉพาะตัว ในงานเขียน ดนตรี ประติมากรรม (ประกอบเข้าด้วยกัน)",
            "word_usage": "คำนาม + を + 構成 + する",
            "word_ex": "チームを構成する。\r\n番組を構成する。"
        },
        {
            "id": "518",
            "kanji": "向上",
            "n_read": "こうじょう",
            "kango_easy": "良くなる",
            "e_read": "よくなる",
            "word_meaning": "ความสามารถ คุณสมบัติ ระดับ พัฒนา ก้าวหน้าไปในทิศทางที่ดีขึ้น เช่น ความสามารถทางการศึกษาพัฒนาขึ้น",
            "word_usage": "คำนาม + が + 向上 + する",
            "word_ex": "学力が向上する。"
        },
        {
            "id": "519",
            "kanji": "出展",
            "n_read": "しゅってん",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "การนำออกมาแสดง เช่น นำมาจัดแสดงที่งานนิทรรศการ",
            "word_usage": "คำนาม (สถานที่, งาน) + に + คำนาม (ผลงาน) + を + 出展 + する",
            "word_ex": "バラ展に出展する。"
        },
        {
            "id": "520",
            "kanji": "成長",
            "n_read": "せいちょう",
            "kango_easy": "大きくなる",
            "e_read": "おおきくなる",
            "word_meaning": "1) คน สัตว์ หรือพืช เจริญเติบโตขึ้น\r\n2) ระดับ ขนาดของสิ่งของใหญ่ขึ้น หรือขยายขึ้น เช่น ธุรจกิจโตขึ้น",
            "word_usage": "คำนาม + が + 成長 + する\r\nคำนาม + が + คำนาม + を + 成長 + させる",
            "word_ex": "子供が成長する。\r\n経験が人を成長させる。\r\n事業が成長する。"
        },
        {
            "id": "521",
            "kanji": "同席",
            "n_read": "どうせき",
            "kango_easy": "出席する",
            "e_read": "しゅっせきする",
            "word_meaning": "นั่งด้วยกัน เข้าร่วมด้วยกัน",
            "word_usage": "คำนาม + が + 同席 + する",
            "word_ex": "有名な俳優と同席する。"
        },
        {
            "id": "522",
            "kanji": "同席",
            "n_read": "どうせき",
            "kango_easy": "務める",
            "e_read": "つとめる",
            "word_meaning": "นั่งด้วยกัน เข้าร่วมด้วยกัน",
            "word_usage": "คำนาม + が + 同席 + する",
            "word_ex": "有名な俳優と同席する。"
        },
        {
            "id": "523",
            "kanji": "構築",
            "n_read": "こうちく",
            "kango_easy": "建てる",
            "e_read": "たてる",
            "word_meaning": "ก่อสร้าง, สร้าง เช่น สร้างปราสาท สร้างทฤษฎี",
            "word_usage": "คำนาม + を + 構築 + する",
            "word_ex": "理論を構築する。"
        },
        {
            "id": "524",
            "kanji": "強行",
            "n_read": "きょうこう",
            "kango_easy": "行う",
            "e_read": "おこなう",
            "word_meaning": "ฝืนดำเนินการสิ่งที่เป็นไปไม่ได้หรือสิ่งที่อาจทำให้เกิดความเสียหายมาก",
            "word_usage": "คำนาม + を + 強行 + する",
            "word_ex": "悪天候の中で大会を強行する。"
        },
        {
            "id": "525",
            "kanji": "強行",
            "n_read": "きょうこう",
            "kango_easy": "無理矢理",
            "e_read": "むりやり",
            "word_meaning": "ฝืนดำเนินการสิ่งที่เป็นไปไม่ได้หรือสิ่งที่อาจทำให้เกิดความเสียหายมาก",
            "word_usage": "คำนาม + を + 強行 + する",
            "word_ex": "悪天候の中で大会を強行する。"
        },
        {
            "id": "526",
            "kanji": "閉幕",
            "n_read": "へいまく",
            "kango_easy": "閉める",
            "e_read": "しめる",
            "word_meaning": "1 )ปิดฉากการแสดง\r\n2) เหตุการณ์ หรือกิจกรรมจบแล้ว",
            "word_usage": "คำนาม + が + 閉幕 + する",
            "word_ex": "展覧会が閉幕する。"
        },
        {
            "id": "527",
            "kanji": "閉幕",
            "n_read": "へいまく",
            "kango_easy": "閉まる",
            "e_read": "しまる",
            "word_meaning": "1 )ปิดฉากการแสดง\r\n2) เหตุการณ์ หรือกิจกรรมจบแล้ว",
            "word_usage": "คำนาม + が + 閉幕 + する",
            "word_ex": "展覧会が閉幕する。"
        },
        {
            "id": "528",
            "kanji": "閉幕",
            "n_read": "へいまく",
            "kango_easy": "終わる",
            "e_read": "おわる",
            "word_meaning": "1 )ปิดฉากการแสดง\r\n2) เหตุการณ์ หรือกิจกรรมจบแล้ว",
            "word_usage": "คำนาม + が + 閉幕 + する",
            "word_ex": "展覧会が閉幕する。"
        },
        {
            "id": "529",
            "kanji": "研究",
            "n_read": "けんきゅう",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "ค้นหาสิ่งต่าง ๆ หรือคิดอย่างลึกซึ้งเกี่ยวกับสิ่งต่าง ๆ ทำให้ข้อเท็จจริงหรือความเป็นจริงของสิ่งนั้นกระจ่าง",
            "word_usage": "คำนาม + を + 研究 + する",
            "word_ex": "中世史を研究する。"
        },
        {
            "id": "530",
            "kanji": "改正",
            "n_read": "かいせい",
            "kango_easy": "直す",
            "e_read": "なおす",
            "word_meaning": "แก้ไขจุดที่ไม่เหมาะสม หรือจุดที่บกพร่อง มักใช้กับกฎระเบียบ ข้อบังคับ ข้อบัญญัติ เช่น แก้ไขกฎระเบียบโรงเรียน",
            "word_usage": "คำนาม + を + 改正 + する",
            "word_ex": "校則を改正する。"
        },
        {
            "id": "531",
            "kanji": "終結",
            "n_read": "しゅうけつ",
            "kango_easy": "終わる",
            "e_read": "おわる",
            "word_meaning": "สิ่งต่าง ๆ จบลง หรือคลี่คลาย",
            "word_usage": "คำนาม + が + 終結 + する",
            "word_ex": "事態がようやく終結した。"
        },
        {
            "id": "532",
            "kanji": "終結",
            "n_read": "しゅうけつ",
            "kango_easy": "収まる",
            "e_read": "おさまる",
            "word_meaning": "สิ่งต่าง ๆ จบลง หรือคลี่คลาย",
            "word_usage": "คำนาม + が + 終結 + する",
            "word_ex": "事態がようやく終結した。"
        },
        {
            "id": "533",
            "kanji": "上陸",
            "n_read": "じょうりく",
            "kango_easy": "上がる",
            "e_read": "あがる",
            "word_meaning": "1) การขึ้นมาบนบกจากเรือหรือทะเล เครื่องบินลงจอดที่สนามบิน เช่น ไต้ฝุ่นพัดขึ้นฝั่งเกาะคิอิฮัน\r\n2) การที่วัฒนธรรมหรือความเจริญจากต่างประเทศเข้ามา การที่ต่างประเทศเข้ามาลงทุน เช่น บริษัทประกันจากต่างประเทศเข้ามาบริษัทแล้วบริษัทเล่า",
            "word_usage": "คำนาม + が + 上陸 + する",
            "word_ex": "台風が紀伊半島に上陸する。\r\n外資系生命保険会社が相次いで上陸する。"
        },
        {
            "id": "534",
            "kanji": "捜索",
            "n_read": "そうさく",
            "kango_easy": "捜す",
            "e_read": "さがす",
            "word_meaning": "1) ค้นหาคนหรือสิ่งของที่หายไป เช่น ค้นหาผู้ประสบภัย\r\n2) การที่ศาลหรือเจ้าหน้าที่สืบสวนสอบสวน ใช้การบังคับในการตรวจค้นตัว สิ่งของ หรือที่อยู่อาศัย เพื่อค้นหาตัวผู้ต้องสงสัย ผู้ต้องหา หรือหลักฐาน",
            "word_usage": "คำนาม + を + 捜査 + する",
            "word_ex": "遭難者を捜索する。"
        },
        {
            "id": "535",
            "kanji": "投下",
            "n_read": "とうか",
            "kango_easy": "落とす",
            "e_read": "おとす",
            "word_meaning": "1) ทำให้ของตกลงมาจากที่สูง ปาลงมา\r\n2) นำเงินไปลงทุนในธุรกิจ",
            "word_usage": "คำนาม + を + 投下 + する",
            "word_ex": "飛行機から物資を投下する。\r\n設備に資本を投下する。"
        },
        {
            "id": "536",
            "kanji": "投下",
            "n_read": "とうか",
            "kango_easy": "出す",
            "e_read": "だす",
            "word_meaning": "1) ทำให้ของตกลงมาจากที่สูง ปาลงมา\r\n2) นำเงินไปลงทุนในธุรกิจ",
            "word_usage": "คำนาม + を + 投下 + する",
            "word_ex": "飛行機から物資を投下する。\r\n設備に資本を投下する。"
        },
        {
            "id": "537",
            "kanji": "企画",
            "n_read": "きかく",
            "kango_easy": "たてる",
            "e_read": "たてる",
            "word_meaning": "วางแผนการเพื่อดำเนินการเรื่องใดเรื่องหนึ่ง",
            "word_usage": "คำนาม + を + 企画 + する",
            "word_ex": "新製品を企画する。"
        },
        {
            "id": "538",
            "kanji": "採用",
            "n_read": "さいよう",
            "kango_easy": "用いる",
            "e_read": "もちいる",
            "word_meaning": "เลือกบุคคล ความเห็น หรือวิธีการต่าง ๆ ที่คิดว่าเหมาะสมมาใช้งาน",
            "word_usage": "คำนาม + を + 採用 + する",
            "word_ex": "店員を三人採用する。\r\n企画案を採用する。"
        },
        {
            "id": "539",
            "kanji": "採用",
            "n_read": "さいよう",
            "kango_easy": "使う",
            "e_read": "つかう",
            "word_meaning": "เลือกบุคคล ความเห็น หรือวิธีการต่าง ๆ ที่คิดว่าเหมาะสมมาใช้งาน",
            "word_usage": "คำนาม + を + 採用 + する",
            "word_ex": "店員を三人採用する。\r\n企画案を採用する。"
        },
        {
            "id": "540",
            "kanji": "採用",
            "n_read": "さいよう",
            "kango_easy": "選ぶ",
            "e_read": "えらぶ",
            "word_meaning": "เลือกบุคคล ความเห็น หรือวิธีการต่าง ๆ ที่คิดว่าเหมาะสมมาใช้งาน",
            "word_usage": "คำนาม + を + 採用 + する",
            "word_ex": "店員を三人採用する。\r\n企画案を採用する。"
        },
        {
            "id": "541",
            "kanji": "転換",
            "n_read": "てんかん",
            "kango_easy": "変える",
            "e_read": "かえる",
            "word_meaning": "เปลี่ยนไปเป็นสิ่งที่แตกต่างจากเดิม เปลี่ยนทิศทาง เปลี่ยนแปลง เช่น เปลี่ยนอารมณ์ เปลี่ยนเรื่องสนทนา",
            "word_usage": "คำนาม + を + 転換 + する",
            "word_ex": "話題を転換する。"
        },
        {
            "id": "542",
            "kanji": "施行",
            "n_read": "しこう",
            "kango_easy": "行う",
            "e_read": "おこなう",
            "word_meaning": "1) การดำเนินการจริง นำนโยบายหรือแผนการไปดำเนินการจริง เช่น บังคับใช้คำสั่ง\r\n2) ทำให้กฎหมายและข้อบังคับมีผล",
            "word_usage": "คำนาม + を + 施行 + する",
            "word_ex": "命令を施行する。\r\n新税法を施行する。"
        },
        {
            "id": "543",
            "kanji": "審議",
            "n_read": "しんぎ",
            "kango_easy": "決める",
            "e_read": "きめる",
            "word_meaning": "ค้นหาข้อมูลหรือพิจารณาสิ่งใดสิ่งหนึ่งอย่างละเอียด เพื่อตัดสินว่าสิ่งนั้นดีหรือไม่ดี",
            "word_usage": "คำนาม + を + 審議 + する",
            "word_ex": "法案を審議する。"
        },
        {
            "id": "544",
            "kanji": "発給",
            "n_read": "はっきゅう",
            "kango_easy": "出す",
            "e_read": "だす",
            "word_meaning": "ทางการออกเอกสารต่าง ๆ ให้ เช่น ออกตั๋ว ออกวีซ่า",
            "word_usage": "คำนาม + を + 発給 + する",
            "word_ex": "ビザを発給する。"
        },
        {
            "id": "545",
            "kanji": "作成",
            "n_read": "さくせい",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "สร้างแผนการ เอกสาร หรืองานเขียน เช่น สร้างหนังสือรายงาน",
            "word_usage": "คำนาม + を + 作成 + する",
            "word_ex": "報告書を作成する。"
        },
        {
            "id": "546",
            "kanji": "断定",
            "n_read": "だんてい",
            "kango_easy": "決める",
            "e_read": "きめる",
            "word_meaning": "ตัดสินใจเรื่องใดเรื่องหนึ่งอย่างชัดเจน เช่น ตัดสินว่าเขาเป็นคนร้าย",
            "word_usage": "คำนาม + を + คำนาม​ + と + 断定 + する",
            "word_ex": "A を犯人と断定した。"
        },
        {
            "id": "547",
            "kanji": "侵害",
            "n_read": "しんがい",
            "kango_easy": "侵す",
            "e_read": "おかす",
            "word_meaning": "ละเมิดสิทธิ์หรือสิ่งที่ผู้อื่นครอบครองอยู่ ทำให้เกิดความเสียหาย เช่น ละเมิดลิขสิทธิ์งานเขียน",
            "word_usage": "คำนาม + を + 侵害 + する",
            "word_ex": "著作権を侵害する。"
        },
        {
            "id": "548",
            "kanji": "投与",
            "n_read": "とうよ",
            "kango_easy": "与える",
            "e_read": "あたえる",
            "word_meaning": "1) ให้\r\n2) จ่ายยาให้กับคนไข้",
            "word_usage": "คำนาม + を + 投与 + する",
            "word_ex": "栄養剤を投与する。"
        },
        {
            "id": "549",
            "kanji": "収束",
            "n_read": "しゅうそく",
            "kango_easy": "収まる",
            "e_read": "おさまる",
            "word_meaning": "สิ่งที่แตกแยกหรือสับสนกลับมารวมกันเป็นหนึ่งเดียว จบ ได้บทสรุป หรือคลี่คลาย",
            "word_usage": "คำนาม + を + 収束 + する",
            "word_ex": "争議が収束する。"
        },
        {
            "id": "550",
            "kanji": "断念",
            "n_read": "だんねん",
            "kango_easy": "諦める",
            "e_read": "あきらめる",
            "word_meaning": "ยอมแพ้ ตัดใจ ล้มเลิกความหวังของตนเองโดยเด็ดขาด",
            "word_usage": "คำนาม + を + 断念 + する",
            "word_ex": "進学を断念する。"
        },
        {
            "id": "551",
            "kanji": "目撃",
            "n_read": "もくげき",
            "kango_easy": "見える",
            "e_read": "みえる",
            "word_meaning": "บังเอิญอยู่ในสถานที่เกิดเหตุแล้วเห็นเหตุการณ์จริง เช่น เป็นพยานในอุบัติเหตุจราจร",
            "word_usage": "คำนาม + を + 目撃 + する",
            "word_ex": "交通事故を目撃する。"
        },
        {
            "id": "552",
            "kanji": "停泊",
            "n_read": "ていはく",
            "kango_easy": "停まる",
            "e_read": "とまる",
            "word_meaning": "จอดเรือโดยทอดสมอเรือลงมา เช่น จอดเรือที่ท่าเรือ",
            "word_usage": "คำนาม​​ (สถานที่) + に + 停泊 + する",
            "word_ex": "港に停泊する。"
        },
        {
            "id": "553",
            "kanji": "拠出",
            "n_read": "きょしゅつ",
            "kango_easy": "寄付する",
            "e_read": "きふする",
            "word_meaning": "รวบรวมเงินเพื่อจุดประสงค์บางอย่าง เช่น รวบรวมเงินเพื่อจัดงานเลี้ยงรุ่น รวบรวมเงินบรรเทาภัยพิบัติ",
            "word_usage": "คำนาม + を + 拠出 + する",
            "word_ex": "会費を拠出して同窓会を運営する。\r\n災害の見舞金を拠出する。"
        },
        {
            "id": "554",
            "kanji": "拠出",
            "n_read": "きょしゅつ",
            "kango_easy": "あげる",
            "e_read": "あげる",
            "word_meaning": "รวบรวมเงินเพื่อจุดประสงค์บางอย่าง เช่น รวบรวมเงินเพื่อจัดงานเลี้ยงรุ่น รวบรวมเงินบรรเทาภัยพิบัติ",
            "word_usage": "คำนาม + を + 拠出 + する",
            "word_ex": "会費を拠出して同窓会を運営する。\r\n災害の見舞金を拠出する。"
        },
        {
            "id": "555",
            "kanji": "負担",
            "n_read": "ふたん",
            "kango_easy": "負う",
            "e_read": "おう",
            "word_meaning": "1) แบกสัมภาระไว้บ่นบ่าหรือหลัง\r\n2) รับผิดชอบต่องานหรือหน้าที่ เช่น รับผิดชอบค่าใช้จ่าย",
            "word_usage": "คำนาม + を + 負担 + する",
            "word_ex": "費用は全員で負担する。"
        },
        {
            "id": "556",
            "kanji": "負担",
            "n_read": "ふたん",
            "kango_easy": "受ける",
            "e_read": "うける",
            "word_meaning": "1) แบกสัมภาระไว้บ่นบ่าหรือหลัง\r\n2) รับผิดชอบต่องานหรือหน้าที่ เช่น รับผิดชอบค่าใช้จ่าย",
            "word_usage": "คำนาม + を + 負担 + する",
            "word_ex": "費用は全員で負担する。"
        },
        {
            "id": "557",
            "kanji": "負担",
            "n_read": "ふたん",
            "kango_easy": "任せる",
            "e_read": "まかせる",
            "word_meaning": "1) แบกสัมภาระไว้บ่นบ่าหรือหลัง\r\n2) รับผิดชอบต่องานหรือหน้าที่ เช่น รับผิดชอบค่าใช้จ่าย",
            "word_usage": "คำนาม + を + 負担 + する",
            "word_ex": "費用は全員で負担する。"
        },
        {
            "id": "558",
            "kanji": "返還",
            "n_read": "へんかん",
            "kango_easy": "戻す",
            "e_read": "もどす",
            "word_meaning": "นำไปคืนที่เดิม นำไปคืนเจ้าของ",
            "word_usage": "คำนาม + を + 返還 + する",
            "word_ex": "優勝旗を返還する。"
        },
        {
            "id": "559",
            "kanji": "結成",
            "n_read": "けっせい",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "ก่อตั้งกลุ่มหรือองค์กร เช่น ตั้งพรรคใหม่ สร้างคณะละคร",
            "word_usage": "คำนาม (กลุ่มคน) + を + 結成 + する",
            "word_ex": "新党を結成する。"
        },
        {
            "id": "560",
            "kanji": "渡航",
            "n_read": "とこう",
            "kango_easy": "行く",
            "e_read": "いく",
            "word_meaning": "ออกไปต่างประเทศด้วยเครื่องบินหรือเรือ",
            "word_usage": "คำนาม (สถานที่) + に + 渡航 + する",
            "word_ex": "ギリスに渡航する。"
        },
        {
            "id": "561",
            "kanji": "渡航",
            "n_read": "とこう",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "ออกไปต่างประเทศด้วยเครื่องบินหรือเรือ",
            "word_usage": "คำนาม (สถานที่) + に + 渡航 + する",
            "word_ex": "ギリスに渡航する。"
        },
        {
            "id": "562",
            "kanji": "渡航",
            "n_read": "とこう",
            "kango_easy": "旅行する",
            "e_read": "りょこうする",
            "word_meaning": "ออกไปต่างประเทศด้วยเครื่องบินหรือเรือ",
            "word_usage": "คำนาม (สถานที่) + に + 渡航 + する",
            "word_ex": "ギリスに渡航する。"
        },
        {
            "id": "563",
            "kanji": "送還",
            "n_read": "そうかん",
            "kango_easy": "送る",
            "e_read": "おくる",
            "word_meaning": "ส่งคืน โดยเฉพาะการส่งตัวนักโทษ หรือผู้ที่เข้าประเทศอย่างผิดกฎหมายกลับประเทศเดิม",
            "word_usage": "คำนาม + を + 送還 + する",
            "word_ex": "抑留者を送還する。"
        },
        {
            "id": "564",
            "kanji": "意識",
            "n_read": "いしき",
            "kango_easy": "気づく",
            "e_read": "きづく",
            "word_meaning": "รับรู้ได้ถึงสิ่งต่าง ๆ และสถานการณ์นั้น ๆ เข้าใจอย่างชัดแจ้ง หรือใส่ใจ (คำนึงถึง)",
            "word_usage": "คำนาม + を + 意識 + する",
            "word_ex": "彼女の存在を意識する。"
        },
        {
            "id": "565",
            "kanji": "意識",
            "n_read": "いしき",
            "kango_easy": "知る",
            "e_read": "しる",
            "word_meaning": "รับรู้ได้ถึงสิ่งต่าง ๆ และสถานการณ์นั้น ๆ เข้าใจอย่างชัดแจ้ง หรือใส่ใจ (คำนึงถึง)",
            "word_usage": "คำนาม + を + 意識 + する",
            "word_ex": "彼女の存在を意識する。"
        },
        {
            "id": "566",
            "kanji": "診断",
            "n_read": "しんだん",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "แพทย์ตรวจดูคนไข้ว่าสภาพร่างกายเป็นอย่างไร แล้วชี้ว่ามีอาการป่วยของโรคใด",
            "word_usage": "คำนาม (ชื่อโรค) + と + 診断 + する",
            "word_ex": "インフルエンザと診断する。"
        },
        {
            "id": "567",
            "kanji": "診断",
            "n_read": "しんだん",
            "kango_easy": "診る",
            "e_read": "みる",
            "word_meaning": "แพทย์ตรวจดูคนไข้ว่าสภาพร่างกายเป็นอย่างไร แล้วชี้ว่ามีอาการป่วยของโรคใด",
            "word_usage": "คำนาม (ชื่อโรค) + と + 診断 + する",
            "word_ex": "インフルエンザと診断する。"
        },
        {
            "id": "568",
            "kanji": "設定",
            "n_read": "せってい",
            "kango_easy": "設ける",
            "e_read": "もうける",
            "word_meaning": "1) กำหนดสิ่งหนึ่งหรือเงื่อนไขขึ้นมา เช่น กำหนดให้ฉากเป็นสมัยเอโดะ\r\n2) ในทางกฎหมายคือการกำหนดสิทธิ์ขึ้นใหม่ เช่น กำหนดสิทธิ์จำนอง",
            "word_usage": "คำนาม + を + (คำนาม + に) + 設定 + する",
            "word_ex": "舞台を江戸時代に設定する。\r\n抵当権を設定する。"
        },
        {
            "id": "569",
            "kanji": "設定",
            "n_read": "せってい",
            "kango_easy": "定める",
            "e_read": "さだめる",
            "word_meaning": "1) กำหนดสิ่งหนึ่งหรือเงื่อนไขขึ้นมา เช่น กำหนดให้ฉากเป็นสมัยเอโดะ\r\n2) ในทางกฎหมายคือการกำหนดสิทธิ์ขึ้นใหม่ เช่น กำหนดสิทธิ์จำนอง",
            "word_usage": "คำนาม + を + (คำนาม + に) + 設定 + する",
            "word_ex": "舞台を江戸時代に設定する。\r\n抵当権を設定する。"
        },
        {
            "id": "570",
            "kanji": "設定",
            "n_read": "せってい",
            "kango_easy": "決める",
            "e_read": "きめる",
            "word_meaning": "1) กำหนดสิ่งหนึ่งหรือเงื่อนไขขึ้นมา เช่น กำหนดให้ฉากเป็นสมัยเอโดะ\r\n2) ในทางกฎหมายคือการกำหนดสิทธิ์ขึ้นใหม่ เช่น กำหนดสิทธิ์จำนอง",
            "word_usage": "คำนาม + を + (คำนาม + に) + 設定 + する",
            "word_ex": "舞台を江戸時代に設定する。\r\n抵当権を設定する。"
        },
        {
            "id": "571",
            "kanji": "批准",
            "n_read": "ひじゅん",
            "kango_easy": "約する",
            "e_read": "やくする",
            "word_meaning": "1) ให้สัตยาบรรณ (การที่รัฐหนึ่งซึ่งเป็นรัฐภาคีที่เข้าร่วมเจรจา (และ/หรือลงนามในสนธิสัญญา) ตั้งแต่แรก ได้ให้ความยินยอมของรัฐ เพื่อการผูกพันตามสนธิสัญญา โดยการให้สัตยาบันจะเป็นการยืนยันว่า สนธิสัญญามีความถูกต้องสมบูรณ์ และประสงค์จะให้มีผลบังคับใช้ตามกฎหมาย อย่างไรก็ตาม การให้สัตยาบันของแต่ละประเทศย่อมมีความแตกต่างกัน ขึ้นกับรัฐธรรมนูญและแนวทางปฏิบัติของแต่ละประเทศ)\r\n2) พระมหากษัตริย์ ตัดสินใจว่าจะอนุมัติฎีกาที่นายกรัฐมนตรีถวายหรือไม่",
            "word_usage": "คำนาม + を + 批准 + する",
            "word_ex": "講和条約を批准する。"
        },
        {
            "id": "572",
            "kanji": "批准",
            "n_read": "ひじゅん",
            "kango_easy": "認める",
            "e_read": "みとめる",
            "word_meaning": "1) ให้สัตยาบรรณ (การที่รัฐหนึ่งซึ่งเป็นรัฐภาคีที่เข้าร่วมเจรจา (และ/หรือลงนามในสนธิสัญญา) ตั้งแต่แรก ได้ให้ความยินยอมของรัฐ เพื่อการผูกพันตามสนธิสัญญา โดยการให้สัตยาบันจะเป็นการยืนยันว่า สนธิสัญญามีความถูกต้องสมบูรณ์ และประสงค์จะให้มีผลบังคับใช้ตามกฎหมาย อย่างไรก็ตาม การให้สัตยาบันของแต่ละประเทศย่อมมีความแตกต่างกัน ขึ้นกับรัฐธรรมนูญและแนวทางปฏิบัติของแต่ละประเทศ)\r\n2) พระมหากษัตริย์ ตัดสินใจว่าจะอนุมัติฎีกาที่นายกรัฐมนตรีถวายหรือไม่",
            "word_usage": "คำนาม + を + 批准 + する",
            "word_ex": "講和条約を批准する。"
        },
        {
            "id": "573",
            "kanji": "再現",
            "n_read": "さいげん",
            "kango_easy": "現す",
            "e_read": "あらわす",
            "word_meaning": "ทำให้ปรากฏอีกครั้ง หรือปรากฏอีกครั้ง เช่น จำลองสถานการณ์ตอนเกิดคดีขึ้นอีกครั้ง",
            "word_usage": "คำนาม + が + 再現 + する\r\nคำนาม + を + 再現 + する",
            "word_ex": "其時老婦人は再現した。\r\n事件の状況を再現する。"
        },
        {
            "id": "574",
            "kanji": "再現",
            "n_read": "さいげん",
            "kango_easy": "現れる",
            "e_read": "あらわれる",
            "word_meaning": "ทำให้ปรากฏอีกครั้ง หรือปรากฏอีกครั้ง เช่น จำลองสถานการณ์ตอนเกิดคดีขึ้นอีกครั้ง",
            "word_usage": "คำนาม + が + 再現 + する\r\nคำนาม + を + 再現 + する",
            "word_ex": "其時老婦人は再現した。\r\n事件の状況を再現する。"
        },
        {
            "id": "575",
            "kanji": "挑戦",
            "n_read": "ちょうせん",
            "kango_easy": "挑む",
            "e_read": "いどむ",
            "word_meaning": "1) สู้ในการต่อสู้ หรือการแข่งขันต่าง ๆ\r\n2) เผขิญหน้ากับความยากลำบากเพื่อสร้างสถิติใหม่",
            "word_usage": "คำนาม + に + 挑戦 + する",
            "word_ex": "チャンピオンに挑戦する。\r\n世界記録に挑戦する。"
        },
        {
            "id": "576",
            "kanji": "挑戦",
            "n_read": "ちょうせん",
            "kango_easy": "戦う",
            "e_read": "たたかう",
            "word_meaning": "1) สู้ในการต่อสู้ หรือการแข่งขันต่าง ๆ\r\n2) เผขิญหน้ากับความยากลำบากเพื่อสร้างสถิติใหม่",
            "word_usage": "คำนาม + に + 挑戦 + する",
            "word_ex": "チャンピオンに挑戦する。\r\n世界記録に挑戦する。"
        },
        {
            "id": "577",
            "kanji": "挑戦",
            "n_read": "ちょうせん",
            "kango_easy": "挑む",
            "e_read": "いどむ",
            "word_meaning": "1) สู้ในการต่อสู้ หรือการแข่งขันต่าง ๆ\r\n2) เผขิญหน้ากับความยากลำบากเพื่อสร้างสถิติใหม่",
            "word_usage": "คำนาม + に + 挑戦 + する",
            "word_ex": "チャンピオンに挑戦する。\r\n世界記録に挑戦する。"
        },
        {
            "id": "578",
            "kanji": "擁護",
            "n_read": "ようご",
            "kango_easy": "守る",
            "e_read": "まもる",
            "word_meaning": "ป้องกันจากการถูกละเมิดหรือจากอันตราย เช่น ปกป้องสิทธิมนุษยชน, ปกป้องรัฐธรรมนูญ",
            "word_usage": "คำนาม + を + 擁護 + する",
            "word_ex": "憲法を擁護する。"
        },
        {
            "id": "579",
            "kanji": "反撃",
            "n_read": "はんげき",
            "kango_easy": "攻める",
            "e_read": "せめる",
            "word_meaning": "โจมตีศัตรูกลับ",
            "word_usage": "คำนาม + が + 反撃 + する",
            "word_ex": "帝国は反撃する。"
        },
        {
            "id": "580",
            "kanji": "着用",
            "n_read": "ちゃくよう",
            "kango_easy": "着る",
            "e_read": "きる",
            "word_meaning": "สวมใส่เสื้อผ้า เช่น สวมเครื่องแบบ สวมหมวกกันน็อค",
            "word_usage": "คำนาม + を + 着用 + する",
            "word_ex": "制服を着用する。"
        },
        {
            "id": "581",
            "kanji": "削除",
            "n_read": "さくじょ",
            "kango_easy": "消す",
            "e_read": "けす",
            "word_meaning": "ลบบทความบางส่วนออก เช่น ลบข้อความที่ไม่เหมาะสม",
            "word_usage": "คำนาม + を + 削除 + する",
            "word_ex": "不穏当な文句を削除する。"
        },
        {
            "id": "582",
            "kanji": "普及",
            "n_read": "ふきゅう",
            "kango_easy": "流行る",
            "e_read": "はやる",
            "word_meaning": "แพร่กระจายไปอย่างกว้างขวาง หรือทำให้แพร่กระจาย",
            "word_usage": "คำนาม + を + 普及 + する\r\nคำนาม + が + 普及 + する",
            "word_ex": "新理論を普及する。\r\n一般家庭にクーラーが普及する。"
        },
        {
            "id": "583",
            "kanji": "普及",
            "n_read": "ふきゅう",
            "kango_easy": "広げる",
            "e_read": "ひろげる",
            "word_meaning": "แพร่กระจายไปอย่างกว้างขวาง หรือทำให้แพร่กระจาย",
            "word_usage": "คำนาม + を + 普及 + する\r\nคำนาม + が + 普及 + する",
            "word_ex": "新理論を普及する。\r\n一般家庭にクーラーが普及する。"
        },
        {
            "id": "584",
            "kanji": "普及",
            "n_read": "ふきゅう",
            "kango_easy": "広がる",
            "e_read": "ひろがる",
            "word_meaning": "แพร่กระจายไปอย่างกว้างขวาง หรือทำให้แพร่กระจาย",
            "word_usage": "คำนาม + を + 普及 + する\r\nคำนาม + が + 普及 + する",
            "word_ex": "新理論を普及する。\r\n一般家庭にクーラーが普及する。"
        },
        {
            "id": "585",
            "kanji": "申告",
            "n_read": "しんこく",
            "kango_easy": "願う",
            "e_read": "ねがう",
            "word_meaning": "1) แจ้ง เช่น แจ้งการเปลี่ยนตัวนักกีฬา\r\n2) ประชาชนแจ้งข้อเท็จจริงตามกำหนดต่อเจ้าหน้าที่รัฐ ตามหน้าที่ทางกฎหมาย",
            "word_usage": "คำนาม + を + 申告 + する",
            "word_ex": "選手の交替を申告する。\r\n一時所得として申告する。"
        },
        {
            "id": "586",
            "kanji": "申告",
            "n_read": "しんこく",
            "kango_easy": "知らせる",
            "e_read": "しらせる",
            "word_meaning": "1) แจ้ง เช่น แจ้งการเปลี่ยนตัวนักกีฬา\r\n2) ประชาชนแจ้งข้อเท็จจริงตามกำหนดต่อเจ้าหน้าที่รัฐ ตามหน้าที่ทางกฎหมาย",
            "word_usage": "คำนาม + を + 申告 + する",
            "word_ex": "選手の交替を申告する。\r\n一時所得として申告する。"
        },
        {
            "id": "587",
            "kanji": "出港",
            "n_read": "しゅっこう",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "(เรือ) ออกจากท่าเรือ",
            "word_usage": "คำนาม + を + 出港 + する",
            "word_ex": "横浜を出港する。"
        },
        {
            "id": "588",
            "kanji": "待機",
            "n_read": "たいき",
            "kango_easy": "待つ",
            "e_read": "まつ",
            "word_meaning": "เตรียมพร้อมเพื่อรอจังหวะ หรือโอกาส เช่น รอหน่วยกู้ภัย",
            "word_usage": "คำนาม + が + 待機 + する",
            "word_ex": "救護班が待機する。"
        },
        {
            "id": "589",
            "kanji": "再燃",
            "n_read": "さいねん",
            "kango_easy": "燃える",
            "e_read": "もえる",
            "word_meaning": "1) ไฟที่ดับไปแล้วครั้งหนึ่งกลับมาลุกไหม้อีกครั้ง เผาอีกครั้ง\r\n2) สิ่งที่อ่อนแอลงกลับมามีเรี่ยวแรงขึ้นอีกครั้ง\r\n3) เรื่องที่เคยคลี่คลายไปแล้วสักระยะกลายมาเป็นปัญหาอีกครั้ง",
            "word_usage": "คำนาม + が + 再燃 + する",
            "word_ex": "財政問題が再燃する。"
        },
        {
            "id": "590",
            "kanji": "再燃",
            "n_read": "さいねん",
            "kango_easy": "問題になる",
            "e_read": "もんだいになる",
            "word_meaning": "1) ไฟที่ดับไปแล้วครั้งหนึ่งกลับมาลุกไหม้อีกครั้ง เผาอีกครั้ง\r\n2) สิ่งที่อ่อนแอลงกลับมามีเรี่ยวแรงขึ้นอีกครั้ง\r\n3) เรื่องที่เคยคลี่คลายไปแล้วสักระยะกลายมาเป็นปัญหาอีกครั้ง",
            "word_usage": "คำนาม + が + 再燃 + する",
            "word_ex": "財政問題が再燃する。"
        },
        {
            "id": "591",
            "kanji": "放棄",
            "n_read": "ほうき",
            "kango_easy": "捨てる",
            "e_read": "すてる",
            "word_meaning": "1) ทิ้งขว้าง ทิ้งไว้ข้างหลัง ไม่หันกลับมาดู เช่น ทิ้งความรับผิดชอบ\r\n2) ทิ้งสิทธิ์ คุณสมบัติ ของตนโดยไม่นำมาใช้",
            "word_usage": "คำนาม + を + 放棄 + する",
            "word_ex": "責任を放棄する。\r\n権利を放棄する。"
        },
        {
            "id": "592",
            "kanji": "回収",
            "n_read": "かいしゅう",
            "kango_easy": "集める",
            "e_read": "あつめる",
            "word_meaning": "1) รวบรวมของแจกจ่ายไปหรือใช้แล้วกลับมา เช่น เก็บแบบสอบถามคืนมา\r\n2) นำดาวเทียมหรือยานอวกาศกลับคืนสู่พื้นทวีป",
            "word_usage": "คำนาม + を + 回収 + する",
            "word_ex": "調査用紙を回収する。"
        },
        {
            "id": "593",
            "kanji": "回収",
            "n_read": "かいしゅう",
            "kango_easy": "戻す",
            "e_read": "もどす",
            "word_meaning": "1) รวบรวมของแจกจ่ายไปหรือใช้แล้วกลับมา เช่น เก็บแบบสอบถามคืนมา\r\n2) นำดาวเทียมหรือยานอวกาศกลับคืนสู่พื้นทวีป",
            "word_usage": "คำนาม + を + 回収 + する",
            "word_ex": "調査用紙を回収する。"
        },
        {
            "id": "594",
            "kanji": "創設",
            "n_read": "そうせつ",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "สร้างสถาบันหรือองค์กรขึ้นมาใหม่ เช่น สถาปนาโรงเรียน ก่อตั้งบริษัท",
            "word_usage": "คำนาม + を + 創設 + する",
            "word_ex": "学校を創設する。\r\n会社を創設する。"
        },
        {
            "id": "595",
            "kanji": "移転",
            "n_read": "いてん",
            "kango_easy": "移す",
            "e_read": "うつす",
            "word_meaning": "1) ย้ายตำแหน่งหรือสถานที่ เช่น ย้ายสำนักงาน\r\n2) สถานการณ์เปลี่ยน\r\n3) ในทางกฎหมาย หมายถึง ความเป็นเจ้าของสิทธิ์ถูกย้ายจากบุคคลหนึ่งไปยังอีกบุคคลหนึ่ง",
            "word_usage": "คำนาม + を + 普及 + する\r\nคำนาม + が + 普及 + する",
            "word_ex": "権利を移転する。\r\n事務所が移転する。"
        },
        {
            "id": "596",
            "kanji": "移転",
            "n_read": "いてん",
            "kango_easy": "変わる",
            "e_read": "かわる",
            "word_meaning": "1) ย้ายตำแหน่งหรือสถานที่ เช่น ย้ายสำนักงาน\r\n2) สถานการณ์เปลี่ยน\r\n3) ในทางกฎหมาย หมายถึง ความเป็นเจ้าของสิทธิ์ถูกย้ายจากบุคคลหนึ่งไปยังอีกบุคคลหนึ่ง",
            "word_usage": "คำนาม + を + 普及 + する\r\nคำนาม + が + 普及 + する",
            "word_ex": "権利を移転する。\r\n事務所が移転する。"
        },
        {
            "id": "597",
            "kanji": "誇示",
            "n_read": "こじ",
            "kango_easy": "見せる",
            "e_read": "みせる",
            "word_meaning": "ชี้ให้เห็นอย่างหยิ่งทะนง แสดงความภาคภูมิใจ (โอ้อวด) เช่น โอ้อวดความสำเร็จ",
            "word_usage": "คำนาม + を + 誇示 + する",
            "word_ex": "成功を誇示する。"
        },
        {
            "id": "598",
            "kanji": "誇示",
            "n_read": "こじ",
            "kango_easy": "示す",
            "e_read": "しめす",
            "word_meaning": "ชี้ให้เห็นอย่างหยิ่งทะนง แสดงความภาคภูมิใจ (โอ้อวด) เช่น โอ้อวดความสำเร็จ",
            "word_usage": "คำนาม + を + 誇示 + する",
            "word_ex": "成功を誇示する。"
        },
        {
            "id": "599",
            "kanji": "復活",
            "n_read": "ふっかつ",
            "kango_easy": "戻す",
            "e_read": "もどす",
            "word_meaning": "1) สิ่งที่ตายไปแล้ว กลับมามีชีวิตอีกครั้ง\r\n2) นำสิ่งที่เคยยกเลิกไปแล้วครั้งหนึ่งกลับมาสู่สภาพเดิม หรือสิ่งที่หายไปหรืออ่อนกำลังลงกลับมาสู่สภาพเดิมอีกครั้ง",
            "word_usage": "คำนาม + を + 復活 + する\r\nคำนาม + が + 復活 + する",
            "word_ex": "対抗試合を復活する。\r\n旧制度が復活する。"
        },
        {
            "id": "600",
            "kanji": "復活",
            "n_read": "ふっかつ",
            "kango_easy": "戻る",
            "e_read": "もどる",
            "word_meaning": "1) สิ่งที่ตายไปแล้ว กลับมามีชีวิตอีกครั้ง\r\n2) นำสิ่งที่เคยยกเลิกไปแล้วครั้งหนึ่งกลับมาสู่สภาพเดิม หรือสิ่งที่หายไปหรืออ่อนกำลังลงกลับมาสู่สภาพเดิมอีกครั้ง",
            "word_usage": "คำนาม + を + 復活 + する\r\nคำนาม + が + 復活 + する",
            "word_ex": "対抗試合を復活する。\r\n旧制度が復活する。"
        },
        {
            "id": "601",
            "kanji": "失望",
            "n_read": "しつぼう",
            "kango_easy": "失う",
            "e_read": "うしなう",
            "word_meaning": "ผิดหวังเพราะไม่เป็นไปตามที่คาดหวังไว้ สิ้นหวัง",
            "word_usage": "คำนาม + に + 復活 + する",
            "word_ex": "彼にはまったく失望した​。"
        },
        {
            "id": "602",
            "kanji": "失望",
            "n_read": "しつぼう",
            "kango_easy": "",
            "e_read": "がっかり",
            "word_meaning": "ผิดหวังเพราะไม่เป็นไปตามที่คาดหวังไว้ สิ้นหวัง",
            "word_usage": "คำนาม + に + 復活 + する",
            "word_ex": "彼にはまったく失望した​。"
        },
        {
            "id": "603",
            "kanji": "交換",
            "n_read": "こうかん",
            "kango_easy": "換える",
            "e_read": "かえる",
            "word_meaning": "แลกเปลี่ยนสิ่งของซึ่งกันและกัน เช่น แลกเปลี่ยนความคิดเห็น",
            "word_usage": "คำนาม + を + 交換 + する",
            "word_ex": "意見を交換する。"
        },
        {
            "id": "604",
            "kanji": "引退",
            "n_read": "いんたい",
            "kango_easy": "辞める",
            "e_read": "やめる",
            "word_meaning": "ลาออกจากตำแหน่งหรือสถานะหนึ่ง ถอนตัวจากตำแหน่งปัจจุบันในกีฬา เช่น นักกีฬาดาวเด่นถอนตัว (จากทีม)",
            "word_usage": "คำนาม + を + 引退 + する\r\nคำนาม + が + 引退 + する",
            "word_ex": "重役を引退する。\r\nスター選手が引退する。"
        },
        {
            "id": "605",
            "kanji": "撤去",
            "n_read": "てっきょ",
            "kango_easy": "取り去る",
            "e_read": "とりさる",
            "word_meaning": "ถอนสิ่งปลูกสร้าง หรือกำจัดสิ่งของออก เช่น รื้อถอนสิ่งปลูกสร้างที่ผิดกฎหมาย กำจัดสิ่งกีดขวาง",
            "word_usage": "คำนาม + を + ​撤去 + する",
            "word_ex": "不法建築物を撤去する。"
        },
        {
            "id": "606",
            "kanji": "即位",
            "n_read": "そくい",
            "kango_easy": "",
            "e_read": "つく",
            "word_meaning": "(พระมหากษัตริย์หรือจักรพรรดิ) ขึ้นครองราชย์",
            "word_usage": "คำนาม + が + ​即位 + する",
            "word_ex": "新しい君主が即位する。"
        },
        {
            "id": "607",
            "kanji": "管轄",
            "n_read": "かんかつ",
            "kango_easy": "コントロール",
            "e_read": "",
            "word_meaning": "ปกครองพื้นที่ที่กำหนดไว้ตามอำนาจที่มี",
            "word_usage": "คำนาม + を + ​管轄 + する",
            "word_ex": "不動産の所在地を管轄する。"
        },
        {
            "id": "608",
            "kanji": "遮断",
            "n_read": "しゃだん",
            "kango_easy": "遮る",
            "e_read": "さえぎる",
            "word_meaning": "หยุดโดยเข้าไปขวางการเคลื่อนไหว เช่น ปิดกั้นการจราจร",
            "word_usage": "คำนาม + が + ​遮断 + する",
            "word_ex": "交通を一時遮断する。"
        },
        {
            "id": "609",
            "kanji": "遮断",
            "n_read": "しゃだん",
            "kango_easy": "止める",
            "e_read": "とめる",
            "word_meaning": "หยุดโดยเข้าไปขวางการเคลื่อนไหว เช่น ปิดกั้นการจราจร",
            "word_usage": "คำนาม + が + ​遮断 + する",
            "word_ex": "交通を一時遮断する。"
        },
        {
            "id": "610",
            "kanji": "誘導",
            "n_read": "ゆうどう",
            "kango_easy": "導く",
            "e_read": "みちびく",
            "word_meaning": "นำสิ่งของหรือนำทางคนไปยังสถานที่หนึ่ง ๆ เช่น นำรถไปยังจุดจอดรถ นำทางลูกค้าไปยังทางออกฉุกเฉิน",
            "word_usage": "คำนาม + を + คำนาม (สถานที่, สภาพ) + に/へ + ​誘導 + する",
            "word_ex": "車を停止位置に誘導する。\r\n客を非常口へ誘導する。"
        },
        {
            "id": "611",
            "kanji": "報復",
            "n_read": "ほうふく",
            "kango_easy": "返す",
            "e_read": "かえす",
            "word_meaning": "โต้กลับ แก้แค้น เอาคืน",
            "word_usage": "คำนาม + に + ​報復 + する",
            "word_ex": "敵に報復する。"
        },
        {
            "id": "612",
            "kanji": "賛成",
            "n_read": "さんせい",
            "kango_easy": "認める",
            "e_read": "みとめる",
            "word_meaning": "1) ยอมรับข้อเสนอ ความคิดเห็น หรือการกระทำของคน (เห็นด้วย)\r\n2) ช่วยเหลือเพื่อให้สำเร็จลุล่วง เช่น สนับสนุนร่างกฎหมาย",
            "word_usage": "คำนาม + に + ​賛成 + する\r\nคำนาม + を + ​賛成 + する",
            "word_ex": "君の意見に賛成する。\r\n原案を賛成する。"
        },
        {
            "id": "613",
            "kanji": "外出",
            "n_read": "がいしゅつ",
            "kango_easy": "出かける",
            "e_read": "でかける",
            "word_meaning": "ออกไปข้างนอก",
            "word_usage": "คำนาม + が + ​外出 + する",
            "word_ex": "急用で外出する。"
        },
        {
            "id": "614",
            "kanji": "配信",
            "n_read": "はいしん",
            "kango_easy": "送る",
            "e_read": "おくる",
            "word_meaning": "กระจายข้อมูลหรือข่าวสาร, ออกอากาศ, ส่งต่อข้อมูล",
            "word_usage": "คำนาม + を + ​配信 + する",
            "word_ex": "その会社は毎週メールニュースを配信する。"
        },
        {
            "id": "615",
            "kanji": "配信",
            "n_read": "はいしん",
            "kango_easy": "配る",
            "e_read": "くばる",
            "word_meaning": "กระจายข้อมูลหรือข่าวสาร, ออกอากาศ, ส่งต่อข้อมูล",
            "word_usage": "คำนาม + を + ​配信 + する",
            "word_ex": "その会社は毎週メールニュースを配信する。"
        },
        {
            "id": "616",
            "kanji": "演奏",
            "n_read": "えんそう",
            "kango_easy": "",
            "e_read": "する",
            "word_meaning": "เล่นดนตรี",
            "word_usage": "คำนาม + を + ​演奏 + する",
            "word_ex": "ピアノを演奏する。"
        },
        {
            "id": "617",
            "kanji": "演奏",
            "n_read": "えんそう",
            "kango_easy": "奏する",
            "e_read": "そうする",
            "word_meaning": "เล่นดนตรี",
            "word_usage": "คำนาม + を + ​演奏 + する",
            "word_ex": "ピアノを演奏する。"
        },
        {
            "id": "618",
            "kanji": "凍結",
            "n_read": "とうけつ",
            "kango_easy": "凍る",
            "e_read": "こおる",
            "word_meaning": "1) กลายเป็นน้ำแข็ง ทำให้กลายเป็นน้ำแข็ง\r\n2) ห้ามเคลื่อนย้ายอสังหารริมทรัพย์ หรือห้ามใช้เงินทุนเป็นการชั่วคราว, สถาบันการเงินหยุดการทำธุรกรรมทางการเงินเช่นการฝากถอนเงินในบัญชีของลูกค้า (อาญัติ)\r\n3) ระงับการดำเนินการที่กำหนดไว้",
            "word_usage": "คำนาม + を + 凍結 + する\r\nคำนาม + が + 凍結 + する",
            "word_ex": "湖面が凍結する。\r\n資産を凍結する。\r\n建設計画を凍結する。"
        },
        {
            "id": "619",
            "kanji": "凍結",
            "n_read": "とうけつ",
            "kango_easy": "禁止する",
            "e_read": "きんしする",
            "word_meaning": "1) กลายเป็นน้ำแข็ง ทำให้กลายเป็นน้ำแข็ง\r\n2) ห้ามเคลื่อนย้ายอสังหารริมทรัพย์ หรือห้ามใช้เงินทุนเป็นการชั่วคราว, สถาบันการเงินหยุดการทำธุรกรรมทางการเงินเช่นการฝากถอนเงินในบัญชีของลูกค้า (อาญัติ)\r\n3) ระงับการดำเนินการที่กำหนดไว้",
            "word_usage": "คำนาม + を + 凍結 + する\r\nคำนาม + が + 凍結 + する",
            "word_ex": "湖面が凍結する。\r\n資産を凍結する。\r\n建設計画を凍結する。"
        },
        {
            "id": "620",
            "kanji": "凍結",
            "n_read": "とうけつ",
            "kango_easy": "止める",
            "e_read": "やめる",
            "word_meaning": "1) กลายเป็นน้ำแข็ง ทำให้กลายเป็นน้ำแข็ง\r\n2) ห้ามเคลื่อนย้ายอสังหารริมทรัพย์ หรือห้ามใช้เงินทุนเป็นการชั่วคราว, สถาบันการเงินหยุดการทำธุรกรรมทางการเงินเช่นการฝากถอนเงินในบัญชีของลูกค้า (อาญัติ)\r\n3) ระงับการดำเนินการที่กำหนดไว้",
            "word_usage": "คำนาม + を + 凍結 + する\r\nคำนาม + が + 凍結 + する",
            "word_ex": "湖面が凍結する。\r\n資産を凍結する。\r\n建設計画を凍結する。"
        },
        {
            "id": "621",
            "kanji": "抵抗",
            "n_read": "ていこう",
            "kango_easy": "逆らう",
            "e_read": "さからう",
            "word_meaning": "ต่อสู้หรือต้านทานแรงจากภายนอก ต่อต้าน ขัดขืน",
            "word_usage": "คำนาม + に + คำนาม + が + ​抵抗 + する",
            "word_ex": "大手資本の進出に地元の商店会が抵抗する。"
        },
        {
            "id": "622",
            "kanji": "抵抗",
            "n_read": "ていこう",
            "kango_easy": "戦う",
            "e_read": "たたかう",
            "word_meaning": "ต่อสู้หรือต้านทานแรงจากภายนอก ต่อต้าน ขัดขืน",
            "word_usage": "คำนาม + に + คำนาม + が + ​抵抗 + する",
            "word_ex": "大手資本の進出に地元の商店会が抵抗する。"
        },
        {
            "id": "623",
            "kanji": "承知",
            "n_read": "しょうち",
            "kango_easy": "",
            "e_read": "わかる",
            "word_meaning": "1) รู้ เข้าใจ เช่น อยากรู้ว่าเกิดอะไรขึ้น\r\n2) รับฟังคำขอ หรือความต้องการ ยอมรับ เช่น รับทราบคำขอเป็นที่เรียบร้อยแล้ว\r\n3) ทำความเข้าใจอีกฝ่ายพร้อมให้อภัย มักใช้ในเชิงลบ เช่น (ให้อภัยแต่) หลังจากนี้ไม่รู้แล้วนะ",
            "word_usage": "คำนาม + を + ​承知 + する",
            "word_ex": "事の経緯を承知しておきたい。\r\n申し出の件、確かに承知した。\r\nこの次からは承知しないぞ。"
        },
        {
            "id": "624",
            "kanji": "承知",
            "n_read": "しょうち",
            "kango_easy": "知る",
            "e_read": "しる",
            "word_meaning": "1) รู้ เข้าใจ เช่น อยากรู้ว่าเกิดอะไรขึ้น\r\n2) รับฟังคำขอ หรือความต้องการ ยอมรับ เช่น รับทราบคำขอเป็นที่เรียบร้อยแล้ว\r\n3) ทำความเข้าใจอีกฝ่ายพร้อมให้อภัย มักใช้ในเชิงลบ เช่น (ให้อภัยแต่) หลังจากนี้ไม่รู้แล้วนะ",
            "word_usage": "คำนาม + を + ​承知 + する",
            "word_ex": "事の経緯を承知しておきたい。\r\n申し出の件、確かに承知した。\r\nこの次からは承知しないぞ。"
        },
        {
            "id": "625",
            "kanji": "称賛",
            "n_read": "しょうさん",
            "kango_easy": "褒める",
            "e_read": "ほめる",
            "word_meaning": "ยกย่องชมเชย",
            "word_usage": "คำนาม + を + ​称賛 + する",
            "word_ex": "人の努力を称賛する。"
        },
        {
            "id": "626",
            "kanji": "追求",
            "n_read": "ついきゅう",
            "kango_easy": "追い求める",
            "e_read": "おいもとめる",
            "word_meaning": "ไล่ตามไปจนกว่าจะบรรลุเป้าหมาย เช่น แสวงหาผลกำไร",
            "word_usage": "คำนาม + を + ​追求 + する",
            "word_ex": "利潤を追求する。"
        },
        {
            "id": "627",
            "kanji": "明記",
            "n_read": "めいき",
            "kango_easy": "書く",
            "e_read": "かく",
            "word_meaning": "เขียนให้ชัดเจน",
            "word_usage": "คำนาม + を + ​明記 + する",
            "word_ex": "欠席の理由を明記する。"
        },
        {
            "id": "628",
            "kanji": "明記",
            "n_read": "めいき",
            "kango_easy": "はっきり",
            "e_read": "はっきり",
            "word_meaning": "เขียนให้ชัดเจน",
            "word_usage": "คำนาม + を + ​明記 + する",
            "word_ex": "欠席の理由を明記する。"
        },
        {
            "id": "629",
            "kanji": "同行",
            "n_read": "どうこう",
            "kango_easy": "行く",
            "e_read": "行く",
            "word_meaning": "ไปด้วยกัน ติดตามบุคคลหนึ่งไป",
            "word_usage": "คำนาม + に + ​同行 + する",
            "word_ex": "警察へ同行する。"
        },
        {
            "id": "630",
            "kanji": "同行",
            "n_read": "どうこう",
            "kango_easy": "同じ",
            "e_read": "おなじ",
            "word_meaning": "ไปด้วยกัน ติดตามบุคคลหนึ่งไป",
            "word_usage": "คำนาม + に + ​同行 + する",
            "word_ex": "警察へ同行する。"
        },
        {
            "id": "631",
            "kanji": "採取",
            "n_read": "さいしゅ",
            "kango_easy": "取る",
            "e_read": "とる",
            "word_meaning": "1) รวบรวมเพื่อทำการวิจัยหรือสำรวจ เช่น เก็บลายนิ้วมือ\r\n2) คัดเลือกแร่ พืช หรือเปลือกหอย เช่น รวบรวมกรวด",
            "word_usage": "คำนาม + を + ​採取 + する",
            "word_ex": "指紋を採取する。\r\n砂利を採取する。"
        },
        {
            "id": "632",
            "kanji": "運用",
            "n_read": "うんよう",
            "kango_easy": "用いる",
            "e_read": "もちいる",
            "word_meaning": "1) ใช้งานฟังก์ชันของสิ่งนั้น ๆ ใช้ประโยชน์\r\n2) เปลี่ยนเงินให้อยู่ในสินทรัพย์รูปแบบอื่นเพื่อจุดประสงค์ในการทำเงิน เช่น จัดการทรัพย์สิน\r\n3) ขับ โดยเฉพาะการควบคุมเรือ",
            "word_usage": "คำนาม + を + ​運用 + する",
            "word_ex": "機械を運用する。\r\n財産を運用する。\r\n船舶を運用する。"
        },
        {
            "id": "633",
            "kanji": "運用",
            "n_read": "うんよう",
            "kango_easy": "使う",
            "e_read": "つかう",
            "word_meaning": "1) ใช้งานฟังก์ชันของสิ่งนั้น ๆ ใช้ประโยชน์\r\n2) เปลี่ยนเงินให้อยู่ในสินทรัพย์รูปแบบอื่นเพื่อจุดประสงค์ในการทำเงิน เช่น จัดการทรัพย์สิน\r\n3) ขับ โดยเฉพาะการควบคุมเรือ",
            "word_usage": "คำนาม + を + ​運用 + する",
            "word_ex": "機械を運用する。\r\n財産を運用する。\r\n船舶を運用する。"
        },
        {
            "id": "634",
            "kanji": "運用",
            "n_read": "うんよう",
            "kango_easy": "変える",
            "e_read": "かえる",
            "word_meaning": "1) ใช้งานฟังก์ชันของสิ่งนั้น ๆ ใช้ประโยชน์\r\n2) เปลี่ยนเงินให้อยู่ในสินทรัพย์รูปแบบอื่นเพื่อจุดประสงค์ในการทำเงิน เช่น จัดการทรัพย์สิน\r\n3) ขับ โดยเฉพาะการควบคุมเรือ",
            "word_usage": "คำนาม + を + ​運用 + する",
            "word_ex": "機械を運用する。\r\n財産を運用する。\r\n船舶を運用する。"
        },
        {
            "id": "635",
            "kanji": "機能",
            "n_read": "きのう",
            "kango_easy": "",
            "e_read": "ファンクション",
            "word_meaning": "ทำหน้าที่ (ซึ่งเป็นการทำงานที่ติดมากับสิ่งนั้น ๆ) เช่น ระบบทำงานเป็นปกติ",
            "word_usage": "คำนาม + が + ​機能 + する",
            "word_ex": "このシステムは衣類を通しても機能する。"
        },
        {
            "id": "636",
            "kanji": "欠航",
            "n_read": "けっこう",
            "kango_easy": "",
            "e_read": "やめる",
            "word_meaning": "หยุดการเดินเรือหรือหยุดทำการบิน เนื่องจากอุบัติเหตุหรือสภาพอากาศที่แปรปรวน",
            "word_usage": "คำนาม (สาเหตุ) + で + ​欠航 + する",
            "word_ex": "荒天のため欠航する。"
        },
        {
            "id": "637",
            "kanji": "欠航",
            "n_read": "けっこう",
            "kango_easy": "足りない",
            "e_read": "たりない",
            "word_meaning": "หยุดการเดินเรือหรือหยุดทำการบิน เนื่องจากอุบัติเหตุหรือสภาพอากาศที่แปรปรวน",
            "word_usage": "คำนาม (สาเหตุ) + で + ​欠航 + する",
            "word_ex": "荒天のため欠航する。"
        },
        {
            "id": "638",
            "kanji": "団結",
            "n_read": "だんけつ",
            "kango_easy": "集まる",
            "e_read": "あつまる",
            "word_meaning": "คนจำนวนมากรวมเป็นหนึ่งเดียวกันเพื่อวัตถุประสงค์ร่วมกัน (รวมกลุ่ม)",
            "word_usage": "คำนาม + が + 団結 + する\r\nคำนาม + を + 団結 + させる",
            "word_ex": "小売店は団結してデパートに対抗した。\r\nクラスを団結させる。"
        },
        {
            "id": "639",
            "kanji": "団結",
            "n_read": "だんけつ",
            "kango_easy": "",
            "e_read": "まとまる",
            "word_meaning": "คนจำนวนมากรวมเป็นหนึ่งเดียวกันเพื่อวัตถุประสงค์ร่วมกัน (รวมกลุ่ม)",
            "word_usage": "คำนาม + が + 団結 + する\r\nคำนาม + を + 団結 + させる",
            "word_ex": "小売店は団結してデパートに対抗した。\r\nクラスを団結させる。"
        },
        {
            "id": "640",
            "kanji": "提訴",
            "n_read": "ていそ",
            "kango_easy": "訴える",
            "e_read": "うったえる",
            "word_meaning": "ฟ้องร้อง ยื่นฟ้อง เช่น ยื่นฟ้องต่อคณะกรรมการ",
            "word_usage": "คำนาม + に + 提訴 + する",
            "word_ex": "委員会に提訴する。"
        },
        {
            "id": "641",
            "kanji": "黙認",
            "n_read": "もくにん",
            "kango_easy": "認める",
            "e_read": "みとめる",
            "word_meaning": "ยอมรับไปโดยปริยาย มองข้ามข้อผิดพลาด เช่น ยอมรับโดยถือว่าเป็นเรื่องที่หลีกเลี่ยงไม่ได้",
            "word_usage": "คำนาม + を + ​黙認 + する",
            "word_ex": "やむを得ないこととして黙認する。"
        },
        {
            "id": "642",
            "kanji": "横断",
            "n_read": "おうだん",
            "kango_easy": "渡る",
            "e_read": "わたる",
            "word_meaning": "1) ข้ามถนนและแม่น้ำจากด้านหนึ่งไปอีกด้านหนึ่ง\r\n2) ผ่านทวีปหรือมหาสมุทรไปทางทิศตะวันออกและตะวันตก",
            "word_usage": "คำนาม + を + ​横断 + する",
            "word_ex": "道路を横断する。\r\nアメリカ大陸を横断する。"
        },
        {
            "id": "643",
            "kanji": "横断",
            "n_read": "おうだん",
            "kango_easy": "通る",
            "e_read": "とおる",
            "word_meaning": "1) ข้ามถนนและแม่น้ำจากด้านหนึ่งไปอีกด้านหนึ่ง\r\n2) ผ่านทวีปหรือมหาสมุทรไปทางทิศตะวันออกและตะวันตก",
            "word_usage": "คำนาม + を + ​横断 + する",
            "word_ex": "道路を横断する。\r\nアメリカ大陸を横断する。"
        },
        {
            "id": "644",
            "kanji": "収容",
            "n_read": "しゅうよう",
            "kango_easy": "入れる",
            "e_read": "いれる",
            "word_meaning": "บรรจุคนหรือสิ่งของเข้าไปในสถานที่ที่กำหนดไว้ เช่น ฮอลล์บรรจุคนได้ 1,000 คน",
            "word_usage": "คำนาม + を + ​収容 + する",
            "word_ex": "千人を収納できるホール。"
        },
        {
            "id": "645",
            "kanji": "被爆",
            "n_read": "ひばく",
            "kango_easy": "爆弾",
            "e_read": "ばくだん",
            "word_meaning": "1) ถูกระเบิด\r\n2) ถูกโจมตีจากระเบิดปรมาณู และได้รับอันตรายจากกัมมันตรังสี",
            "word_usage": "คำนาม (สาเหตุ) + で + ​被曝 + する",
            "word_ex": "空襲で被爆する。\r\n核実験で被爆する。"
        },
        {
            "id": "646",
            "kanji": "被爆",
            "n_read": "ひばく",
            "kango_easy": "ボム",
            "e_read": "",
            "word_meaning": "1) ถูกระเบิด\r\n2) ถูกโจมตีจากระเบิดปรมาณู และได้รับอันตรายจากกัมมันตรังสี",
            "word_usage": "คำนาม (สาเหตุ) + で + ​被曝 + する",
            "word_ex": "空襲で被爆する。\r\n核実験で被爆する。"
        },
        {
            "id": "647",
            "kanji": "賛同",
            "n_read": "さんどう",
            "kango_easy": "賛成する",
            "e_read": "さんせいする",
            "word_meaning": "เห็นด้วยหรือยอมรับความเห็นหรือข้อเสนอของผู้อื่น",
            "word_usage": "คำนาม + に + 賛同 + する",
            "word_ex": "趣旨に賛同する。"
        },
        {
            "id": "648",
            "kanji": "樹立",
            "n_read": "じゅりつ",
            "kango_easy": "作る",
            "e_read": "つくる",
            "word_meaning": "สร้าง หรือก่อตั้ง เช่น สร้างสถิติโลกใหม่",
            "word_usage": "คำนาม + を + ​樹立 + する",
            "word_ex": "世界新記録を樹立する。"
        },
        {
            "id": "649",
            "kanji": "殺到",
            "n_read": "さっとう",
            "kango_easy": "倒れる",
            "e_read": "たおれる",
            "word_meaning": "คนหรือสิ่งของจำนวนมากพุ่งเป้าไปที่สิ่งใดสิ่งหนึ่งหรือสถานที่ใดสถานที่หนึ่งในเวลาเดียวกัน เช่น ยอดสมัครถล่มทลาย, กรูกันไปยังทางออกฉุกเฉิน",
            "word_usage": "คำนาม + が + คำนาม (ปลายทาง) + に + 殺到 + する",
            "word_ex": "非常口に殺到する。\r\n申し込みが殺到する。"
        },
        {
            "id": "650",
            "kanji": "検査",
            "n_read": "けんさ",
            "kango_easy": "調べる",
            "e_read": "しらべる",
            "word_meaning": "ตรวจสอบว่าปกติหรือผิดปกติ เหมาะสมหรือไม่เหมาะสม โดยอ้างอิงจากเกณฑ์หนึ่ง เช่น ตรวจสอบเครื่องจักร",
            "word_usage": "คำนาม + を + ​検査 + する",
            "word_ex": "機械を検査する。"
        },
        {
            "id": "651",
            "kanji": "動員",
            "n_read": "どういん",
            "kango_easy": "集める",
            "e_read": "あつめる",
            "word_meaning": "1) เปลี่ยนการจัดทัพของกองกำลังทหารจากการจัดทัพแบบยามสงบเป็นยามศึกสงคราม หรือเรียกกำลังพลทหาร เช่น ถูกเรียกรวมพลไปรบในแนวหน้า\r\n2) รวมทรัพยากรภายในประเทศ โรงงาน หรือกำลังคนไว้ภายใต้การควบคุมของรัฐบาล เพื่อใช้ในยามศึกสงคราม\r\n3) รวบรวมคนหรือสิ่งของจำนวนมากเพื่อจุดประสงค์หนึ่ง",
            "word_usage": "คำนาม + が + ​動員 + される\r\nคำนาม + に + ​動員 + する\r\nคำนาม + を + ​動員 + する",
            "word_ex": "動員されて戦地に赴く。\r\n戦時中、学徒を生産労働に動員する。\r\n観客を動員する。"
        },
        {
            "id": "652",
            "kanji": "勤務",
            "n_read": "きんむ",
            "kango_easy": "務める",
            "e_read": "つとめる",
            "word_meaning": "ทำงาน โดยประจำอยู่ที่บริษัทหรือหน่วยงานรัฐ",
            "word_usage": "คำนาม + に + 勤務 + する",
            "word_ex": "市役所に勤務する。"
        },
        {
            "id": "653",
            "kanji": "廃止",
            "n_read": "はいし",
            "kango_easy": "",
            "e_read": "やめる",
            "word_meaning": "ยกเลิก ไม่ดำเนินการต่อ เช่น ยกเลิกภาษีศุลกากร",
            "word_usage": "คำนาม + を + ​廃止 + する",
            "word_ex": "関税を廃止する。"
        },
        {
            "id": "654",
            "kanji": "是正",
            "n_read": "ぜせい",
            "kango_easy": "正しくする",
            "e_read": "なおす",
            "word_meaning": "แก้ไขจุดที่ผิด ไม่ดี หรือไม่เหมาะสมให้ถูกต้อง เช่น แก้ไขความเหลื่อมล้ำ",
            "word_usage": "คำนาม + を + ​是正 + する",
            "word_ex": "格差を是正する。"
        },
        {
            "id": "655",
            "kanji": "是正",
            "n_read": "ぜせい",
            "kango_easy": "直す",
            "e_read": "なおす",
            "word_meaning": "แก้ไขจุดที่ผิด ไม่ดี หรือไม่เหมาะสมให้ถูกต้อง เช่น แก้ไขความเหลื่อมล้ำ",
            "word_usage": "คำนาม + を + ​是正 + する",
            "word_ex": "格差を是正する。"
        },
        {
            "id": "656",
            "kanji": "欠席",
            "n_read": "けっせき",
            "kango_easy": "出ない",
            "e_read": "でない",
            "word_meaning": "ไม่ได้เข้าร่วมงาน หรือขาดเรียน เช่น ไม่ได้ไปงานเลี้ยงรุ่น ขาดประชุมเพราะมีธุระด่วน",
            "word_usage": "คำนาม + に + ​欠席 + する\r\nคำนาม + を + ​出席 + する",
            "word_ex": "同窓会に欠席する。\r\n用事で会議を欠席する。\r\n授業を欠席する。"
        },
        {
            "id": "657",
            "kanji": "発着",
            "n_read": "はっちゃく",
            "kango_easy": "出る",
            "e_read": "でる",
            "word_meaning": "ออกเดินทางและถึงที่หมาย เช่น ทุก ๆ 3 นาที รถไฟจะจอดและออกไป",
            "word_usage": "คำนาม + が + ​発着 + する",
            "word_ex": "三分ごとに電車が発着する。"
        },
        {
            "id": "658",
            "kanji": "発着",
            "n_read": "はっちゃく",
            "kango_easy": "着く",
            "e_read": "つく",
            "word_meaning": "ออกเดินทางและถึงที่หมาย เช่น ทุก ๆ 3 นาที รถไฟจะจอดและออกไป",
            "word_usage": "คำนาม + が + ​発着 + する",
            "word_ex": "三分ごとに電車が発着する。"
        },
        {
            "id": "659",
            "kanji": "限定",
            "n_read": "げんてい",
            "kango_easy": "限る",
            "e_read": "かぎる",
            "word_meaning": "1) จำกัดขอบเขตหรือปริมาณของสิ่งของ ไม่ยอมรับสิ่งที่เกินขอบเขตนั้น เช่น กำหนดคุณสมบัติของผู้สมัครให้มีอายุต่ำกว่า 20 ปี\r\n2) กำหนดคุณสมบัติหรือขอบเขตของแนวคิดให้ชัดเจน (จำกัดความ)",
            "word_usage": "คำนาม + を + ​限定 + する",
            "word_ex": "応募資格を二〇歳以下に限定する。"
        },
        {
            "id": "660",
            "kanji": "一転",
            "n_read": "いってん",
            "kango_easy": "変わる",
            "e_read": "かわる",
            "word_meaning": "1) หมุนไปรอบ ๆ, พลิกกลับด้าน, วนรอบ\r\n2) แตกต่างไปจากสิ่งเดิม หรือเปลี่ยนไปโดยสิ้นเชิง เช่น ราคาตลาดเปลี่ยน",
            "word_usage": "คำนาม + が + ​一転 + する",
            "word_ex": "氷上で滑って一転した。\r\n相場が一転する。"
        },
        {
            "id": "661",
            "kanji": "経営",
            "n_read": "けいえい",
            "kango_easy": "",
            "e_read": "やる",
            "word_meaning": "ดำเนินการบริหารหรือจัดการธุรกิจตามที่กำหนดไว้อย่างต่อเนื่องและมีแบบแผน เพื่อให้บรรลุวัตถุประสงค์ขององค์กร เช่น บริหารบริษัท, จัดการอาณานิคม",
            "word_usage": "คำนาม + を + ​経営 + する",
            "word_ex": "会社を経営する。"
        },
        {
            "id": "662",
            "kanji": "経営",
            "n_read": "けいえい",
            "kango_easy": "営む",
            "e_read": "いとなむ",
            "word_meaning": "ดำเนินการบริหารหรือจัดการธุรกิจตามที่กำหนดไว้อย่างต่อเนื่องและมีแบบแผน เพื่อให้บรรลุวัตถุประสงค์ขององค์กร เช่น บริหารบริษัท, จัดการอาณานิคม",
            "word_usage": "คำนาม + を + ​経営 + する",
            "word_ex": "会社を経営する。"
        },
        {
            "id": "663",
            "kanji": "台頭",
            "n_read": "たいとう",
            "kango_easy": "上げる",
            "e_read": "あげる",
            "word_meaning": "เงยศีรษะขึ้น, กำลังหรืออำนาจของสิ่ง ๆ หนึ่งมากขึ้น เช่น นักปฏิรูปลุกฮือขึ้นมา",
            "word_usage": "คำนาม + が + ​台頭 + する",
            "word_ex": "改革派が台頭する。"
        },
        {
            "id": "664",
            "kanji": "台頭",
            "n_read": "たいとう",
            "kango_easy": "増える",
            "e_read": "ふえる",
            "word_meaning": "เงยศีรษะขึ้น, กำลังหรืออำนาจของสิ่ง ๆ หนึ่งมากขึ้น เช่น นักปฏิรูปลุกฮือขึ้นมา",
            "word_usage": "คำนาม + が + ​台頭 + する",
            "word_ex": "改革派が台頭する。"
        },
        {
            "id": "665",
            "kanji": "脱線",
            "n_read": "だっせん",
            "kango_easy": "外れる",
            "e_read": "はずれる",
            "word_meaning": "1) ล้อของรถไฟตกจากรางรถไฟ\r\n2) บทสนทนาหลุดประเด็น การกระทำหลุดจากจุดประสงค์",
            "word_usage": "คำนาม + が + ​脱線 + する",
            "word_ex": "電車が脱線する。\r\n講義の途中ですぐに脱線する。"
        },
        {
            "id": "666",
            "kanji": "解明",
            "n_read": "かいめい",
            "kango_easy": "",
            "e_read": "はっきりさせる",
            "word_meaning": "ทำให้กระจ่าง ชี้แจง แจกแจง เช่น ชี้แจงความจริงในคดี",
            "word_usage": "คำนาม + を + ​解明 + する",
            "word_ex": "事件の真相を解明する。"
        },
        {
            "id": "667",
            "kanji": "退任",
            "n_read": "たいにん",
            "kango_easy": "辞める",
            "e_read": "やめる",
            "word_meaning": "ลาออกจากหน้าที่หรืออาชีพ เช่น ลาออกจากตำแหน่งประธาน, ลาออกจากวาระการดำรงตำแหน่งกลางคัน",
            "word_usage": "คำนาม + を + ​退任 + する",
            "word_ex": "任期途中で退任する。"
        },
        {
            "id": "668",
            "kanji": "充実",
            "n_read": "じゅうじつ",
            "kango_easy": "備わる",
            "e_read": "そなわる",
            "word_meaning": "สิ่งที่จำเป็นถูกเตรียมไว้อย่างเพียงพอ, เต็มไปด้วยแก่นสาร เช่น ปรับปรุงอุปกรณ์ให้พร้อม, ปรับปรุงเนื้อหาให้สมบูรณ์",
            "word_usage": "คำนาม + を + ​充実 + する\r\nคำนาม + を + ​充実 + させる",
            "word_ex": "内容を充実する。\r\n設備を充実させる。"
        },
        {
            "id": "669",
            "kanji": "防止",
            "n_read": "ぼうし",
            "kango_easy": "防ぐ",
            "e_read": "ふせぐ",
            "word_meaning": "ป้องกัน ยับยั้ง เช่น ป้องกันอุบัติเหตุ, ป้องกันการทำผิดกฎหมายในเด็ก",
            "word_usage": "คำนาม + を + ​防止 + する",
            "word_ex": "少年の非行を防止する。"
        },
        {
            "id": "670",
            "kanji": "媒介",
            "n_read": "ばいかい",
            "kango_easy": "仲立ち",
            "e_read": "なかだち",
            "word_meaning": "ตัวกลาง (พ่อค้าคนกลาง),\r\nพาหะ (นำโรค)",
            "word_usage": "คำนาม + を + ​媒介 + する",
            "word_ex": "虫が伝染病を媒介する。"
        }
    ]
}
export default data.list;